  
(function(e,t){var n,r,i=typeof t,o=e.document,a=e.location,s=e.jQuery,u=e.$,l={},c=[],p="1.9.66",f=c.concat,d=c.push,h=c.slice,g=c.indexOf,m=l.toString,y=l.hasOwnProperty,v=p.trim,b=function(e,t){return new b.fn.init(e,t,r)},x=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,w=/\S+/g,T=/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,N=/^(?:(<[\w\W]+>)[^>]*|#([\w-]*))$/,C=/^<(\w+)\s*\/?>(?:<\/\1>|)$/,k=/^[\],:{}\s]*$/,E=/(?:^|:|,)(?:\s*\[)+/g,S=/\\(?:["\\\/bfnrt]|u[\da-fA-F]{4})/g,A=/"[^"\\\r\n]*"|true|false|null|-?(?:\d+\.|)\d+(?:[eE][+-]?\d+|)/g,j=/^-ms-/,D=/-([\da-z])/gi,L=function(e,t){return t.toUpperCase()},H=function(e){(o.addEventListener||"load"===e.type||"complete"===o.readyState)&&(q(),b.ready())},q=function(){o.addEventListener?(o.removeEventListener("DOMContentLoaded",H,!1),e.removeEventListener("load",H,!1)):(o.detachEvent("onreadystatechange",H),e.detachEvent("onload",H))};b.fn=b.prototype={jquery:p,constructor:b,init:function(e,n,r){var i,a;if(!e)return this;if("string"==typeof e){if(i="<"===e.charAt(0)&&">"===e.charAt(e.length-1)&&e.length>=3?[null,e,null]:N.exec(e),!i||!i[1]&&n)return!n||n.jquery?(n||r).find(e):this.constructor(n).find(e);if(i[1]){if(n=n instanceof b?n[0]:n,b.merge(this,b.parseHTML(i[1],n&&n.nodeType?n.ownerDocument||n:o,!0)),C.test(i[1])&&b.isPlainObject(n))for(i in n)b.isFunction(this[i])?this[i](n[i]):this.attr(i,n[i]);return this}if(a=o.getElementById(i[2]),a&&a.parentNode){if(a.id!==i[2])return r.find(e);this.length=1,this[0]=a}return this.context=o,this.selector=e,this}return e.nodeType?(this.context=this[0]=e,this.length=1,this):b.isFunction(e)?r.ready(e):(e.selector!==t&&(this.selector=e.selector,this.context=e.context),b.makeArray(e,this))},selector:"",length:0,size:function(){return this.length},toArray:function(){return h.call(this)},get:function(e){return null==e?this.toArray():0>e?this[this.length+e]:this[e]},pushStack:function(e){var t=b.merge(this.constructor(),e);return t.prevObject=this,t.context=this.context,t},each:function(e,t){return b.each(this,e,t)},ready:function(e){return b.ready.promise().done(e),this},slice:function(){return this.pushStack(h.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},eq:function(e){var t=this.length,n=+e+(0>e?t:0);return this.pushStack(n>=0&&t>n?[this[n]]:[])},map:function(e){return this.pushStack(b.map(this,function(t,n){return e.call(t,n,t)}))},end:function(){return this.prevObject||this.constructor(null)},push:d,sort:[].sort,splice:[].splice},b.fn.init.prototype=b.fn,b.extend=b.fn.extend=function(){var e,n,r,i,o,a,s=arguments[0]||{},u=1,l=arguments.length,c=!1;for("boolean"==typeof s&&(c=s,s=arguments[1]||{},u=2),"object"==typeof s||b.isFunction(s)||(s={}),l===u&&(s=this,--u);l>u;u++)if(null!=(o=arguments[u]))for(i in o)e=s[i],r=o[i],s!==r&&(c&&r&&(b.isPlainObject(r)||(n=b.isArray(r)))?(n?(n=!1,a=e&&b.isArray(e)?e:[]):a=e&&b.isPlainObject(e)?e:{},s[i]=b.extend(c,a,r)):r!==t&&(s[i]=r));return s},b.extend({noConflict:function(t){return e.$===b&&(e.$=u),t&&e.jQuery===b&&(e.jQuery=s),b},isReady:!1,readyWait:1,holdReady:function(e){e?b.readyWait++:b.ready(!0)},ready:function(e){if(e===!0?!--b.readyWait:!b.isReady){if(!o.body)return setTimeout(b.ready);b.isReady=!0,e!==!0&&--b.readyWait>0||(n.resolveWith(o,[b]),b.fn.trigger&&b(o).trigger("ready").off("ready"))}},isFunction:function(e){return"function"===b.type(e)},isArray:Array.isArray||function(e){return"array"===b.type(e)},isWindow:function(e){return null!=e&&e==e.window},isNumeric:function(e){return!isNaN(parseFloat(e))&&isFinite(e)},type:function(e){return null==e?e+"":"object"==typeof e||"function"==typeof e?l[m.call(e)]||"object":typeof e},isPlainObject:function(e){if(!e||"object"!==b.type(e)||e.nodeType||b.isWindow(e))return!1;try{if(e.constructor&&!y.call(e,"constructor")&&!y.call(e.constructor.prototype,"isPrototypeOf"))return!1}catch(n){return!1}var r;for(r in e);return r===t||y.call(e,r)},isEmptyObject:function(e){var t;for(t in e)return!1;return!0},error:function(e){throw Error(e)},parseHTML:function(e,t,n){if(!e||"string"!=typeof e)return null;"boolean"==typeof t&&(n=t,t=!1),t=t||o;var r=C.exec(e),i=!n&&[];return r?[t.createElement(r[1])]:(r=b.buildFragment([e],t,i),i&&b(i).remove(),b.merge([],r.childNodes))},parseJSON:function(n){return e.JSON&&e.JSON.parse?e.JSON.parse(n):null===n?n:"string"==typeof n&&(n=b.trim(n),n&&k.test(n.replace(S,"@").replace(A,"]").replace(E,"")))?Function("return "+n)():(b.error("Invalid JSON: "+n),t)},parseXML:function(n){var r,i;if(!n||"string"!=typeof n)return null;try{e.DOMParser?(i=new DOMParser,r=i.parseFromString(n,"text/xml")):(r=new ActiveXObject("Microsoft.XMLDOM"),r.async="false",r.loadXML(n))}catch(o){r=t}return r&&r.documentElement&&!r.getElementsByTagName("parsererror").length||b.error("Invalid XML: "+n),r},noop:function(){},globalEval:function(t){t&&b.trim(t)&&(e.execScript||function(t){e.eval.call(e,t)})(t)},camelCase:function(e){return e.replace(j,"ms-").replace(D,L)},nodeName:function(e,t){return e.nodeName&&e.nodeName.toLowerCase()===t.toLowerCase()},each:function(e,t,n){var r,i=0,o=e.length,a=M(e);if(n){if(a){for(;o>i;i++)if(r=t.apply(e[i],n),r===!1)break}else for(i in e)if(r=t.apply(e[i],n),r===!1)break}else if(a){for(;o>i;i++)if(r=t.call(e[i],i,e[i]),r===!1)break}else for(i in e)if(r=t.call(e[i],i,e[i]),r===!1)break;return e},trim:v&&!v.call("\ufeff\u00a0")?function(e){return null==e?"":v.call(e)}:function(e){return null==e?"":(e+"").replace(T,"")},makeArray:function(e,t){var n=t||[];return null!=e&&(M(Object(e))?b.merge(n,"string"==typeof e?[e]:e):d.call(n,e)),n},inArray:function(e,t,n){var r;if(t){if(g)return g.call(t,e,n);for(r=t.length,n=n?0>n?Math.max(0,r+n):n:0;r>n;n++)if(n in t&&t[n]===e)return n}return-1},merge:function(e,n){var r=n.length,i=e.length,o=0;if("number"==typeof r)for(;r>o;o++)e[i++]=n[o];else while(n[o]!==t)e[i++]=n[o++];return e.length=i,e},grep:function(e,t,n){var r,i=[],o=0,a=e.length;for(n=!!n;a>o;o++)r=!!t(e[o],o),n!==r&&i.push(e[o]);return i},map:function(e,t,n){var r,i=0,o=e.length,a=M(e),s=[];if(a)for(;o>i;i++)r=t(e[i],i,n),null!=r&&(s[s.length]=r);else for(i in e)r=t(e[i],i,n),null!=r&&(s[s.length]=r);return f.apply([],s)},guid:1,proxy:function(e,n){var r,i,o;return"string"==typeof n&&(o=e[n],n=e,e=o),b.isFunction(e)?(r=h.call(arguments,2),i=function(){return e.apply(n||this,r.concat(h.call(arguments)))},i.guid=e.guid=e.guid||b.guid++,i):t},access:function(e,n,r,i,o,a,s){var u=0,l=e.length,c=null==r;if("object"===b.type(r)){o=!0;for(u in r)b.access(e,n,u,r[u],!0,a,s)}else if(i!==t&&(o=!0,b.isFunction(i)||(s=!0),c&&(s?(n.call(e,i),n=null):(c=n,n=function(e,t,n){return c.call(b(e),n)})),n))for(;l>u;u++)n(e[u],r,s?i:i.call(e[u],u,n(e[u],r)));return o?e:c?n.call(e):l?n(e[0],r):a},now:function(){return(new Date).getTime()}}),b.ready.promise=function(t){if(!n)if(n=b.Deferred(),"complete"===o.readyState)setTimeout(b.ready);else if(o.addEventListener)o.addEventListener("DOMContentLoaded",H,!1),e.addEventListener("load",H,!1);else{o.attachEvent("onreadystatechange",H),e.attachEvent("onload",H);var r=!1;try{r=null==e.frameElement&&o.documentElement}catch(i){}r&&r.doScroll&&function a(){if(!b.isReady){try{r.doScroll("left")}catch(e){return setTimeout(a,50)}q(),b.ready()}}()}return n.promise(t)},b.each("Boolean Number String Function Array Date RegExp Object Error".split(" "),function(e,t){l["[object "+t+"]"]=t.toLowerCase()});function M(e){var t=e.length,n=b.type(e);return b.isWindow(e)?!1:1===e.nodeType&&t?!0:"array"===n||"function"!==n&&(0===t||"number"==typeof t&&t>0&&t-1 in e)}r=b(o);var _={};function F(e){var t=_[e]={};return b.each(e.match(w)||[],function(e,n){t[n]=!0}),t}b.Callbacks=function(e){e="string"==typeof e?_[e]||F(e):b.extend({},e);var n,r,i,o,a,s,u=[],l=!e.once&&[],c=function(t){for(r=e.memory&&t,i=!0,a=s||0,s=0,o=u.length,n=!0;u&&o>a;a++)if(u[a].apply(t[0],t[1])===!1&&e.stopOnFalse){r=!1;break}n=!1,u&&(l?l.length&&c(l.shift()):r?u=[]:p.disable())},p={add:function(){if(u){var t=u.length;(function i(t){b.each(t,function(t,n){var r=b.type(n);"function"===r?e.unique&&p.has(n)||u.push(n):n&&n.length&&"string"!==r&&i(n)})})(arguments),n?o=u.length:r&&(s=t,c(r))}return this},remove:function(){return u&&b.each(arguments,function(e,t){var r;while((r=b.inArray(t,u,r))>-1)u.splice(r,1),n&&(o>=r&&o--,a>=r&&a--)}),this},has:function(e){return e?b.inArray(e,u)>-1:!(!u||!u.length)},empty:function(){return u=[],this},disable:function(){return u=l=r=t,this},disabled:function(){return!u},lock:function(){return l=t,r||p.disable(),this},locked:function(){return!l},fireWith:function(e,t){return t=t||[],t=[e,t.slice?t.slice():t],!u||i&&!l||(n?l.push(t):c(t)),this},fire:function(){return p.fireWith(this,arguments),this},fired:function(){return!!i}};return p},b.extend({Deferred:function(e){var t=[["resolve","done",b.Callbacks("once memory"),"resolved"],["reject","fail",b.Callbacks("once memory"),"rejected"],["notify","progress",b.Callbacks("memory")]],n="pending",r={state:function(){return n},always:function(){return i.done(arguments).fail(arguments),this},then:function(){var e=arguments;return b.Deferred(function(n){b.each(t,function(t,o){var a=o[0],s=b.isFunction(e[t])&&e[t];i[o[1]](function(){var e=s&&s.apply(this,arguments);e&&b.isFunction(e.promise)?e.promise().done(n.resolve).fail(n.reject).progress(n.notify):n[a+"With"](this===r?n.promise():this,s?[e]:arguments)})}),e=null}).promise()},promise:function(e){return null!=e?b.extend(e,r):r}},i={};return r.pipe=r.then,b.each(t,function(e,o){var a=o[2],s=o[3];r[o[1]]=a.add,s&&a.add(function(){n=s},t[1^e][2].disable,t[2][2].lock),i[o[0]]=function(){return i[o[0]+"With"](this===i?r:this,arguments),this},i[o[0]+"With"]=a.fireWith}),r.promise(i),e&&e.call(i,i),i},when:function(e){var t=0,n=h.call(arguments),r=n.length,i=1!==r||e&&b.isFunction(e.promise)?r:0,o=1===i?e:b.Deferred(),a=function(e,t,n){return function(r){t[e]=this,n[e]=arguments.length>1?h.call(arguments):r,n===s?o.notifyWith(t,n):--i||o.resolveWith(t,n)}},s,u,l;if(r>1)for(s=Array(r),u=Array(r),l=Array(r);r>t;t++)n[t]&&b.isFunction(n[t].promise)?n[t].promise().done(a(t,l,n)).fail(o.reject).progress(a(t,u,s)):--i;return i||o.resolveWith(l,n),o.promise()}}),b.support=function(){var t,n,r,a,s,u,l,c,p,f,d=o.createElement("div");if(d.setAttribute("className","t"),d.innerHTML="  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>",n=d.getElementsByTagName("*"),r=d.getElementsByTagName("a")[0],!n||!r||!n.length)return{};s=o.createElement("select"),l=s.appendChild(o.createElement("option")),a=d.getElementsByTagName("input")[0],r.style.cssText="top:1px;float:left;opacity:.5",t={getSetAttribute:"t"!==d.className,leadingWhitespace:3===d.firstChild.nodeType,tbody:!d.getElementsByTagName("tbody").length,htmlSerialize:!!d.getElementsByTagName("link").length,style:/top/.test(r.getAttribute("style")),hrefNormalized:"/a"===r.getAttribute("href"),opacity:/^0.5/.test(r.style.opacity),cssFloat:!!r.style.cssFloat,checkOn:!!a.value,optSelected:l.selected,enctype:!!o.createElement("form").enctype,html5Clone:"<:nav></:nav>"!==o.createElement("nav").cloneNode(!0).outerHTML,boxModel:"CSS1Compat"===o.compatMode,deleteExpando:!0,noCloneEvent:!0,inlineBlockNeedsLayout:!1,shrinkWrapBlocks:!1,reliableMarginRight:!0,boxSizingReliable:!0,pixelPosition:!1},a.checked=!0,t.noCloneChecked=a.cloneNode(!0).checked,s.disabled=!0,t.optDisabled=!l.disabled;try{delete d.test}catch(h){t.deleteExpando=!1}a=o.createElement("input"),a.setAttribute("value",""),t.input=""===a.getAttribute("value"),a.value="t",a.setAttribute("type","radio"),t.radioValue="t"===a.value,a.setAttribute("checked","t"),a.setAttribute("name","t"),u=o.createDocumentFragment(),u.appendChild(a),t.appendChecked=a.checked,t.checkClone=u.cloneNode(!0).cloneNode(!0).lastChild.checked,d.attachEvent&&(d.attachEvent("onclick",function(){t.noCloneEvent=!1}),d.cloneNode(!0).click());for(f in{submit:!0,change:!0,focusin:!0})d.setAttribute(c="on"+f,"t"),t[f+"Bubbles"]=c in e||d.attributes[c].expando===!1;return d.style.backgroundClip="content-box",d.cloneNode(!0).style.backgroundClip="",t.clearCloneStyle="content-box"===d.style.backgroundClip,b(function(){var n,r,a,s="padding:0;margin:0;border:0;display:block;box-sizing:content-box;-moz-box-sizing:content-box;-webkit-box-sizing:content-box;",u=o.getElementsByTagName("body")[0];u&&(n=o.createElement("div"),n.style.cssText="border:0;width:0;height:0;position:absolute;top:0;left:-9999px;margin-top:1px",u.appendChild(n).appendChild(d),d.innerHTML="<table><tr><td></td><td>t</td></tr></table>",a=d.getElementsByTagName("td"),a[0].style.cssText="padding:0;margin:0;border:0;display:none",p=0===a[0].offsetHeight,a[0].style.display="",a[1].style.display="none",t.reliableHiddenOffsets=p&&0===a[0].offsetHeight,d.innerHTML="",d.style.cssText="box-sizing:border-box;-moz-box-sizing:border-box;-webkit-box-sizing:border-box;padding:1px;border:1px;display:block;width:4px;margin-top:1%;position:absolute;top:1%;",t.boxSizing=4===d.offsetWidth,t.doesNotIncludeMarginInBodyOffset=1!==u.offsetTop,e.getComputedStyle&&(t.pixelPosition="1%"!==(e.getComputedStyle(d,null)||{}).top,t.boxSizingReliable="4px"===(e.getComputedStyle(d,null)||{width:"4px"}).width,r=d.appendChild(o.createElement("div")),r.style.cssText=d.style.cssText=s,r.style.marginRight=r.style.width="0",d.style.width="1px",t.reliableMarginRight=!parseFloat((e.getComputedStyle(r,null)||{}).marginRight)),typeof d.style.zoom!==i&&(d.innerHTML="",d.style.cssText=s+"width:1px;padding:1px;display:inline;zoom:1",t.inlineBlockNeedsLayout=3===d.offsetWidth,d.style.display="block",d.innerHTML="<div></div>",d.firstChild.style.width="5px",t.shrinkWrapBlocks=3!==d.offsetWidth,t.inlineBlockNeedsLayout&&(u.style.zoom=1)),u.removeChild(n),n=d=a=r=null)}),n=s=u=l=r=a=null,t}();var O=/(?:\{[\s\S]*\}|\[[\s\S]*\])$/,B=/([A-Z])/g;function P(e,n,r,i){if(b.acceptData(e)){var o,a,s=b.expando,u="string"==typeof n,l=e.nodeType,p=l?b.cache:e,f=l?e[s]:e[s]&&s;if(f&&p[f]&&(i||p[f].data)||!u||r!==t)return f||(l?e[s]=f=c.pop()||b.guid++:f=s),p[f]||(p[f]={},l||(p[f].toJSON=b.noop)),("object"==typeof n||"function"==typeof n)&&(i?p[f]=b.extend(p[f],n):p[f].data=b.extend(p[f].data,n)),o=p[f],i||(o.data||(o.data={}),o=o.data),r!==t&&(o[b.camelCase(n)]=r),u?(a=o[n],null==a&&(a=o[b.camelCase(n)])):a=o,a}}function R(e,t,n){if(b.acceptData(e)){var r,i,o,a=e.nodeType,s=a?b.cache:e,u=a?e[b.expando]:b.expando;if(s[u]){if(t&&(o=n?s[u]:s[u].data)){b.isArray(t)?t=t.concat(b.map(t,b.camelCase)):t in o?t=[t]:(t=b.camelCase(t),t=t in o?[t]:t.split(" "));for(r=0,i=t.length;i>r;r++)delete o[t[r]];if(!(n?$:b.isEmptyObject)(o))return}(n||(delete s[u].data,$(s[u])))&&(a?b.cleanData([e],!0):b.support.deleteExpando||s!=s.window?delete s[u]:s[u]=null)}}}b.extend({cache:{},expando:"jQuery"+(p+Math.random()).replace(/\D/g,""),noData:{embed:!0,object:"clsid:D27CDB6E-AE6D-11cf-96B8-444553540000",applet:!0},hasData:function(e){return e=e.nodeType?b.cache[e[b.expando]]:e[b.expando],!!e&&!$(e)},data:function(e,t,n){return P(e,t,n)},removeData:function(e,t){return R(e,t)},_data:function(e,t,n){return P(e,t,n,!0)},_removeData:function(e,t){return R(e,t,!0)},acceptData:function(e){if(e.nodeType&&1!==e.nodeType&&9!==e.nodeType)return!1;var t=e.nodeName&&b.noData[e.nodeName.toLowerCase()];return!t||t!==!0&&e.getAttribute("classid")===t}}),b.fn.extend({data:function(e,n){var r,i,o=this[0],a=0,s=null;if(e===t){if(this.length&&(s=b.data(o),1===o.nodeType&&!b._data(o,"parsedAttrs"))){for(r=o.attributes;r.length>a;a++)i=r[a].name,i.indexOf("data-")||(i=b.camelCase(i.slice(5)),W(o,i,s[i]));b._data(o,"parsedAttrs",!0)}return s}return"object"==typeof e?this.each(function(){b.data(this,e)}):b.access(this,function(n){return n===t?o?W(o,e,b.data(o,e)):null:(this.each(function(){b.data(this,e,n)}),t)},null,n,arguments.length>1,null,!0)},removeData:function(e){return this.each(function(){b.removeData(this,e)})}});function W(e,n,r){if(r===t&&1===e.nodeType){var i="data-"+n.replace(B,"-$1").toLowerCase();if(r=e.getAttribute(i),"string"==typeof r){try{r="true"===r?!0:"false"===r?!1:"null"===r?null:+r+""===r?+r:O.test(r)?b.parseJSON(r):r}catch(o){}b.data(e,n,r)}else r=t}return r}function $(e){var t;for(t in e)if(("data"!==t||!b.isEmptyObject(e[t]))&&"toJSON"!==t)return!1;return!0}b.extend({queue:function(e,n,r){var i;return e?(n=(n||"fx")+"queue",i=b._data(e,n),r&&(!i||b.isArray(r)?i=b._data(e,n,b.makeArray(r)):i.push(r)),i||[]):t},dequeue:function(e,t){t=t||"fx";var n=b.queue(e,t),r=n.length,i=n.shift(),o=b._queueHooks(e,t),a=function(){b.dequeue(e,t)};"inprogress"===i&&(i=n.shift(),r--),o.cur=i,i&&("fx"===t&&n.unshift("inprogress"),delete o.stop,i.call(e,a,o)),!r&&o&&o.empty.fire()},_queueHooks:function(e,t){var n=t+"queueHooks";return b._data(e,n)||b._data(e,n,{empty:b.Callbacks("once memory").add(function(){b._removeData(e,t+"queue"),b._removeData(e,n)})})}}),b.fn.extend({queue:function(e,n){var r=2;return"string"!=typeof e&&(n=e,e="fx",r--),r>arguments.length?b.queue(this[0],e):n===t?this:this.each(function(){var t=b.queue(this,e,n);b._queueHooks(this,e),"fx"===e&&"inprogress"!==t[0]&&b.dequeue(this,e)})},dequeue:function(e){return this.each(function(){b.dequeue(this,e)})},delay:function(e,t){return e=b.fx?b.fx.speeds[e]||e:e,t=t||"fx",this.queue(t,function(t,n){var r=setTimeout(t,e);n.stop=function(){clearTimeout(r)}})},clearQueue:function(e){return this.queue(e||"fx",[])},promise:function(e,n){var r,i=1,o=b.Deferred(),a=this,s=this.length,u=function(){--i||o.resolveWith(a,[a])};"string"!=typeof e&&(n=e,e=t),e=e||"fx";while(s--)r=b._data(a[s],e+"queueHooks"),r&&r.empty&&(i++,r.empty.add(u));return u(),o.promise(n)}});var I,z,X=/[\t\r\n]/g,U=/\r/g,V=/^(?:input|select|textarea|button|object)$/i,Y=/^(?:a|area)$/i,J=/^(?:checked|selected|autofocus|autoplay|async|controls|defer|disabled|hidden|loop|multiple|open|readonly|required|scoped)$/i,G=/^(?:checked|selected)$/i,Q=b.support.getSetAttribute,K=b.support.input;b.fn.extend({attr:function(e,t){return b.access(this,b.attr,e,t,arguments.length>1)},removeAttr:function(e){return this.each(function(){b.removeAttr(this,e)})},prop:function(e,t){return b.access(this,b.prop,e,t,arguments.length>1)},removeProp:function(e){return e=b.propFix[e]||e,this.each(function(){try{this[e]=t,delete this[e]}catch(n){}})},addClass:function(e){var t,n,r,i,o,a=0,s=this.length,u="string"==typeof e&&e;if(b.isFunction(e))return this.each(function(t){b(this).addClass(e.call(this,t,this.className))});if(u)for(t=(e||"").match(w)||[];s>a;a++)if(n=this[a],r=1===n.nodeType&&(n.className?(" "+n.className+" ").replace(X," "):" ")){o=0;while(i=t[o++])0>r.indexOf(" "+i+" ")&&(r+=i+" ");n.className=b.trim(r)}return this},removeClass:function(e){var t,n,r,i,o,a=0,s=this.length,u=0===arguments.length||"string"==typeof e&&e;if(b.isFunction(e))return this.each(function(t){b(this).removeClass(e.call(this,t,this.className))});if(u)for(t=(e||"").match(w)||[];s>a;a++)if(n=this[a],r=1===n.nodeType&&(n.className?(" "+n.className+" ").replace(X," "):"")){o=0;while(i=t[o++])while(r.indexOf(" "+i+" ")>=0)r=r.replace(" "+i+" "," ");n.className=e?b.trim(r):""}return this},toggleClass:function(e,t){var n=typeof e,r="boolean"==typeof t;return b.isFunction(e)?this.each(function(n){b(this).toggleClass(e.call(this,n,this.className,t),t)}):this.each(function(){if("string"===n){var o,a=0,s=b(this),u=t,l=e.match(w)||[];while(o=l[a++])u=r?u:!s.hasClass(o),s[u?"addClass":"removeClass"](o)}else(n===i||"boolean"===n)&&(this.className&&b._data(this,"__className__",this.className),this.className=this.className||e===!1?"":b._data(this,"__className__")||"")})},hasClass:function(e){var t=" "+e+" ",n=0,r=this.length;for(;r>n;n++)if(1===this[n].nodeType&&(" "+this[n].className+" ").replace(X," ").indexOf(t)>=0)return!0;return!1},val:function(e){var n,r,i,o=this[0];{if(arguments.length)return i=b.isFunction(e),this.each(function(n){var o,a=b(this);1===this.nodeType&&(o=i?e.call(this,n,a.val()):e,null==o?o="":"number"==typeof o?o+="":b.isArray(o)&&(o=b.map(o,function(e){return null==e?"":e+""})),r=b.valHooks[this.type]||b.valHooks[this.nodeName.toLowerCase()],r&&"set"in r&&r.set(this,o,"value")!==t||(this.value=o))});if(o)return r=b.valHooks[o.type]||b.valHooks[o.nodeName.toLowerCase()],r&&"get"in r&&(n=r.get(o,"value"))!==t?n:(n=o.value,"string"==typeof n?n.replace(U,""):null==n?"":n)}}}),b.extend({valHooks:{option:{get:function(e){var t=e.attributes.value;return!t||t.specified?e.value:e.text}},select:{get:function(e){var t,n,r=e.options,i=e.selectedIndex,o="select-one"===e.type||0>i,a=o?null:[],s=o?i+1:r.length,u=0>i?s:o?i:0;for(;s>u;u++)if(n=r[u],!(!n.selected&&u!==i||(b.support.optDisabled?n.disabled:null!==n.getAttribute("disabled"))||n.parentNode.disabled&&b.nodeName(n.parentNode,"optgroup"))){if(t=b(n).val(),o)return t;a.push(t)}return a},set:function(e,t){var n=b.makeArray(t);return b(e).find("option").each(function(){this.selected=b.inArray(b(this).val(),n)>=0}),n.length||(e.selectedIndex=-1),n}}},attr:function(e,n,r){var o,a,s,u=e.nodeType;if(e&&3!==u&&8!==u&&2!==u)return typeof e.getAttribute===i?b.prop(e,n,r):(a=1!==u||!b.isXMLDoc(e),a&&(n=n.toLowerCase(),o=b.attrHooks[n]||(J.test(n)?z:I)),r===t?o&&a&&"get"in o&&null!==(s=o.get(e,n))?s:(typeof e.getAttribute!==i&&(s=e.getAttribute(n)),null==s?t:s):null!==r?o&&a&&"set"in o&&(s=o.set(e,r,n))!==t?s:(e.setAttribute(n,r+""),r):(b.removeAttr(e,n),t))},removeAttr:function(e,t){var n,r,i=0,o=t&&t.match(w);if(o&&1===e.nodeType)while(n=o[i++])r=b.propFix[n]||n,J.test(n)?!Q&&G.test(n)?e[b.camelCase("default-"+n)]=e[r]=!1:e[r]=!1:b.attr(e,n,""),e.removeAttribute(Q?n:r)},attrHooks:{type:{set:function(e,t){if(!b.support.radioValue&&"radio"===t&&b.nodeName(e,"input")){var n=e.value;return e.setAttribute("type",t),n&&(e.value=n),t}}}},propFix:{tabindex:"tabIndex",readonly:"readOnly","for":"htmlFor","class":"className",maxlength:"maxLength",cellspacing:"cellSpacing",cellpadding:"cellPadding",rowspan:"rowSpan",colspan:"colSpan",usemap:"useMap",frameborder:"frameBorder",contenteditable:"contentEditable"},prop:function(e,n,r){var i,o,a,s=e.nodeType;if(e&&3!==s&&8!==s&&2!==s)return a=1!==s||!b.isXMLDoc(e),a&&(n=b.propFix[n]||n,o=b.propHooks[n]),r!==t?o&&"set"in o&&(i=o.set(e,r,n))!==t?i:e[n]=r:o&&"get"in o&&null!==(i=o.get(e,n))?i:e[n]},propHooks:{tabIndex:{get:function(e){var n=e.getAttributeNode("tabindex");return n&&n.specified?parseInt(n.value,10):V.test(e.nodeName)||Y.test(e.nodeName)&&e.href?0:t}}}}),z={get:function(e,n){var r=b.prop(e,n),i="boolean"==typeof r&&e.getAttribute(n),o="boolean"==typeof r?K&&Q?null!=i:G.test(n)?e[b.camelCase("default-"+n)]:!!i:e.getAttributeNode(n);return o&&o.value!==!1?n.toLowerCase():t},set:function(e,t,n){return t===!1?b.removeAttr(e,n):K&&Q||!G.test(n)?e.setAttribute(!Q&&b.propFix[n]||n,n):e[b.camelCase("default-"+n)]=e[n]=!0,n}},K&&Q||(b.attrHooks.value={get:function(e,n){var r=e.getAttributeNode(n);return b.nodeName(e,"input")?e.defaultValue:r&&r.specified?r.value:t},set:function(e,n,r){return b.nodeName(e,"input")?(e.defaultValue=n,t):I&&I.set(e,n,r)}}),Q||(I=b.valHooks.button={get:function(e,n){var r=e.getAttributeNode(n);return r&&("id"===n||"name"===n||"coords"===n?""!==r.value:r.specified)?r.value:t},set:function(e,n,r){var i=e.getAttributeNode(r);return i||e.setAttributeNode(i=e.ownerDocument.createAttribute(r)),i.value=n+="","value"===r||n===e.getAttribute(r)?n:t}},b.attrHooks.contenteditable={get:I.get,set:function(e,t,n){I.set(e,""===t?!1:t,n)}},b.each(["width","height"],function(e,n){b.attrHooks[n]=b.extend(b.attrHooks[n],{set:function(e,r){return""===r?(e.setAttribute(n,"auto"),r):t}})})),b.support.hrefNormalized||(b.each(["href","src","width","height"],function(e,n){b.attrHooks[n]=b.extend(b.attrHooks[n],{get:function(e){var r=e.getAttribute(n,2);return null==r?t:r}})}),b.each(["href","src"],function(e,t){b.propHooks[t]={get:function(e){return e.getAttribute(t,4)}}})),b.support.style||(b.attrHooks.style={get:function(e){return e.style.cssText||t},set:function(e,t){return e.style.cssText=t+""}}),b.support.optSelected||(b.propHooks.selected=b.extend(b.propHooks.selected,{get:function(e){var t=e.parentNode;return t&&(t.selectedIndex,t.parentNode&&t.parentNode.selectedIndex),null}})),b.support.enctype||(b.propFix.enctype="encoding"),b.support.checkOn||b.each(["radio","checkbox"],function(){b.valHooks[this]={get:function(e){return null===e.getAttribute("value")?"on":e.value}}}),b.each(["radio","checkbox"],function(){b.valHooks[this]=b.extend(b.valHooks[this],{set:function(e,n){return b.isArray(n)?e.checked=b.inArray(b(e).val(),n)>=0:t}})});var Z=/^(?:input|select|textarea)$/i,et=/^key/,tt=/^(?:mouse|contextmenu)|click/,nt=/^(?:focusinfocus|focusoutblur)$/,rt=/^([^.]*)(?:\.(.+)|)$/;function it(){return!0}function ot(){return!1}b.event={global:{},add:function(e,n,r,o,a){var s,u,l,c,p,f,d,h,g,m,y,v=b._data(e);if(v){r.handler&&(c=r,r=c.handler,a=c.selector),r.guid||(r.guid=b.guid++),(u=v.events)||(u=v.events={}),(f=v.handle)||(f=v.handle=function(e){return typeof b===i||e&&b.event.triggered===e.type?t:b.event.dispatch.apply(f.elem,arguments)},f.elem=e),n=(n||"").match(w)||[""],l=n.length;while(l--)s=rt.exec(n[l])||[],g=y=s[1],m=(s[2]||"").split(".").sort(),p=b.event.special[g]||{},g=(a?p.delegateType:p.bindType)||g,p=b.event.special[g]||{},d=b.extend({type:g,origType:y,data:o,handler:r,guid:r.guid,selector:a,needsContext:a&&b.expr.match.needsContext.test(a),namespace:m.join(".")},c),(h=u[g])||(h=u[g]=[],h.delegateCount=0,p.setup&&p.setup.call(e,o,m,f)!==!1||(e.addEventListener?e.addEventListener(g,f,!1):e.attachEvent&&e.attachEvent("on"+g,f))),p.add&&(p.add.call(e,d),d.handler.guid||(d.handler.guid=r.guid)),a?h.splice(h.delegateCount++,0,d):h.push(d),b.event.global[g]=!0;e=null}},remove:function(e,t,n,r,i){var o,a,s,u,l,c,p,f,d,h,g,m=b.hasData(e)&&b._data(e);if(m&&(c=m.events)){t=(t||"").match(w)||[""],l=t.length;while(l--)if(s=rt.exec(t[l])||[],d=g=s[1],h=(s[2]||"").split(".").sort(),d){p=b.event.special[d]||{},d=(r?p.delegateType:p.bindType)||d,f=c[d]||[],s=s[2]&&RegExp("(^|\\.)"+h.join("\\.(?:.*\\.|)")+"(\\.|$)"),u=o=f.length;while(o--)a=f[o],!i&&g!==a.origType||n&&n.guid!==a.guid||s&&!s.test(a.namespace)||r&&r!==a.selector&&("**"!==r||!a.selector)||(f.splice(o,1),a.selector&&f.delegateCount--,p.remove&&p.remove.call(e,a));u&&!f.length&&(p.teardown&&p.teardown.call(e,h,m.handle)!==!1||b.removeEvent(e,d,m.handle),delete c[d])}else for(d in c)b.event.remove(e,d+t[l],n,r,!0);b.isEmptyObject(c)&&(delete m.handle,b._removeData(e,"events"))}},trigger:function(n,r,i,a){var s,u,l,c,p,f,d,h=[i||o],g=y.call(n,"type")?n.type:n,m=y.call(n,"namespace")?n.namespace.split("."):[];if(l=f=i=i||o,3!==i.nodeType&&8!==i.nodeType&&!nt.test(g+b.event.triggered)&&(g.indexOf(".")>=0&&(m=g.split("."),g=m.shift(),m.sort()),u=0>g.indexOf(":")&&"on"+g,n=n[b.expando]?n:new b.Event(g,"object"==typeof n&&n),n.isTrigger=!0,n.namespace=m.join("."),n.namespace_re=n.namespace?RegExp("(^|\\.)"+m.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,n.result=t,n.target||(n.target=i),r=null==r?[n]:b.makeArray(r,[n]),p=b.event.special[g]||{},a||!p.trigger||p.trigger.apply(i,r)!==!1)){if(!a&&!p.noBubble&&!b.isWindow(i)){for(c=p.delegateType||g,nt.test(c+g)||(l=l.parentNode);l;l=l.parentNode)h.push(l),f=l;f===(i.ownerDocument||o)&&h.push(f.defaultView||f.parentWindow||e)}d=0;while((l=h[d++])&&!n.isPropagationStopped())n.type=d>1?c:p.bindType||g,s=(b._data(l,"events")||{})[n.type]&&b._data(l,"handle"),s&&s.apply(l,r),s=u&&l[u],s&&b.acceptData(l)&&s.apply&&s.apply(l,r)===!1&&n.preventDefault();if(n.type=g,!(a||n.isDefaultPrevented()||p._default&&p._default.apply(i.ownerDocument,r)!==!1||"click"===g&&b.nodeName(i,"a")||!b.acceptData(i)||!u||!i[g]||b.isWindow(i))){f=i[u],f&&(i[u]=null),b.event.triggered=g;try{i[g]()}catch(v){}b.event.triggered=t,f&&(i[u]=f)}return n.result}},dispatch:function(e){e=b.event.fix(e);var n,r,i,o,a,s=[],u=h.call(arguments),l=(b._data(this,"events")||{})[e.type]||[],c=b.event.special[e.type]||{};if(u[0]=e,e.delegateTarget=this,!c.preDispatch||c.preDispatch.call(this,e)!==!1){s=b.event.handlers.call(this,e,l),n=0;while((o=s[n++])&&!e.isPropagationStopped()){e.currentTarget=o.elem,a=0;while((i=o.handlers[a++])&&!e.isImmediatePropagationStopped())(!e.namespace_re||e.namespace_re.test(i.namespace))&&(e.handleObj=i,e.data=i.data,r=((b.event.special[i.origType]||{}).handle||i.handler).apply(o.elem,u),r!==t&&(e.result=r)===!1&&(e.preventDefault(),e.stopPropagation()))}return c.postDispatch&&c.postDispatch.call(this,e),e.result}},handlers:function(e,n){var r,i,o,a,s=[],u=n.delegateCount,l=e.target;if(u&&l.nodeType&&(!e.button||"click"!==e.type))for(;l!=this;l=l.parentNode||this)if(1===l.nodeType&&(l.disabled!==!0||"click"!==e.type)){for(o=[],a=0;u>a;a++)i=n[a],r=i.selector+" ",o[r]===t&&(o[r]=i.needsContext?b(r,this).index(l)>=0:b.find(r,this,null,[l]).length),o[r]&&o.push(i);o.length&&s.push({elem:l,handlers:o})}return n.length>u&&s.push({elem:this,handlers:n.slice(u)}),s},fix:function(e){if(e[b.expando])return e;var t,n,r,i=e.type,a=e,s=this.fixHooks[i];s||(this.fixHooks[i]=s=tt.test(i)?this.mouseHooks:et.test(i)?this.keyHooks:{}),r=s.props?this.props.concat(s.props):this.props,e=new b.Event(a),t=r.length;while(t--)n=r[t],e[n]=a[n];return e.target||(e.target=a.srcElement||o),3===e.target.nodeType&&(e.target=e.target.parentNode),e.metaKey=!!e.metaKey,s.filter?s.filter(e,a):e},props:"altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),fixHooks:{},keyHooks:{props:"char charCode key keyCode".split(" "),filter:function(e,t){return null==e.which&&(e.which=null!=t.charCode?t.charCode:t.keyCode),e}},mouseHooks:{props:"button buttons clientX clientY fromElement offsetX offsetY pageX pageY screenX screenY toElement".split(" "),filter:function(e,n){var r,i,a,s=n.button,u=n.fromElement;return null==e.pageX&&null!=n.clientX&&(i=e.target.ownerDocument||o,a=i.documentElement,r=i.body,e.pageX=n.clientX+(a&&a.scrollLeft||r&&r.scrollLeft||0)-(a&&a.clientLeft||r&&r.clientLeft||0),e.pageY=n.clientY+(a&&a.scrollTop||r&&r.scrollTop||0)-(a&&a.clientTop||r&&r.clientTop||0)),!e.relatedTarget&&u&&(e.relatedTarget=u===e.target?n.toElement:u),e.which||s===t||(e.which=1&s?1:2&s?3:4&s?2:0),e}},special:{load:{noBubble:!0},click:{trigger:function(){return b.nodeName(this,"input")&&"checkbox"===this.type&&this.click?(this.click(),!1):t}},focus:{trigger:function(){if(this!==o.activeElement&&this.focus)try{return this.focus(),!1}catch(e){}},delegateType:"focusin"},blur:{trigger:function(){return this===o.activeElement&&this.blur?(this.blur(),!1):t},delegateType:"focusout"},beforeunload:{postDispatch:function(e){e.result!==t&&(e.originalEvent.returnValue=e.result)}}},simulate:function(e,t,n,r){var i=b.extend(new b.Event,n,{type:e,isSimulated:!0,originalEvent:{}});r?b.event.trigger(i,null,t):b.event.dispatch.call(t,i),i.isDefaultPrevented()&&n.preventDefault()}},b.removeEvent=o.removeEventListener?function(e,t,n){e.removeEventListener&&e.removeEventListener(t,n,!1)}:function(e,t,n){var r="on"+t;e.detachEvent&&(typeof e[r]===i&&(e[r]=null),e.detachEvent(r,n))},b.Event=function(e,n){return this instanceof b.Event?(e&&e.type?(this.originalEvent=e,this.type=e.type,this.isDefaultPrevented=e.defaultPrevented||e.returnValue===!1||e.getPreventDefault&&e.getPreventDefault()?it:ot):this.type=e,n&&b.extend(this,n),this.timeStamp=e&&e.timeStamp||b.now(),this[b.expando]=!0,t):new b.Event(e,n)},b.Event.prototype={isDefaultPrevented:ot,isPropagationStopped:ot,isImmediatePropagationStopped:ot,preventDefault:function(){var e=this.originalEvent;this.isDefaultPrevented=it,e&&(e.preventDefault?e.preventDefault():e.returnValue=!1)},stopPropagation:function(){var e=this.originalEvent;this.isPropagationStopped=it,e&&(e.stopPropagation&&e.stopPropagation(),e.cancelBubble=!0)},stopImmediatePropagation:function(){this.isImmediatePropagationStopped=it,this.stopPropagation()}},b.each({mouseenter:"mouseover",mouseleave:"mouseout"},function(e,t){b.event.special[e]={delegateType:t,bindType:t,handle:function(e){var n,r=this,i=e.relatedTarget,o=e.handleObj;
return(!i||i!==r&&!b.contains(r,i))&&(e.type=o.origType,n=o.handler.apply(this,arguments),e.type=t),n}}}),b.support.submitBubbles||(b.event.special.submit={setup:function(){return b.nodeName(this,"form")?!1:(b.event.add(this,"click._submit keypress._submit",function(e){var n=e.target,r=b.nodeName(n,"input")||b.nodeName(n,"button")?n.form:t;r&&!b._data(r,"submitBubbles")&&(b.event.add(r,"submit._submit",function(e){e._submit_bubble=!0}),b._data(r,"submitBubbles",!0))}),t)},postDispatch:function(e){e._submit_bubble&&(delete e._submit_bubble,this.parentNode&&!e.isTrigger&&b.event.simulate("submit",this.parentNode,e,!0))},teardown:function(){return b.nodeName(this,"form")?!1:(b.event.remove(this,"._submit"),t)}}),b.support.changeBubbles||(b.event.special.change={setup:function(){return Z.test(this.nodeName)?(("checkbox"===this.type||"radio"===this.type)&&(b.event.add(this,"propertychange._change",function(e){"checked"===e.originalEvent.propertyName&&(this._just_changed=!0)}),b.event.add(this,"click._change",function(e){this._just_changed&&!e.isTrigger&&(this._just_changed=!1),b.event.simulate("change",this,e,!0)})),!1):(b.event.add(this,"beforeactivate._change",function(e){var t=e.target;Z.test(t.nodeName)&&!b._data(t,"changeBubbles")&&(b.event.add(t,"change._change",function(e){!this.parentNode||e.isSimulated||e.isTrigger||b.event.simulate("change",this.parentNode,e,!0)}),b._data(t,"changeBubbles",!0))}),t)},handle:function(e){var n=e.target;return this!==n||e.isSimulated||e.isTrigger||"radio"!==n.type&&"checkbox"!==n.type?e.handleObj.handler.apply(this,arguments):t},teardown:function(){return b.event.remove(this,"._change"),!Z.test(this.nodeName)}}),b.support.focusinBubbles||b.each({focus:"focusin",blur:"focusout"},function(e,t){var n=0,r=function(e){b.event.simulate(t,e.target,b.event.fix(e),!0)};b.event.special[t]={setup:function(){0===n++&&o.addEventListener(e,r,!0)},teardown:function(){0===--n&&o.removeEventListener(e,r,!0)}}}),b.fn.extend({on:function(e,n,r,i,o){var a,s;if("object"==typeof e){"string"!=typeof n&&(r=r||n,n=t);for(a in e)this.on(a,n,r,e[a],o);return this}if(null==r&&null==i?(i=n,r=n=t):null==i&&("string"==typeof n?(i=r,r=t):(i=r,r=n,n=t)),i===!1)i=ot;else if(!i)return this;return 1===o&&(s=i,i=function(e){return b().off(e),s.apply(this,arguments)},i.guid=s.guid||(s.guid=b.guid++)),this.each(function(){b.event.add(this,e,i,r,n)})},one:function(e,t,n,r){return this.on(e,t,n,r,1)},off:function(e,n,r){var i,o;if(e&&e.preventDefault&&e.handleObj)return i=e.handleObj,b(e.delegateTarget).off(i.namespace?i.origType+"."+i.namespace:i.origType,i.selector,i.handler),this;if("object"==typeof e){for(o in e)this.off(o,n,e[o]);return this}return(n===!1||"function"==typeof n)&&(r=n,n=t),r===!1&&(r=ot),this.each(function(){b.event.remove(this,e,r,n)})},bind:function(e,t,n){return this.on(e,null,t,n)},unbind:function(e,t){return this.off(e,null,t)},delegate:function(e,t,n,r){return this.on(t,e,n,r)},undelegate:function(e,t,n){return 1===arguments.length?this.off(e,"**"):this.off(t,e||"**",n)},trigger:function(e,t){return this.each(function(){b.event.trigger(e,t,this)})},triggerHandler:function(e,n){var r=this[0];return r?b.event.trigger(e,n,r,!0):t}}),function(e,t){var n,r,i,o,a,s,u,l,c,p,f,d,h,g,m,y,v,x="sizzle"+-new Date,w=e.document,T={},N=0,C=0,k=it(),E=it(),S=it(),A=typeof t,j=1<<31,D=[],L=D.pop,H=D.push,q=D.slice,M=D.indexOf||function(e){var t=0,n=this.length;for(;n>t;t++)if(this[t]===e)return t;return-1},_="[\\x20\\t\\r\\n\\f]",F="(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",O=F.replace("w","w#"),B="([*^$|!~]?=)",P="\\["+_+"*("+F+")"+_+"*(?:"+B+_+"*(?:(['\"])((?:\\\\.|[^\\\\])*?)\\3|("+O+")|)|)"+_+"*\\]",R=":("+F+")(?:\\(((['\"])((?:\\\\.|[^\\\\])*?)\\3|((?:\\\\.|[^\\\\()[\\]]|"+P.replace(3,8)+")*)|.*)\\)|)",W=RegExp("^"+_+"+|((?:^|[^\\\\])(?:\\\\.)*)"+_+"+$","g"),$=RegExp("^"+_+"*,"+_+"*"),I=RegExp("^"+_+"*([\\x20\\t\\r\\n\\f>+~])"+_+"*"),z=RegExp(R),X=RegExp("^"+O+"$"),U={ID:RegExp("^#("+F+")"),CLASS:RegExp("^\\.("+F+")"),NAME:RegExp("^\\[name=['\"]?("+F+")['\"]?\\]"),TAG:RegExp("^("+F.replace("w","w*")+")"),ATTR:RegExp("^"+P),PSEUDO:RegExp("^"+R),CHILD:RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\("+_+"*(even|odd|(([+-]|)(\\d*)n|)"+_+"*(?:([+-]|)"+_+"*(\\d+)|))"+_+"*\\)|)","i"),needsContext:RegExp("^"+_+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\("+_+"*((?:-\\d)?\\d*)"+_+"*\\)|)(?=[^-]|$)","i")},V=/[\x20\t\r\n\f]*[+~]/,Y=/^[^{]+\{\s*\[native code/,J=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,G=/^(?:input|select|textarea|button)$/i,Q=/^h\d$/i,K=/'|\\/g,Z=/\=[\x20\t\r\n\f]*([^'"\]]*)[\x20\t\r\n\f]*\]/g,et=/\\([\da-fA-F]{1,6}[\x20\t\r\n\f]?|.)/g,tt=function(e,t){var n="0x"+t-65536;return n!==n?t:0>n?String.fromCharCode(n+65536):String.fromCharCode(55296|n>>10,56320|1023&n)};try{q.call(w.documentElement.childNodes,0)[0].nodeType}catch(nt){q=function(e){var t,n=[];while(t=this[e++])n.push(t);return n}}function rt(e){return Y.test(e+"")}function it(){var e,t=[];return e=function(n,r){return t.push(n+=" ")>i.cacheLength&&delete e[t.shift()],e[n]=r}}function ot(e){return e[x]=!0,e}function at(e){var t=p.createElement("div");try{return e(t)}catch(n){return!1}finally{t=null}}function st(e,t,n,r){var i,o,a,s,u,l,f,g,m,v;if((t?t.ownerDocument||t:w)!==p&&c(t),t=t||p,n=n||[],!e||"string"!=typeof e)return n;if(1!==(s=t.nodeType)&&9!==s)return[];if(!d&&!r){if(i=J.exec(e))if(a=i[1]){if(9===s){if(o=t.getElementById(a),!o||!o.parentNode)return n;if(o.id===a)return n.push(o),n}else if(t.ownerDocument&&(o=t.ownerDocument.getElementById(a))&&y(t,o)&&o.id===a)return n.push(o),n}else{if(i[2])return H.apply(n,q.call(t.getElementsByTagName(e),0)),n;if((a=i[3])&&T.getByClassName&&t.getElementsByClassName)return H.apply(n,q.call(t.getElementsByClassName(a),0)),n}if(T.qsa&&!h.test(e)){if(f=!0,g=x,m=t,v=9===s&&e,1===s&&"object"!==t.nodeName.toLowerCase()){l=ft(e),(f=t.getAttribute("id"))?g=f.replace(K,"\\$&"):t.setAttribute("id",g),g="[id='"+g+"'] ",u=l.length;while(u--)l[u]=g+dt(l[u]);m=V.test(e)&&t.parentNode||t,v=l.join(",")}if(v)try{return H.apply(n,q.call(m.querySelectorAll(v),0)),n}catch(b){}finally{f||t.removeAttribute("id")}}}return wt(e.replace(W,"$1"),t,n,r)}a=st.isXML=function(e){var t=e&&(e.ownerDocument||e).documentElement;return t?"HTML"!==t.nodeName:!1},c=st.setDocument=function(e){var n=e?e.ownerDocument||e:w;return n!==p&&9===n.nodeType&&n.documentElement?(p=n,f=n.documentElement,d=a(n),T.tagNameNoComments=at(function(e){return e.appendChild(n.createComment("")),!e.getElementsByTagName("*").length}),T.attributes=at(function(e){e.innerHTML="<select></select>";var t=typeof e.lastChild.getAttribute("multiple");return"boolean"!==t&&"string"!==t}),T.getByClassName=at(function(e){return e.innerHTML="<div class='hidden e'></div><div class='hidden'></div>",e.getElementsByClassName&&e.getElementsByClassName("e").length?(e.lastChild.className="e",2===e.getElementsByClassName("e").length):!1}),T.getByName=at(function(e){e.id=x+0,e.innerHTML="<a name='"+x+"'></a><div name='"+x+"'></div>",f.insertBefore(e,f.firstChild);var t=n.getElementsByName&&n.getElementsByName(x).length===2+n.getElementsByName(x+0).length;return T.getIdNotName=!n.getElementById(x),f.removeChild(e),t}),i.attrHandle=at(function(e){return e.innerHTML="<a href='#'></a>",e.firstChild&&typeof e.firstChild.getAttribute!==A&&"#"===e.firstChild.getAttribute("href")})?{}:{href:function(e){return e.getAttribute("href",2)},type:function(e){return e.getAttribute("type")}},T.getIdNotName?(i.find.ID=function(e,t){if(typeof t.getElementById!==A&&!d){var n=t.getElementById(e);return n&&n.parentNode?[n]:[]}},i.filter.ID=function(e){var t=e.replace(et,tt);return function(e){return e.getAttribute("id")===t}}):(i.find.ID=function(e,n){if(typeof n.getElementById!==A&&!d){var r=n.getElementById(e);return r?r.id===e||typeof r.getAttributeNode!==A&&r.getAttributeNode("id").value===e?[r]:t:[]}},i.filter.ID=function(e){var t=e.replace(et,tt);return function(e){var n=typeof e.getAttributeNode!==A&&e.getAttributeNode("id");return n&&n.value===t}}),i.find.TAG=T.tagNameNoComments?function(e,n){return typeof n.getElementsByTagName!==A?n.getElementsByTagName(e):t}:function(e,t){var n,r=[],i=0,o=t.getElementsByTagName(e);if("*"===e){while(n=o[i++])1===n.nodeType&&r.push(n);return r}return o},i.find.NAME=T.getByName&&function(e,n){return typeof n.getElementsByName!==A?n.getElementsByName(name):t},i.find.CLASS=T.getByClassName&&function(e,n){return typeof n.getElementsByClassName===A||d?t:n.getElementsByClassName(e)},g=[],h=[":focus"],(T.qsa=rt(n.querySelectorAll))&&(at(function(e){e.innerHTML="<select><option selected=''></option></select>",e.querySelectorAll("[selected]").length||h.push("\\["+_+"*(?:checked|disabled|ismap|multiple|readonly|selected|value)"),e.querySelectorAll(":checked").length||h.push(":checked")}),at(function(e){e.innerHTML="<input type='hidden' i=''/>",e.querySelectorAll("[i^='']").length&&h.push("[*^$]="+_+"*(?:\"\"|'')"),e.querySelectorAll(":enabled").length||h.push(":enabled",":disabled"),e.querySelectorAll("*,:x"),h.push(",.*:")})),(T.matchesSelector=rt(m=f.matchesSelector||f.mozMatchesSelector||f.webkitMatchesSelector||f.oMatchesSelector||f.msMatchesSelector))&&at(function(e){T.disconnectedMatch=m.call(e,"div"),m.call(e,"[s!='']:x"),g.push("!=",R)}),h=RegExp(h.join("|")),g=RegExp(g.join("|")),y=rt(f.contains)||f.compareDocumentPosition?function(e,t){var n=9===e.nodeType?e.documentElement:e,r=t&&t.parentNode;return e===r||!(!r||1!==r.nodeType||!(n.contains?n.contains(r):e.compareDocumentPosition&&16&e.compareDocumentPosition(r)))}:function(e,t){if(t)while(t=t.parentNode)if(t===e)return!0;return!1},v=f.compareDocumentPosition?function(e,t){var r;return e===t?(u=!0,0):(r=t.compareDocumentPosition&&e.compareDocumentPosition&&e.compareDocumentPosition(t))?1&r||e.parentNode&&11===e.parentNode.nodeType?e===n||y(w,e)?-1:t===n||y(w,t)?1:0:4&r?-1:1:e.compareDocumentPosition?-1:1}:function(e,t){var r,i=0,o=e.parentNode,a=t.parentNode,s=[e],l=[t];if(e===t)return u=!0,0;if(!o||!a)return e===n?-1:t===n?1:o?-1:a?1:0;if(o===a)return ut(e,t);r=e;while(r=r.parentNode)s.unshift(r);r=t;while(r=r.parentNode)l.unshift(r);while(s[i]===l[i])i++;return i?ut(s[i],l[i]):s[i]===w?-1:l[i]===w?1:0},u=!1,[0,0].sort(v),T.detectDuplicates=u,p):p},st.matches=function(e,t){return st(e,null,null,t)},st.matchesSelector=function(e,t){if((e.ownerDocument||e)!==p&&c(e),t=t.replace(Z,"='$1']"),!(!T.matchesSelector||d||g&&g.test(t)||h.test(t)))try{var n=m.call(e,t);if(n||T.disconnectedMatch||e.document&&11!==e.document.nodeType)return n}catch(r){}return st(t,p,null,[e]).length>0},st.contains=function(e,t){return(e.ownerDocument||e)!==p&&c(e),y(e,t)},st.attr=function(e,t){var n;return(e.ownerDocument||e)!==p&&c(e),d||(t=t.toLowerCase()),(n=i.attrHandle[t])?n(e):d||T.attributes?e.getAttribute(t):((n=e.getAttributeNode(t))||e.getAttribute(t))&&e[t]===!0?t:n&&n.specified?n.value:null},st.error=function(e){throw Error("Syntax error, unrecognized expression: "+e)},st.uniqueSort=function(e){var t,n=[],r=1,i=0;if(u=!T.detectDuplicates,e.sort(v),u){for(;t=e[r];r++)t===e[r-1]&&(i=n.push(r));while(i--)e.splice(n[i],1)}return e};function ut(e,t){var n=t&&e,r=n&&(~t.sourceIndex||j)-(~e.sourceIndex||j);if(r)return r;if(n)while(n=n.nextSibling)if(n===t)return-1;return e?1:-1}function lt(e){return function(t){var n=t.nodeName.toLowerCase();return"input"===n&&t.type===e}}function ct(e){return function(t){var n=t.nodeName.toLowerCase();return("input"===n||"button"===n)&&t.type===e}}function pt(e){return ot(function(t){return t=+t,ot(function(n,r){var i,o=e([],n.length,t),a=o.length;while(a--)n[i=o[a]]&&(n[i]=!(r[i]=n[i]))})})}o=st.getText=function(e){var t,n="",r=0,i=e.nodeType;if(i){if(1===i||9===i||11===i){if("string"==typeof e.textContent)return e.textContent;for(e=e.firstChild;e;e=e.nextSibling)n+=o(e)}else if(3===i||4===i)return e.nodeValue}else for(;t=e[r];r++)n+=o(t);return n},i=st.selectors={cacheLength:50,createPseudo:ot,match:U,find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(e){return e[1]=e[1].replace(et,tt),e[3]=(e[4]||e[5]||"").replace(et,tt),"~="===e[2]&&(e[3]=" "+e[3]+" "),e.slice(0,4)},CHILD:function(e){return e[1]=e[1].toLowerCase(),"nth"===e[1].slice(0,3)?(e[3]||st.error(e[0]),e[4]=+(e[4]?e[5]+(e[6]||1):2*("even"===e[3]||"odd"===e[3])),e[5]=+(e[7]+e[8]||"odd"===e[3])):e[3]&&st.error(e[0]),e},PSEUDO:function(e){var t,n=!e[5]&&e[2];return U.CHILD.test(e[0])?null:(e[4]?e[2]=e[4]:n&&z.test(n)&&(t=ft(n,!0))&&(t=n.indexOf(")",n.length-t)-n.length)&&(e[0]=e[0].slice(0,t),e[2]=n.slice(0,t)),e.slice(0,3))}},filter:{TAG:function(e){return"*"===e?function(){return!0}:(e=e.replace(et,tt).toLowerCase(),function(t){return t.nodeName&&t.nodeName.toLowerCase()===e})},CLASS:function(e){var t=k[e+" "];return t||(t=RegExp("(^|"+_+")"+e+"("+_+"|$)"))&&k(e,function(e){return t.test(e.className||typeof e.getAttribute!==A&&e.getAttribute("class")||"")})},ATTR:function(e,t,n){return function(r){var i=st.attr(r,e);return null==i?"!="===t:t?(i+="","="===t?i===n:"!="===t?i!==n:"^="===t?n&&0===i.indexOf(n):"*="===t?n&&i.indexOf(n)>-1:"$="===t?n&&i.slice(-n.length)===n:"~="===t?(" "+i+" ").indexOf(n)>-1:"|="===t?i===n||i.slice(0,n.length+1)===n+"-":!1):!0}},CHILD:function(e,t,n,r,i){var o="nth"!==e.slice(0,3),a="last"!==e.slice(-4),s="of-type"===t;return 1===r&&0===i?function(e){return!!e.parentNode}:function(t,n,u){var l,c,p,f,d,h,g=o!==a?"nextSibling":"previousSibling",m=t.parentNode,y=s&&t.nodeName.toLowerCase(),v=!u&&!s;if(m){if(o){while(g){p=t;while(p=p[g])if(s?p.nodeName.toLowerCase()===y:1===p.nodeType)return!1;h=g="only"===e&&!h&&"nextSibling"}return!0}if(h=[a?m.firstChild:m.lastChild],a&&v){c=m[x]||(m[x]={}),l=c[e]||[],d=l[0]===N&&l[1],f=l[0]===N&&l[2],p=d&&m.childNodes[d];while(p=++d&&p&&p[g]||(f=d=0)||h.pop())if(1===p.nodeType&&++f&&p===t){c[e]=[N,d,f];break}}else if(v&&(l=(t[x]||(t[x]={}))[e])&&l[0]===N)f=l[1];else while(p=++d&&p&&p[g]||(f=d=0)||h.pop())if((s?p.nodeName.toLowerCase()===y:1===p.nodeType)&&++f&&(v&&((p[x]||(p[x]={}))[e]=[N,f]),p===t))break;return f-=i,f===r||0===f%r&&f/r>=0}}},PSEUDO:function(e,t){var n,r=i.pseudos[e]||i.setFilters[e.toLowerCase()]||st.error("unsupported pseudo: "+e);return r[x]?r(t):r.length>1?(n=[e,e,"",t],i.setFilters.hasOwnProperty(e.toLowerCase())?ot(function(e,n){var i,o=r(e,t),a=o.length;while(a--)i=M.call(e,o[a]),e[i]=!(n[i]=o[a])}):function(e){return r(e,0,n)}):r}},pseudos:{not:ot(function(e){var t=[],n=[],r=s(e.replace(W,"$1"));return r[x]?ot(function(e,t,n,i){var o,a=r(e,null,i,[]),s=e.length;while(s--)(o=a[s])&&(e[s]=!(t[s]=o))}):function(e,i,o){return t[0]=e,r(t,null,o,n),!n.pop()}}),has:ot(function(e){return function(t){return st(e,t).length>0}}),contains:ot(function(e){return function(t){return(t.textContent||t.innerText||o(t)).indexOf(e)>-1}}),lang:ot(function(e){return X.test(e||"")||st.error("unsupported lang: "+e),e=e.replace(et,tt).toLowerCase(),function(t){var n;do if(n=d?t.getAttribute("xml:lang")||t.getAttribute("lang"):t.lang)return n=n.toLowerCase(),n===e||0===n.indexOf(e+"-");while((t=t.parentNode)&&1===t.nodeType);return!1}}),target:function(t){var n=e.location&&e.location.hash;return n&&n.slice(1)===t.id},root:function(e){return e===f},focus:function(e){return e===p.activeElement&&(!p.hasFocus||p.hasFocus())&&!!(e.type||e.href||~e.tabIndex)},enabled:function(e){return e.disabled===!1},disabled:function(e){return e.disabled===!0},checked:function(e){var t=e.nodeName.toLowerCase();return"input"===t&&!!e.checked||"option"===t&&!!e.selected},selected:function(e){return e.parentNode&&e.parentNode.selectedIndex,e.selected===!0},empty:function(e){for(e=e.firstChild;e;e=e.nextSibling)if(e.nodeName>"@"||3===e.nodeType||4===e.nodeType)return!1;return!0},parent:function(e){return!i.pseudos.empty(e)},header:function(e){return Q.test(e.nodeName)},input:function(e){return G.test(e.nodeName)},button:function(e){var t=e.nodeName.toLowerCase();return"input"===t&&"button"===e.type||"button"===t},text:function(e){var t;return"input"===e.nodeName.toLowerCase()&&"text"===e.type&&(null==(t=e.getAttribute("type"))||t.toLowerCase()===e.type)},first:pt(function(){return[0]}),last:pt(function(e,t){return[t-1]}),eq:pt(function(e,t,n){return[0>n?n+t:n]}),even:pt(function(e,t){var n=0;for(;t>n;n+=2)e.push(n);return e}),odd:pt(function(e,t){var n=1;for(;t>n;n+=2)e.push(n);return e}),lt:pt(function(e,t,n){var r=0>n?n+t:n;for(;--r>=0;)e.push(r);return e}),gt:pt(function(e,t,n){var r=0>n?n+t:n;for(;t>++r;)e.push(r);return e})}};for(n in{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})i.pseudos[n]=lt(n);for(n in{submit:!0,reset:!0})i.pseudos[n]=ct(n);function ft(e,t){var n,r,o,a,s,u,l,c=E[e+" "];if(c)return t?0:c.slice(0);s=e,u=[],l=i.preFilter;while(s){(!n||(r=$.exec(s)))&&(r&&(s=s.slice(r[0].length)||s),u.push(o=[])),n=!1,(r=I.exec(s))&&(n=r.shift(),o.push({value:n,type:r[0].replace(W," ")}),s=s.slice(n.length));for(a in i.filter)!(r=U[a].exec(s))||l[a]&&!(r=l[a](r))||(n=r.shift(),o.push({value:n,type:a,matches:r}),s=s.slice(n.length));if(!n)break}return t?s.length:s?st.error(e):E(e,u).slice(0)}function dt(e){var t=0,n=e.length,r="";for(;n>t;t++)r+=e[t].value;return r}function ht(e,t,n){var i=t.dir,o=n&&"parentNode"===i,a=C++;return t.first?function(t,n,r){while(t=t[i])if(1===t.nodeType||o)return e(t,n,r)}:function(t,n,s){var u,l,c,p=N+" "+a;if(s){while(t=t[i])if((1===t.nodeType||o)&&e(t,n,s))return!0}else while(t=t[i])if(1===t.nodeType||o)if(c=t[x]||(t[x]={}),(l=c[i])&&l[0]===p){if((u=l[1])===!0||u===r)return u===!0}else if(l=c[i]=[p],l[1]=e(t,n,s)||r,l[1]===!0)return!0}}function gt(e){return e.length>1?function(t,n,r){var i=e.length;while(i--)if(!e[i](t,n,r))return!1;return!0}:e[0]}function mt(e,t,n,r,i){var o,a=[],s=0,u=e.length,l=null!=t;for(;u>s;s++)(o=e[s])&&(!n||n(o,r,i))&&(a.push(o),l&&t.push(s));return a}function yt(e,t,n,r,i,o){return r&&!r[x]&&(r=yt(r)),i&&!i[x]&&(i=yt(i,o)),ot(function(o,a,s,u){var l,c,p,f=[],d=[],h=a.length,g=o||xt(t||"*",s.nodeType?[s]:s,[]),m=!e||!o&&t?g:mt(g,f,e,s,u),y=n?i||(o?e:h||r)?[]:a:m;if(n&&n(m,y,s,u),r){l=mt(y,d),r(l,[],s,u),c=l.length;while(c--)(p=l[c])&&(y[d[c]]=!(m[d[c]]=p))}if(o){if(i||e){if(i){l=[],c=y.length;while(c--)(p=y[c])&&l.push(m[c]=p);i(null,y=[],l,u)}c=y.length;while(c--)(p=y[c])&&(l=i?M.call(o,p):f[c])>-1&&(o[l]=!(a[l]=p))}}else y=mt(y===a?y.splice(h,y.length):y),i?i(null,a,y,u):H.apply(a,y)})}function vt(e){var t,n,r,o=e.length,a=i.relative[e[0].type],s=a||i.relative[" "],u=a?1:0,c=ht(function(e){return e===t},s,!0),p=ht(function(e){return M.call(t,e)>-1},s,!0),f=[function(e,n,r){return!a&&(r||n!==l)||((t=n).nodeType?c(e,n,r):p(e,n,r))}];for(;o>u;u++)if(n=i.relative[e[u].type])f=[ht(gt(f),n)];else{if(n=i.filter[e[u].type].apply(null,e[u].matches),n[x]){for(r=++u;o>r;r++)if(i.relative[e[r].type])break;return yt(u>1&&gt(f),u>1&&dt(e.slice(0,u-1)).replace(W,"$1"),n,r>u&&vt(e.slice(u,r)),o>r&&vt(e=e.slice(r)),o>r&&dt(e))}f.push(n)}return gt(f)}function bt(e,t){var n=0,o=t.length>0,a=e.length>0,s=function(s,u,c,f,d){var h,g,m,y=[],v=0,b="0",x=s&&[],w=null!=d,T=l,C=s||a&&i.find.TAG("*",d&&u.parentNode||u),k=N+=null==T?1:Math.random()||.1;for(w&&(l=u!==p&&u,r=n);null!=(h=C[b]);b++){if(a&&h){g=0;while(m=e[g++])if(m(h,u,c)){f.push(h);break}w&&(N=k,r=++n)}o&&((h=!m&&h)&&v--,s&&x.push(h))}if(v+=b,o&&b!==v){g=0;while(m=t[g++])m(x,y,u,c);if(s){if(v>0)while(b--)x[b]||y[b]||(y[b]=L.call(f));y=mt(y)}H.apply(f,y),w&&!s&&y.length>0&&v+t.length>1&&st.uniqueSort(f)}return w&&(N=k,l=T),x};return o?ot(s):s}s=st.compile=function(e,t){var n,r=[],i=[],o=S[e+" "];if(!o){t||(t=ft(e)),n=t.length;while(n--)o=vt(t[n]),o[x]?r.push(o):i.push(o);o=S(e,bt(i,r))}return o};function xt(e,t,n){var r=0,i=t.length;for(;i>r;r++)st(e,t[r],n);return n}function wt(e,t,n,r){var o,a,u,l,c,p=ft(e);if(!r&&1===p.length){if(a=p[0]=p[0].slice(0),a.length>2&&"ID"===(u=a[0]).type&&9===t.nodeType&&!d&&i.relative[a[1].type]){if(t=i.find.ID(u.matches[0].replace(et,tt),t)[0],!t)return n;e=e.slice(a.shift().value.length)}o=U.needsContext.test(e)?0:a.length;while(o--){if(u=a[o],i.relative[l=u.type])break;if((c=i.find[l])&&(r=c(u.matches[0].replace(et,tt),V.test(a[0].type)&&t.parentNode||t))){if(a.splice(o,1),e=r.length&&dt(a),!e)return H.apply(n,q.call(r,0)),n;break}}}return s(e,p)(r,t,d,n,V.test(e)),n}i.pseudos.nth=i.pseudos.eq;function Tt(){}i.filters=Tt.prototype=i.pseudos,i.setFilters=new Tt,c(),st.attr=b.attr,b.find=st,b.expr=st.selectors,b.expr[":"]=b.expr.pseudos,b.unique=st.uniqueSort,b.text=st.getText,b.isXMLDoc=st.isXML,b.contains=st.contains}(e);var at=/Until$/,st=/^(?:parents|prev(?:Until|All))/,ut=/^.[^:#\[\.,]*$/,lt=b.expr.match.needsContext,ct={children:!0,contents:!0,next:!0,prev:!0};b.fn.extend({find:function(e){var t,n,r,i=this.length;if("string"!=typeof e)return r=this,this.pushStack(b(e).filter(function(){for(t=0;i>t;t++)if(b.contains(r[t],this))return!0}));for(n=[],t=0;i>t;t++)b.find(e,this[t],n);return n=this.pushStack(i>1?b.unique(n):n),n.selector=(this.selector?this.selector+" ":"")+e,n},has:function(e){var t,n=b(e,this),r=n.length;return this.filter(function(){for(t=0;r>t;t++)if(b.contains(this,n[t]))return!0})},not:function(e){return this.pushStack(ft(this,e,!1))},filter:function(e){return this.pushStack(ft(this,e,!0))},is:function(e){return!!e&&("string"==typeof e?lt.test(e)?b(e,this.context).index(this[0])>=0:b.filter(e,this).length>0:this.filter(e).length>0)},closest:function(e,t){var n,r=0,i=this.length,o=[],a=lt.test(e)||"string"!=typeof e?b(e,t||this.context):0;for(;i>r;r++){n=this[r];while(n&&n.ownerDocument&&n!==t&&11!==n.nodeType){if(a?a.index(n)>-1:b.find.matchesSelector(n,e)){o.push(n);break}n=n.parentNode}}return this.pushStack(o.length>1?b.unique(o):o)},index:function(e){return e?"string"==typeof e?b.inArray(this[0],b(e)):b.inArray(e.jquery?e[0]:e,this):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(e,t){var n="string"==typeof e?b(e,t):b.makeArray(e&&e.nodeType?[e]:e),r=b.merge(this.get(),n);return this.pushStack(b.unique(r))},addBack:function(e){return this.add(null==e?this.prevObject:this.prevObject.filter(e))}}),b.fn.andSelf=b.fn.addBack;function pt(e,t){do e=e[t];while(e&&1!==e.nodeType);return e}b.each({parent:function(e){var t=e.parentNode;return t&&11!==t.nodeType?t:null},parents:function(e){return b.dir(e,"parentNode")},parentsUntil:function(e,t,n){return b.dir(e,"parentNode",n)},next:function(e){return pt(e,"nextSibling")},prev:function(e){return pt(e,"previousSibling")},nextAll:function(e){return b.dir(e,"nextSibling")},prevAll:function(e){return b.dir(e,"previousSibling")},nextUntil:function(e,t,n){return b.dir(e,"nextSibling",n)},prevUntil:function(e,t,n){return b.dir(e,"previousSibling",n)},siblings:function(e){return b.sibling((e.parentNode||{}).firstChild,e)},children:function(e){return b.sibling(e.firstChild)},contents:function(e){return b.nodeName(e,"iframe")?e.contentDocument||e.contentWindow.document:b.merge([],e.childNodes)}},function(e,t){b.fn[e]=function(n,r){var i=b.map(this,t,n);return at.test(e)||(r=n),r&&"string"==typeof r&&(i=b.filter(r,i)),i=this.length>1&&!ct[e]?b.unique(i):i,this.length>1&&st.test(e)&&(i=i.reverse()),this.pushStack(i)}}),b.extend({filter:function(e,t,n){return n&&(e=":not("+e+")"),1===t.length?b.find.matchesSelector(t[0],e)?[t[0]]:[]:b.find.matches(e,t)},dir:function(e,n,r){var i=[],o=e[n];while(o&&9!==o.nodeType&&(r===t||1!==o.nodeType||!b(o).is(r)))1===o.nodeType&&i.push(o),o=o[n];return i},sibling:function(e,t){var n=[];for(;e;e=e.nextSibling)1===e.nodeType&&e!==t&&n.push(e);return n}});function ft(e,t,n){if(t=t||0,b.isFunction(t))return b.grep(e,function(e,r){var i=!!t.call(e,r,e);return i===n});if(t.nodeType)return b.grep(e,function(e){return e===t===n});if("string"==typeof t){var r=b.grep(e,function(e){return 1===e.nodeType});if(ut.test(t))return b.filter(t,r,!n);t=b.filter(t,r)}return b.grep(e,function(e){return b.inArray(e,t)>=0===n})}function dt(e){var t=ht.split("|"),n=e.createDocumentFragment();if(n.createElement)while(t.length)n.createElement(t.pop());return n}var ht="abbr|article|aside|audio|bdi|canvas|data|datalist|details|figcaption|figure|footer|header|hgroup|mark|meter|nav|output|progress|section|summary|time|video",gt=/ jQuery\d+="(?:null|\d+)"/g,mt=RegExp("<(?:"+ht+")[\\s/>]","i"),yt=/^\s+/,vt=/<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,bt=/<([\w:]+)/,xt=/<tbody/i,wt=/<|&#?\w+;/,Tt=/<(?:script|style|link)/i,Nt=/^(?:checkbox|radio)$/i,Ct=/checked\s*(?:[^=]|=\s*.checked.)/i,kt=/^$|\/(?:java|ecma)script/i,Et=/^true\/(.*)/,St=/^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,At={option:[1,"<select multiple='multiple'>","</select>"],legend:[1,"<fieldset>","</fieldset>"],area:[1,"<map>","</map>"],param:[1,"<object>","</object>"],thead:[1,"<table>","</table>"],tr:[2,"<table><tbody>","</tbody></table>"],col:[2,"<table><tbody></tbody><colgroup>","</colgroup></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:b.support.htmlSerialize?[0,"",""]:[1,"X<div>","</div>"]},jt=dt(o),Dt=jt.appendChild(o.createElement("div"));At.optgroup=At.option,At.tbody=At.tfoot=At.colgroup=At.caption=At.thead,At.th=At.td,b.fn.extend({text:function(e){return b.access(this,function(e){return e===t?b.text(this):this.empty().append((this[0]&&this[0].ownerDocument||o).createTextNode(e))},null,e,arguments.length)},wrapAll:function(e){if(b.isFunction(e))return this.each(function(t){b(this).wrapAll(e.call(this,t))});if(this[0]){var t=b(e,this[0].ownerDocument).eq(0).clone(!0);this[0].parentNode&&t.insertBefore(this[0]),t.map(function(){var e=this;while(e.firstChild&&1===e.firstChild.nodeType)e=e.firstChild;return e}).append(this)}return this},wrapInner:function(e){return b.isFunction(e)?this.each(function(t){b(this).wrapInner(e.call(this,t))}):this.each(function(){var t=b(this),n=t.contents();n.length?n.wrapAll(e):t.append(e)})},wrap:function(e){var t=b.isFunction(e);return this.each(function(n){b(this).wrapAll(t?e.call(this,n):e)})},unwrap:function(){return this.parent().each(function(){b.nodeName(this,"body")||b(this).replaceWith(this.childNodes)}).end()},append:function(){return this.domManip(arguments,!0,function(e){(1===this.nodeType||11===this.nodeType||9===this.nodeType)&&this.appendChild(e)})},prepend:function(){return this.domManip(arguments,!0,function(e){(1===this.nodeType||11===this.nodeType||9===this.nodeType)&&this.insertBefore(e,this.firstChild)})},before:function(){return this.domManip(arguments,!1,function(e){this.parentNode&&this.parentNode.insertBefore(e,this)})},after:function(){return this.domManip(arguments,!1,function(e){this.parentNode&&this.parentNode.insertBefore(e,this.nextSibling)})},remove:function(e,t){var n,r=0;for(;null!=(n=this[r]);r++)(!e||b.filter(e,[n]).length>0)&&(t||1!==n.nodeType||b.cleanData(Ot(n)),n.parentNode&&(t&&b.contains(n.ownerDocument,n)&&Mt(Ot(n,"script")),n.parentNode.removeChild(n)));return this},empty:function(){var e,t=0;for(;null!=(e=this[t]);t++){1===e.nodeType&&b.cleanData(Ot(e,!1));while(e.firstChild)e.removeChild(e.firstChild);e.options&&b.nodeName(e,"select")&&(e.options.length=0)}return this},clone:function(e,t){return e=null==e?!1:e,t=null==t?e:t,this.map(function(){return b.clone(this,e,t)})},html:function(e){return b.access(this,function(e){var n=this[0]||{},r=0,i=this.length;if(e===t)return 1===n.nodeType?n.innerHTML.replace(gt,""):t;if(!("string"!=typeof e||Tt.test(e)||!b.support.htmlSerialize&&mt.test(e)||!b.support.leadingWhitespace&&yt.test(e)||At[(bt.exec(e)||["",""])[1].toLowerCase()])){e=e.replace(vt,"<$1></$2>");try{for(;i>r;r++)n=this[r]||{},1===n.nodeType&&(b.cleanData(Ot(n,!1)),n.innerHTML=e);n=0}catch(o){}}n&&this.empty().append(e)},null,e,arguments.length)},replaceWith:function(e){var t=b.isFunction(e);return t||"string"==typeof e||(e=b(e).not(this).detach()),this.domManip([e],!0,function(e){var t=this.nextSibling,n=this.parentNode;n&&(b(this).remove(),n.insertBefore(e,t))})},detach:function(e){return this.remove(e,!0)},domManip:function(e,n,r){e=f.apply([],e);var i,o,a,s,u,l,c=0,p=this.length,d=this,h=p-1,g=e[0],m=b.isFunction(g);if(m||!(1>=p||"string"!=typeof g||b.support.checkClone)&&Ct.test(g))return this.each(function(i){var o=d.eq(i);m&&(e[0]=g.call(this,i,n?o.html():t)),o.domManip(e,n,r)});if(p&&(l=b.buildFragment(e,this[0].ownerDocument,!1,this),i=l.firstChild,1===l.childNodes.length&&(l=i),i)){for(n=n&&b.nodeName(i,"tr"),s=b.map(Ot(l,"script"),Ht),a=s.length;p>c;c++)o=l,c!==h&&(o=b.clone(o,!0,!0),a&&b.merge(s,Ot(o,"script"))),r.call(n&&b.nodeName(this[c],"table")?Lt(this[c],"tbody"):this[c],o,c);if(a)for(u=s[s.length-1].ownerDocument,b.map(s,qt),c=0;a>c;c++)o=s[c],kt.test(o.type||"")&&!b._data(o,"globalEval")&&b.contains(u,o)&&(o.src?b.ajax({url:o.src,type:"GET",dataType:"script",async:!1,global:!1,"throws":!0}):b.globalEval((o.text||o.textContent||o.innerHTML||"").replace(St,"")));l=i=null}return this}});function Lt(e,t){return e.getElementsByTagName(t)[0]||e.appendChild(e.ownerDocument.createElement(t))}function Ht(e){var t=e.getAttributeNode("type");return e.type=(t&&t.specified)+"/"+e.type,e}function qt(e){var t=Et.exec(e.type);return t?e.type=t[1]:e.removeAttribute("type"),e}function Mt(e,t){var n,r=0;for(;null!=(n=e[r]);r++)b._data(n,"globalEval",!t||b._data(t[r],"globalEval"))}function _t(e,t){if(1===t.nodeType&&b.hasData(e)){var n,r,i,o=b._data(e),a=b._data(t,o),s=o.events;if(s){delete a.handle,a.events={};for(n in s)for(r=0,i=s[n].length;i>r;r++)b.event.add(t,n,s[n][r])}a.data&&(a.data=b.extend({},a.data))}}function Ft(e,t){var n,r,i;if(1===t.nodeType){if(n=t.nodeName.toLowerCase(),!b.support.noCloneEvent&&t[b.expando]){i=b._data(t);for(r in i.events)b.removeEvent(t,r,i.handle);t.removeAttribute(b.expando)}"script"===n&&t.text!==e.text?(Ht(t).text=e.text,qt(t)):"object"===n?(t.parentNode&&(t.outerHTML=e.outerHTML),b.support.html5Clone&&e.innerHTML&&!b.trim(t.innerHTML)&&(t.innerHTML=e.innerHTML)):"input"===n&&Nt.test(e.type)?(t.defaultChecked=t.checked=e.checked,t.value!==e.value&&(t.value=e.value)):"option"===n?t.defaultSelected=t.selected=e.defaultSelected:("input"===n||"textarea"===n)&&(t.defaultValue=e.defaultValue)}}b.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(e,t){b.fn[e]=function(e){var n,r=0,i=[],o=b(e),a=o.length-1;for(;a>=r;r++)n=r===a?this:this.clone(!0),b(o[r])[t](n),d.apply(i,n.get());return this.pushStack(i)}});function Ot(e,n){var r,o,a=0,s=typeof e.getElementsByTagName!==i?e.getElementsByTagName(n||"*"):typeof e.querySelectorAll!==i?e.querySelectorAll(n||"*"):t;if(!s)for(s=[],r=e.childNodes||e;null!=(o=r[a]);a++)!n||b.nodeName(o,n)?s.push(o):b.merge(s,Ot(o,n));return n===t||n&&b.nodeName(e,n)?b.merge([e],s):s}function Bt(e){Nt.test(e.type)&&(e.defaultChecked=e.checked)}b.extend({clone:function(e,t,n){var r,i,o,a,s,u=b.contains(e.ownerDocument,e);if(b.support.html5Clone||b.isXMLDoc(e)||!mt.test("<"+e.nodeName+">")?o=e.cloneNode(!0):(Dt.innerHTML=e.outerHTML,Dt.removeChild(o=Dt.firstChild)),!(b.support.noCloneEvent&&b.support.noCloneChecked||1!==e.nodeType&&11!==e.nodeType||b.isXMLDoc(e)))for(r=Ot(o),s=Ot(e),a=0;null!=(i=s[a]);++a)r[a]&&Ft(i,r[a]);if(t)if(n)for(s=s||Ot(e),r=r||Ot(o),a=0;null!=(i=s[a]);a++)_t(i,r[a]);else _t(e,o);return r=Ot(o,"script"),r.length>0&&Mt(r,!u&&Ot(e,"script")),r=s=i=null,o},buildFragment:function(e,t,n,r){var i,o,a,s,u,l,c,p=e.length,f=dt(t),d=[],h=0;for(;p>h;h++)if(o=e[h],o||0===o)if("object"===b.type(o))b.merge(d,o.nodeType?[o]:o);else if(wt.test(o)){s=s||f.appendChild(t.createElement("div")),u=(bt.exec(o)||["",""])[1].toLowerCase(),c=At[u]||At._default,s.innerHTML=c[1]+o.replace(vt,"<$1></$2>")+c[2],i=c[0];while(i--)s=s.lastChild;if(!b.support.leadingWhitespace&&yt.test(o)&&d.push(t.createTextNode(yt.exec(o)[0])),!b.support.tbody){o="table"!==u||xt.test(o)?"<table>"!==c[1]||xt.test(o)?0:s:s.firstChild,i=o&&o.childNodes.length;while(i--)b.nodeName(l=o.childNodes[i],"tbody")&&!l.childNodes.length&&o.removeChild(l)
}b.merge(d,s.childNodes),s.textContent="";while(s.firstChild)s.removeChild(s.firstChild);s=f.lastChild}else d.push(t.createTextNode(o));s&&f.removeChild(s),b.support.appendChecked||b.grep(Ot(d,"input"),Bt),h=0;while(o=d[h++])if((!r||-1===b.inArray(o,r))&&(a=b.contains(o.ownerDocument,o),s=Ot(f.appendChild(o),"script"),a&&Mt(s),n)){i=0;while(o=s[i++])kt.test(o.type||"")&&n.push(o)}return s=null,f},cleanData:function(e,t){var n,r,o,a,s=0,u=b.expando,l=b.cache,p=b.support.deleteExpando,f=b.event.special;for(;null!=(n=e[s]);s++)if((t||b.acceptData(n))&&(o=n[u],a=o&&l[o])){if(a.events)for(r in a.events)f[r]?b.event.remove(n,r):b.removeEvent(n,r,a.handle);l[o]&&(delete l[o],p?delete n[u]:typeof n.removeAttribute!==i?n.removeAttribute(u):n[u]=null,c.push(o))}}});var Pt,Rt,Wt,$t=/alpha\([^)]*\)/i,It=/opacity\s*=\s*([^)]*)/,zt=/^(top|right|bottom|left)$/,Xt=/^(none|table(?!-c[ea]).+)/,Ut=/^margin/,Vt=RegExp("^("+x+")(.*)$","i"),Yt=RegExp("^("+x+")(?!px)[a-z%]+$","i"),Jt=RegExp("^([+-])=("+x+")","i"),Gt={BODY:"block"},Qt={position:"absolute",visibility:"hidden",display:"block"},Kt={letterSpacing:0,fontWeight:400},Zt=["Top","Right","Bottom","Left"],en=["Webkit","O","Moz","ms"];function tn(e,t){if(t in e)return t;var n=t.charAt(0).toUpperCase()+t.slice(1),r=t,i=en.length;while(i--)if(t=en[i]+n,t in e)return t;return r}function nn(e,t){return e=t||e,"none"===b.css(e,"display")||!b.contains(e.ownerDocument,e)}function rn(e,t){var n,r,i,o=[],a=0,s=e.length;for(;s>a;a++)r=e[a],r.style&&(o[a]=b._data(r,"olddisplay"),n=r.style.display,t?(o[a]||"none"!==n||(r.style.display=""),""===r.style.display&&nn(r)&&(o[a]=b._data(r,"olddisplay",un(r.nodeName)))):o[a]||(i=nn(r),(n&&"none"!==n||!i)&&b._data(r,"olddisplay",i?n:b.css(r,"display"))));for(a=0;s>a;a++)r=e[a],r.style&&(t&&"none"!==r.style.display&&""!==r.style.display||(r.style.display=t?o[a]||"":"none"));return e}b.fn.extend({css:function(e,n){return b.access(this,function(e,n,r){var i,o,a={},s=0;if(b.isArray(n)){for(o=Rt(e),i=n.length;i>s;s++)a[n[s]]=b.css(e,n[s],!1,o);return a}return r!==t?b.style(e,n,r):b.css(e,n)},e,n,arguments.length>1)},show:function(){return rn(this,!0)},hide:function(){return rn(this)},toggle:function(e){var t="boolean"==typeof e;return this.each(function(){(t?e:nn(this))?b(this).show():b(this).hide()})}}),b.extend({cssHooks:{opacity:{get:function(e,t){if(t){var n=Wt(e,"opacity");return""===n?"1":n}}}},cssNumber:{columnCount:!0,fillOpacity:!0,fontWeight:!0,lineHeight:!0,opacity:!0,orphans:!0,widows:!0,zIndex:!0,zoom:!0},cssProps:{"float":b.support.cssFloat?"cssFloat":"styleFloat"},style:function(e,n,r,i){if(e&&3!==e.nodeType&&8!==e.nodeType&&e.style){var o,a,s,u=b.camelCase(n),l=e.style;if(n=b.cssProps[u]||(b.cssProps[u]=tn(l,u)),s=b.cssHooks[n]||b.cssHooks[u],r===t)return s&&"get"in s&&(o=s.get(e,!1,i))!==t?o:l[n];if(a=typeof r,"string"===a&&(o=Jt.exec(r))&&(r=(o[1]+1)*o[2]+parseFloat(b.css(e,n)),a="number"),!(null==r||"number"===a&&isNaN(r)||("number"!==a||b.cssNumber[u]||(r+="px"),b.support.clearCloneStyle||""!==r||0!==n.indexOf("background")||(l[n]="inherit"),s&&"set"in s&&(r=s.set(e,r,i))===t)))try{l[n]=r}catch(c){}}},css:function(e,n,r,i){var o,a,s,u=b.camelCase(n);return n=b.cssProps[u]||(b.cssProps[u]=tn(e.style,u)),s=b.cssHooks[n]||b.cssHooks[u],s&&"get"in s&&(a=s.get(e,!0,r)),a===t&&(a=Wt(e,n,i)),"normal"===a&&n in Kt&&(a=Kt[n]),""===r||r?(o=parseFloat(a),r===!0||b.isNumeric(o)?o||0:a):a},swap:function(e,t,n,r){var i,o,a={};for(o in t)a[o]=e.style[o],e.style[o]=t[o];i=n.apply(e,r||[]);for(o in t)e.style[o]=a[o];return i}}),e.getComputedStyle?(Rt=function(t){return e.getComputedStyle(t,null)},Wt=function(e,n,r){var i,o,a,s=r||Rt(e),u=s?s.getPropertyValue(n)||s[n]:t,l=e.style;return s&&(""!==u||b.contains(e.ownerDocument,e)||(u=b.style(e,n)),Yt.test(u)&&Ut.test(n)&&(i=l.width,o=l.minWidth,a=l.maxWidth,l.minWidth=l.maxWidth=l.width=u,u=s.width,l.width=i,l.minWidth=o,l.maxWidth=a)),u}):o.documentElement.currentStyle&&(Rt=function(e){return e.currentStyle},Wt=function(e,n,r){var i,o,a,s=r||Rt(e),u=s?s[n]:t,l=e.style;return null==u&&l&&l[n]&&(u=l[n]),Yt.test(u)&&!zt.test(n)&&(i=l.left,o=e.runtimeStyle,a=o&&o.left,a&&(o.left=e.currentStyle.left),l.left="fontSize"===n?"1em":u,u=l.pixelLeft+"px",l.left=i,a&&(o.left=a)),""===u?"auto":u});function on(e,t,n){var r=Vt.exec(t);return r?Math.max(0,r[1]-(n||0))+(r[2]||"px"):t}function an(e,t,n,r,i){var o=n===(r?"border":"content")?4:"width"===t?1:0,a=0;for(;4>o;o+=2)"margin"===n&&(a+=b.css(e,n+Zt[o],!0,i)),r?("content"===n&&(a-=b.css(e,"padding"+Zt[o],!0,i)),"margin"!==n&&(a-=b.css(e,"border"+Zt[o]+"Width",!0,i))):(a+=b.css(e,"padding"+Zt[o],!0,i),"padding"!==n&&(a+=b.css(e,"border"+Zt[o]+"Width",!0,i)));return a}function sn(e,t,n){var r=!0,i="width"===t?e.offsetWidth:e.offsetHeight,o=Rt(e),a=b.support.boxSizing&&"border-box"===b.css(e,"boxSizing",!1,o);if(0>=i||null==i){if(i=Wt(e,t,o),(0>i||null==i)&&(i=e.style[t]),Yt.test(i))return i;r=a&&(b.support.boxSizingReliable||i===e.style[t]),i=parseFloat(i)||0}return i+an(e,t,n||(a?"border":"content"),r,o)+"px"}function un(e){var t=o,n=Gt[e];return n||(n=ln(e,t),"none"!==n&&n||(Pt=(Pt||b("<iframe frameborder='0' width='0' height='0'/>").css("cssText","display:block !important")).appendTo(t.documentElement),t=(Pt[0].contentWindow||Pt[0].contentDocument).document,t.write("<!doctype html><html><body>"),t.close(),n=ln(e,t),Pt.detach()),Gt[e]=n),n}function ln(e,t){var n=b(t.createElement(e)).appendTo(t.body),r=b.css(n[0],"display");return n.remove(),r}b.each(["height","width"],function(e,n){b.cssHooks[n]={get:function(e,r,i){return r?0===e.offsetWidth&&Xt.test(b.css(e,"display"))?b.swap(e,Qt,function(){return sn(e,n,i)}):sn(e,n,i):t},set:function(e,t,r){var i=r&&Rt(e);return on(e,t,r?an(e,n,r,b.support.boxSizing&&"border-box"===b.css(e,"boxSizing",!1,i),i):0)}}}),b.support.opacity||(b.cssHooks.opacity={get:function(e,t){return It.test((t&&e.currentStyle?e.currentStyle.filter:e.style.filter)||"")?.01*parseFloat(RegExp.$1)+"":t?"1":""},set:function(e,t){var n=e.style,r=e.currentStyle,i=b.isNumeric(t)?"alpha(opacity="+100*t+")":"",o=r&&r.filter||n.filter||"";n.zoom=1,(t>=1||""===t)&&""===b.trim(o.replace($t,""))&&n.removeAttribute&&(n.removeAttribute("filter"),""===t||r&&!r.filter)||(n.filter=$t.test(o)?o.replace($t,i):o+" "+i)}}),b(function(){b.support.reliableMarginRight||(b.cssHooks.marginRight={get:function(e,n){return n?b.swap(e,{display:"inline-block"},Wt,[e,"marginRight"]):t}}),!b.support.pixelPosition&&b.fn.position&&b.each(["top","left"],function(e,n){b.cssHooks[n]={get:function(e,r){return r?(r=Wt(e,n),Yt.test(r)?b(e).position()[n]+"px":r):t}}})}),b.expr&&b.expr.filters&&(b.expr.filters.hidden=function(e){return 0>=e.offsetWidth&&0>=e.offsetHeight||!b.support.reliableHiddenOffsets&&"none"===(e.style&&e.style.display||b.css(e,"display"))},b.expr.filters.visible=function(e){return!b.expr.filters.hidden(e)}),b.each({margin:"",padding:"",border:"Width"},function(e,t){b.cssHooks[e+t]={expand:function(n){var r=0,i={},o="string"==typeof n?n.split(" "):[n];for(;4>r;r++)i[e+Zt[r]+t]=o[r]||o[r-2]||o[0];return i}},Ut.test(e)||(b.cssHooks[e+t].set=on)});var cn=/%20/g,pn=/\[\]$/,fn=/\r?\n/g,dn=/^(?:submit|button|image|reset|file)$/i,hn=/^(?:input|select|textarea|keygen)/i;b.fn.extend({serialize:function(){return b.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var e=b.prop(this,"elements");return e?b.makeArray(e):this}).filter(function(){var e=this.type;return this.name&&!b(this).is(":disabled")&&hn.test(this.nodeName)&&!dn.test(e)&&(this.checked||!Nt.test(e))}).map(function(e,t){var n=b(this).val();return null==n?null:b.isArray(n)?b.map(n,function(e){return{name:t.name,value:e.replace(fn,"\r\n")}}):{name:t.name,value:n.replace(fn,"\r\n")}}).get()}}),b.param=function(e,n){var r,i=[],o=function(e,t){t=b.isFunction(t)?t():null==t?"":t,i[i.length]=encodeURIComponent(e)+"="+encodeURIComponent(t)};if(n===t&&(n=b.ajaxSettings&&b.ajaxSettings.traditional),b.isArray(e)||e.jquery&&!b.isPlainObject(e))b.each(e,function(){o(this.name,this.value)});else for(r in e)gn(r,e[r],n,o);return i.join("&").replace(cn,"+")};function gn(e,t,n,r){var i;if(b.isArray(t))b.each(t,function(t,i){n||pn.test(e)?r(e,i):gn(e+"["+("object"==typeof i?t:"")+"]",i,n,r)});else if(n||"object"!==b.type(t))r(e,t);else for(i in t)gn(e+"["+i+"]",t[i],n,r)}b.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "),function(e,t){b.fn[t]=function(e,n){return arguments.length>0?this.on(t,null,e,n):this.trigger(t)}}),b.fn.hover=function(e,t){return this.mouseenter(e).mouseleave(t||e)};var mn,yn,vn=b.now(),bn=/\?/,xn=/#.*$/,wn=/([?&])_=[^&]*/,Tn=/^(.*?):[ \t]*([^\r\n]*)\r?$/gm,Nn=/^(?:about|app|app-storage|.+-extension|file|res|widget):$/,Cn=/^(?:GET|HEAD)$/,kn=/^\/\//,En=/^([\w.+-]+:)(?:\/\/([^\/?#:]*)(?::(\d+)|)|)/,Sn=b.fn.load,An={},jn={},Dn="*/".concat("*");try{yn=a.href}catch(Ln){yn=o.createElement("a"),yn.href="",yn=yn.href}mn=En.exec(yn.toLowerCase())||[];function Hn(e){return function(t,n){"string"!=typeof t&&(n=t,t="*");var r,i=0,o=t.toLowerCase().match(w)||[];if(b.isFunction(n))while(r=o[i++])"+"===r[0]?(r=r.slice(1)||"*",(e[r]=e[r]||[]).unshift(n)):(e[r]=e[r]||[]).push(n)}}function qn(e,n,r,i){var o={},a=e===jn;function s(u){var l;return o[u]=!0,b.each(e[u]||[],function(e,u){var c=u(n,r,i);return"string"!=typeof c||a||o[c]?a?!(l=c):t:(n.dataTypes.unshift(c),s(c),!1)}),l}return s(n.dataTypes[0])||!o["*"]&&s("*")}function Mn(e,n){var r,i,o=b.ajaxSettings.flatOptions||{};for(i in n)n[i]!==t&&((o[i]?e:r||(r={}))[i]=n[i]);return r&&b.extend(!0,e,r),e}b.fn.load=function(e,n,r){if("string"!=typeof e&&Sn)return Sn.apply(this,arguments);var i,o,a,s=this,u=e.indexOf(" ");return u>=0&&(i=e.slice(u,e.length),e=e.slice(0,u)),b.isFunction(n)?(r=n,n=t):n&&"object"==typeof n&&(a="POST"),s.length>0&&b.ajax({url:e,type:a,dataType:"html",data:n}).done(function(e){o=arguments,s.html(i?b("<div>").append(b.parseHTML(e)).find(i):e)}).complete(r&&function(e,t){s.each(r,o||[e.responseText,t,e])}),this},b.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],function(e,t){b.fn[t]=function(e){return this.on(t,e)}}),b.each(["get","post"],function(e,n){b[n]=function(e,r,i,o){return b.isFunction(r)&&(o=o||i,i=r,r=t),b.ajax({url:e,type:n,dataType:o,data:r,success:i})}}),b.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:yn,type:"GET",isLocal:Nn.test(mn[1]),global:!0,processData:!0,async:!0,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":Dn,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/xml/,html:/html/,json:/json/},responseFields:{xml:"responseXML",text:"responseText"},converters:{"* text":e.String,"text html":!0,"text json":b.parseJSON,"text xml":b.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(e,t){return t?Mn(Mn(e,b.ajaxSettings),t):Mn(b.ajaxSettings,e)},ajaxPrefilter:Hn(An),ajaxTransport:Hn(jn),ajax:function(e,n){"object"==typeof e&&(n=e,e=t),n=n||{};var r,i,o,a,s,u,l,c,p=b.ajaxSetup({},n),f=p.context||p,d=p.context&&(f.nodeType||f.jquery)?b(f):b.event,h=b.Deferred(),g=b.Callbacks("once memory"),m=p.statusCode||{},y={},v={},x=0,T="canceled",N={readyState:0,getResponseHeader:function(e){var t;if(2===x){if(!c){c={};while(t=Tn.exec(a))c[t[1].toLowerCase()]=t[2]}t=c[e.toLowerCase()]}return null==t?null:t},getAllResponseHeaders:function(){return 2===x?a:null},setRequestHeader:function(e,t){var n=e.toLowerCase();return x||(e=v[n]=v[n]||e,y[e]=t),this},overrideMimeType:function(e){return x||(p.mimeType=e),this},statusCode:function(e){var t;if(e)if(2>x)for(t in e)m[t]=[m[t],e[t]];else N.always(e[N.status]);return this},abort:function(e){var t=e||T;return l&&l.abort(t),k(0,t),this}};if(h.promise(N).complete=g.add,N.success=N.done,N.error=N.fail,p.url=((e||p.url||yn)+"").replace(xn,"").replace(kn,mn[1]+"//"),p.type=n.method||n.type||p.method||p.type,p.dataTypes=b.trim(p.dataType||"*").toLowerCase().match(w)||[""],null==p.crossDomain&&(r=En.exec(p.url.toLowerCase()),p.crossDomain=!(!r||r[1]===mn[1]&&r[2]===mn[2]&&(r[3]||("http:"===r[1]?80:443))==(mn[3]||("http:"===mn[1]?80:443)))),p.data&&p.processData&&"string"!=typeof p.data&&(p.data=b.param(p.data,p.traditional)),qn(An,p,n,N),2===x)return N;u=p.global,u&&0===b.active++&&b.event.trigger("ajaxStart"),p.type=p.type.toUpperCase(),p.hasContent=!Cn.test(p.type),o=p.url,p.hasContent||(p.data&&(o=p.url+=(bn.test(o)?"&":"?")+p.data,delete p.data),p.cache===!1&&(p.url=wn.test(o)?o.replace(wn,"$1_="+vn++):o+(bn.test(o)?"&":"?")+"_="+vn++)),p.ifModified&&(b.lastModified[o]&&N.setRequestHeader("If-Modified-Since",b.lastModified[o]),b.etag[o]&&N.setRequestHeader("If-None-Match",b.etag[o])),(p.data&&p.hasContent&&p.contentType!==!1||n.contentType)&&N.setRequestHeader("Content-Type",p.contentType),N.setRequestHeader("Accept",p.dataTypes[0]&&p.accepts[p.dataTypes[0]]?p.accepts[p.dataTypes[0]]+("*"!==p.dataTypes[0]?", "+Dn+"; q=0.01":""):p.accepts["*"]);for(i in p.headers)N.setRequestHeader(i,p.headers[i]);if(p.beforeSend&&(p.beforeSend.call(f,N,p)===!1||2===x))return N.abort();T="abort";for(i in{success:1,error:1,complete:1})N[i](p[i]);if(l=qn(jn,p,n,N)){N.readyState=1,u&&d.trigger("ajaxSend",[N,p]),p.async&&p.timeout>0&&(s=setTimeout(function(){N.abort("timeout")},p.timeout));try{x=1,l.send(y,k)}catch(C){if(!(2>x))throw C;k(-1,C)}}else k(-1,"No Transport");function k(e,n,r,i){var c,y,v,w,T,C=n;2!==x&&(x=2,s&&clearTimeout(s),l=t,a=i||"",N.readyState=e>0?4:0,r&&(w=_n(p,N,r)),e>=200&&300>e||304===e?(p.ifModified&&(T=N.getResponseHeader("Last-Modified"),T&&(b.lastModified[o]=T),T=N.getResponseHeader("etag"),T&&(b.etag[o]=T)),204===e?(c=!0,C="nocontent"):304===e?(c=!0,C="notmodified"):(c=Fn(p,w),C=c.state,y=c.data,v=c.error,c=!v)):(v=C,(e||!C)&&(C="error",0>e&&(e=0))),N.status=e,N.statusText=(n||C)+"",c?h.resolveWith(f,[y,C,N]):h.rejectWith(f,[N,C,v]),N.statusCode(m),m=t,u&&d.trigger(c?"ajaxSuccess":"ajaxError",[N,p,c?y:v]),g.fireWith(f,[N,C]),u&&(d.trigger("ajaxComplete",[N,p]),--b.active||b.event.trigger("ajaxStop")))}return N},getScript:function(e,n){return b.get(e,t,n,"script")},getJSON:function(e,t,n){return b.get(e,t,n,"json")}});function _n(e,n,r){var i,o,a,s,u=e.contents,l=e.dataTypes,c=e.responseFields;for(s in c)s in r&&(n[c[s]]=r[s]);while("*"===l[0])l.shift(),o===t&&(o=e.mimeType||n.getResponseHeader("Content-Type"));if(o)for(s in u)if(u[s]&&u[s].test(o)){l.unshift(s);break}if(l[0]in r)a=l[0];else{for(s in r){if(!l[0]||e.converters[s+" "+l[0]]){a=s;break}i||(i=s)}a=a||i}return a?(a!==l[0]&&l.unshift(a),r[a]):t}function Fn(e,t){var n,r,i,o,a={},s=0,u=e.dataTypes.slice(),l=u[0];if(e.dataFilter&&(t=e.dataFilter(t,e.dataType)),u[1])for(i in e.converters)a[i.toLowerCase()]=e.converters[i];for(;r=u[++s];)if("*"!==r){if("*"!==l&&l!==r){if(i=a[l+" "+r]||a["* "+r],!i)for(n in a)if(o=n.split(" "),o[1]===r&&(i=a[l+" "+o[0]]||a["* "+o[0]])){i===!0?i=a[n]:a[n]!==!0&&(r=o[0],u.splice(s--,0,r));break}if(i!==!0)if(i&&e["throws"])t=i(t);else try{t=i(t)}catch(c){return{state:"parsererror",error:i?c:"No conversion from "+l+" to "+r}}}l=r}return{state:"success",data:t}}b.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/(?:java|ecma)script/},converters:{"text script":function(e){return b.globalEval(e),e}}}),b.ajaxPrefilter("script",function(e){e.cache===t&&(e.cache=!1),e.crossDomain&&(e.type="GET",e.global=!1)}),b.ajaxTransport("script",function(e){if(e.crossDomain){var n,r=o.head||b("head")[0]||o.documentElement;return{send:function(t,i){n=o.createElement("script"),n.async=!0,e.scriptCharset&&(n.charset=e.scriptCharset),n.src=e.url,n.onload=n.onreadystatechange=function(e,t){(t||!n.readyState||/loaded|complete/.test(n.readyState))&&(n.onload=n.onreadystatechange=null,n.parentNode&&n.parentNode.removeChild(n),n=null,t||i(200,"success"))},r.insertBefore(n,r.firstChild)},abort:function(){n&&n.onload(t,!0)}}}});var On=[],Bn=/(=)\?(?=&|$)|\?\?/;b.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var e=On.pop()||b.expando+"_"+vn++;return this[e]=!0,e}}),b.ajaxPrefilter("json jsonp",function(n,r,i){var o,a,s,u=n.jsonp!==!1&&(Bn.test(n.url)?"url":"string"==typeof n.data&&!(n.contentType||"").indexOf("application/x-www-form-urlencoded")&&Bn.test(n.data)&&"data");return u||"jsonp"===n.dataTypes[0]?(o=n.jsonpCallback=b.isFunction(n.jsonpCallback)?n.jsonpCallback():n.jsonpCallback,u?n[u]=n[u].replace(Bn,"$1"+o):n.jsonp!==!1&&(n.url+=(bn.test(n.url)?"&":"?")+n.jsonp+"="+o),n.converters["script json"]=function(){return s||b.error(o+" was not called"),s[0]},n.dataTypes[0]="json",a=e[o],e[o]=function(){s=arguments},i.always(function(){e[o]=a,n[o]&&(n.jsonpCallback=r.jsonpCallback,On.push(o)),s&&b.isFunction(a)&&a(s[0]),s=a=t}),"script"):t});var Pn,Rn,Wn=0,$n=e.ActiveXObject&&function(){var e;for(e in Pn)Pn[e](t,!0)};function In(){try{return new e.XMLHttpRequest}catch(t){}}function zn(){try{return new e.ActiveXObject("Microsoft.XMLHTTP")}catch(t){}}b.ajaxSettings.xhr=e.ActiveXObject?function(){return!this.isLocal&&In()||zn()}:In,Rn=b.ajaxSettings.xhr(),b.support.cors=!!Rn&&"withCredentials"in Rn,Rn=b.support.ajax=!!Rn,Rn&&b.ajaxTransport(function(n){if(!n.crossDomain||b.support.cors){var r;return{send:function(i,o){var a,s,u=n.xhr();if(n.username?u.open(n.type,n.url,n.async,n.username,n.password):u.open(n.type,n.url,n.async),n.xhrFields)for(s in n.xhrFields)u[s]=n.xhrFields[s];n.mimeType&&u.overrideMimeType&&u.overrideMimeType(n.mimeType),n.crossDomain||i["X-Requested-With"]||(i["X-Requested-With"]="XMLHttpRequest");try{for(s in i)u.setRequestHeader(s,i[s])}catch(l){}u.send(n.hasContent&&n.data||null),r=function(e,i){var s,l,c,p;try{if(r&&(i||4===u.readyState))if(r=t,a&&(u.onreadystatechange=b.noop,$n&&delete Pn[a]),i)4!==u.readyState&&u.abort();else{p={},s=u.status,l=u.getAllResponseHeaders(),"string"==typeof u.responseText&&(p.text=u.responseText);try{c=u.statusText}catch(f){c=""}s||!n.isLocal||n.crossDomain?1223===s&&(s=204):s=p.text?200:404}}catch(d){i||o(-1,d)}p&&o(s,c,p,l)},n.async?4===u.readyState?setTimeout(r):(a=++Wn,$n&&(Pn||(Pn={},b(e).unload($n)),Pn[a]=r),u.onreadystatechange=r):r()},abort:function(){r&&r(t,!0)}}}});var Xn,Un,Vn=/^(?:toggle|show|hide)$/,Yn=RegExp("^(?:([+-])=|)("+x+")([a-z%]*)$","i"),Jn=/queueHooks$/,Gn=[nr],Qn={"*":[function(e,t){var n,r,i=this.createTween(e,t),o=Yn.exec(t),a=i.cur(),s=+a||0,u=1,l=20;if(o){if(n=+o[2],r=o[3]||(b.cssNumber[e]?"":"px"),"px"!==r&&s){s=b.css(i.elem,e,!0)||n||1;do u=u||".5",s/=u,b.style(i.elem,e,s+r);while(u!==(u=i.cur()/a)&&1!==u&&--l)}i.unit=r,i.start=s,i.end=o[1]?s+(o[1]+1)*n:n}return i}]};function Kn(){return setTimeout(function(){Xn=t}),Xn=b.now()}function Zn(e,t){b.each(t,function(t,n){var r=(Qn[t]||[]).concat(Qn["*"]),i=0,o=r.length;for(;o>i;i++)if(r[i].call(e,t,n))return})}function er(e,t,n){var r,i,o=0,a=Gn.length,s=b.Deferred().always(function(){delete u.elem}),u=function(){if(i)return!1;var t=Xn||Kn(),n=Math.max(0,l.startTime+l.duration-t),r=n/l.duration||0,o=1-r,a=0,u=l.tweens.length;for(;u>a;a++)l.tweens[a].run(o);return s.notifyWith(e,[l,o,n]),1>o&&u?n:(s.resolveWith(e,[l]),!1)},l=s.promise({elem:e,props:b.extend({},t),opts:b.extend(!0,{specialEasing:{}},n),originalProperties:t,originalOptions:n,startTime:Xn||Kn(),duration:n.duration,tweens:[],createTween:function(t,n){var r=b.Tween(e,l.opts,t,n,l.opts.specialEasing[t]||l.opts.easing);return l.tweens.push(r),r},stop:function(t){var n=0,r=t?l.tweens.length:0;if(i)return this;for(i=!0;r>n;n++)l.tweens[n].run(1);return t?s.resolveWith(e,[l,t]):s.rejectWith(e,[l,t]),this}}),c=l.props;for(tr(c,l.opts.specialEasing);a>o;o++)if(r=Gn[o].call(l,e,c,l.opts))return r;return Zn(l,c),b.isFunction(l.opts.start)&&l.opts.start.call(e,l),b.fx.timer(b.extend(u,{elem:e,anim:l,queue:l.opts.queue})),l.progress(l.opts.progress).done(l.opts.done,l.opts.complete).fail(l.opts.fail).always(l.opts.always)}function tr(e,t){var n,r,i,o,a;for(i in e)if(r=b.camelCase(i),o=t[r],n=e[i],b.isArray(n)&&(o=n[1],n=e[i]=n[0]),i!==r&&(e[r]=n,delete e[i]),a=b.cssHooks[r],a&&"expand"in a){n=a.expand(n),delete e[r];for(i in n)i in e||(e[i]=n[i],t[i]=o)}else t[r]=o}b.Animation=b.extend(er,{tweener:function(e,t){b.isFunction(e)?(t=e,e=["*"]):e=e.split(" ");var n,r=0,i=e.length;for(;i>r;r++)n=e[r],Qn[n]=Qn[n]||[],Qn[n].unshift(t)},prefilter:function(e,t){t?Gn.unshift(e):Gn.push(e)}});function nr(e,t,n){var r,i,o,a,s,u,l,c,p,f=this,d=e.style,h={},g=[],m=e.nodeType&&nn(e);n.queue||(c=b._queueHooks(e,"fx"),null==c.unqueued&&(c.unqueued=0,p=c.empty.fire,c.empty.fire=function(){c.unqueued||p()}),c.unqueued++,f.always(function(){f.always(function(){c.unqueued--,b.queue(e,"fx").length||c.empty.fire()})})),1===e.nodeType&&("height"in t||"width"in t)&&(n.overflow=[d.overflow,d.overflowX,d.overflowY],"inline"===b.css(e,"display")&&"none"===b.css(e,"float")&&(b.support.inlineBlockNeedsLayout&&"inline"!==un(e.nodeName)?d.zoom=1:d.display="inline-block")),n.overflow&&(d.overflow="hidden",b.support.shrinkWrapBlocks||f.always(function(){d.overflow=n.overflow[0],d.overflowX=n.overflow[1],d.overflowY=n.overflow[2]}));for(i in t)if(a=t[i],Vn.exec(a)){if(delete t[i],u=u||"toggle"===a,a===(m?"hide":"show"))continue;g.push(i)}if(o=g.length){s=b._data(e,"fxshow")||b._data(e,"fxshow",{}),"hidden"in s&&(m=s.hidden),u&&(s.hidden=!m),m?b(e).show():f.done(function(){b(e).hide()}),f.done(function(){var t;b._removeData(e,"fxshow");for(t in h)b.style(e,t,h[t])});for(i=0;o>i;i++)r=g[i],l=f.createTween(r,m?s[r]:0),h[r]=s[r]||b.style(e,r),r in s||(s[r]=l.start,m&&(l.end=l.start,l.start="width"===r||"height"===r?1:0))}}function rr(e,t,n,r,i){return new rr.prototype.init(e,t,n,r,i)}b.Tween=rr,rr.prototype={constructor:rr,init:function(e,t,n,r,i,o){this.elem=e,this.prop=n,this.easing=i||"swing",this.options=t,this.start=this.now=this.cur(),this.end=r,this.unit=o||(b.cssNumber[n]?"":"px")},cur:function(){var e=rr.propHooks[this.prop];return e&&e.get?e.get(this):rr.propHooks._default.get(this)},run:function(e){var t,n=rr.propHooks[this.prop];return this.pos=t=this.options.duration?b.easing[this.easing](e,this.options.duration*e,0,1,this.options.duration):e,this.now=(this.end-this.start)*t+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),n&&n.set?n.set(this):rr.propHooks._default.set(this),this}},rr.prototype.init.prototype=rr.prototype,rr.propHooks={_default:{get:function(e){var t;return null==e.elem[e.prop]||e.elem.style&&null!=e.elem.style[e.prop]?(t=b.css(e.elem,e.prop,""),t&&"auto"!==t?t:0):e.elem[e.prop]},set:function(e){b.fx.step[e.prop]?b.fx.step[e.prop](e):e.elem.style&&(null!=e.elem.style[b.cssProps[e.prop]]||b.cssHooks[e.prop])?b.style(e.elem,e.prop,e.now+e.unit):e.elem[e.prop]=e.now}}},rr.propHooks.scrollTop=rr.propHooks.scrollLeft={set:function(e){e.elem.nodeType&&e.elem.parentNode&&(e.elem[e.prop]=e.now)}},b.each(["toggle","show","hide"],function(e,t){var n=b.fn[t];b.fn[t]=function(e,r,i){return null==e||"boolean"==typeof e?n.apply(this,arguments):this.animate(ir(t,!0),e,r,i)}}),b.fn.extend({fadeTo:function(e,t,n,r){return this.filter(nn).css("opacity",0).show().end().animate({opacity:t},e,n,r)},animate:function(e,t,n,r){var i=b.isEmptyObject(e),o=b.speed(t,n,r),a=function(){var t=er(this,b.extend({},e),o);a.finish=function(){t.stop(!0)},(i||b._data(this,"finish"))&&t.stop(!0)};return a.finish=a,i||o.queue===!1?this.each(a):this.queue(o.queue,a)},stop:function(e,n,r){var i=function(e){var t=e.stop;delete e.stop,t(r)};return"string"!=typeof e&&(r=n,n=e,e=t),n&&e!==!1&&this.queue(e||"fx",[]),this.each(function(){var t=!0,n=null!=e&&e+"queueHooks",o=b.timers,a=b._data(this);if(n)a[n]&&a[n].stop&&i(a[n]);else for(n in a)a[n]&&a[n].stop&&Jn.test(n)&&i(a[n]);for(n=o.length;n--;)o[n].elem!==this||null!=e&&o[n].queue!==e||(o[n].anim.stop(r),t=!1,o.splice(n,1));(t||!r)&&b.dequeue(this,e)})},finish:function(e){return e!==!1&&(e=e||"fx"),this.each(function(){var t,n=b._data(this),r=n[e+"queue"],i=n[e+"queueHooks"],o=b.timers,a=r?r.length:0;for(n.finish=!0,b.queue(this,e,[]),i&&i.cur&&i.cur.finish&&i.cur.finish.call(this),t=o.length;t--;)o[t].elem===this&&o[t].queue===e&&(o[t].anim.stop(!0),o.splice(t,1));for(t=0;a>t;t++)r[t]&&r[t].finish&&r[t].finish.call(this);delete n.finish})}});function ir(e,t){var n,r={height:e},i=0;for(t=t?1:0;4>i;i+=2-t)n=Zt[i],r["margin"+n]=r["padding"+n]=e;return t&&(r.opacity=r.width=e),r}b.each({slideDown:ir("show"),slideUp:ir("hide"),slideToggle:ir("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(e,t){b.fn[e]=function(e,n,r){return this.animate(t,e,n,r)}}),b.speed=function(e,t,n){var r=e&&"object"==typeof e?b.extend({},e):{complete:n||!n&&t||b.isFunction(e)&&e,duration:e,easing:n&&t||t&&!b.isFunction(t)&&t};return r.duration=b.fx.off?0:"number"==typeof r.duration?r.duration:r.duration in b.fx.speeds?b.fx.speeds[r.duration]:b.fx.speeds._default,(null==r.queue||r.queue===!0)&&(r.queue="fx"),r.old=r.complete,r.complete=function(){b.isFunction(r.old)&&r.old.call(this),r.queue&&b.dequeue(this,r.queue)},r},b.easing={linear:function(e){return e},swing:function(e){return.5-Math.cos(e*Math.PI)/2}},b.timers=[],b.fx=rr.prototype.init,b.fx.tick=function(){var e,n=b.timers,r=0;for(Xn=b.now();n.length>r;r++)e=n[r],e()||n[r]!==e||n.splice(r--,1);n.length||b.fx.stop(),Xn=t},b.fx.timer=function(e){e()&&b.timers.push(e)&&b.fx.start()},b.fx.interval=13,b.fx.start=function(){Un||(Un=setInterval(b.fx.tick,b.fx.interval))},b.fx.stop=function(){clearInterval(Un),Un=null},b.fx.speeds={slow:600,fast:200,_default:400},b.fx.step={},b.expr&&b.expr.filters&&(b.expr.filters.animated=function(e){return b.grep(b.timers,function(t){return e===t.elem}).length}),b.fn.offset=function(e){if(arguments.length)return e===t?this:this.each(function(t){b.offset.setOffset(this,e,t)});var n,r,o={top:0,left:0},a=this[0],s=a&&a.ownerDocument;if(s)return n=s.documentElement,b.contains(n,a)?(typeof a.getBoundingClientRect!==i&&(o=a.getBoundingClientRect()),r=or(s),{top:o.top+(r.pageYOffset||n.scrollTop)-(n.clientTop||0),left:o.left+(r.pageXOffset||n.scrollLeft)-(n.clientLeft||0)}):o},b.offset={setOffset:function(e,t,n){var r=b.css(e,"position");"static"===r&&(e.style.position="relative");var i=b(e),o=i.offset(),a=b.css(e,"top"),s=b.css(e,"left"),u=("absolute"===r||"fixed"===r)&&b.inArray("auto",[a,s])>-1,l={},c={},p,f;u?(c=i.position(),p=c.top,f=c.left):(p=parseFloat(a)||0,f=parseFloat(s)||0),b.isFunction(t)&&(t=t.call(e,n,o)),null!=t.top&&(l.top=t.top-o.top+p),null!=t.left&&(l.left=t.left-o.left+f),"using"in t?t.using.call(e,l):i.css(l)}},b.fn.extend({position:function(){if(this[0]){var e,t,n={top:0,left:0},r=this[0];return"fixed"===b.css(r,"position")?t=r.getBoundingClientRect():(e=this.offsetParent(),t=this.offset(),b.nodeName(e[0],"html")||(n=e.offset()),n.top+=b.css(e[0],"borderTopWidth",!0),n.left+=b.css(e[0],"borderLeftWidth",!0)),{top:t.top-n.top-b.css(r,"marginTop",!0),left:t.left-n.left-b.css(r,"marginLeft",!0)}}},offsetParent:function(){return this.map(function(){var e=this.offsetParent||o.documentElement;while(e&&!b.nodeName(e,"html")&&"static"===b.css(e,"position"))e=e.offsetParent;return e||o.documentElement})}}),b.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(e,n){var r=/Y/.test(n);b.fn[e]=function(i){return b.access(this,function(e,i,o){var a=or(e);return o===t?a?n in a?a[n]:a.document.documentElement[i]:e[i]:(a?a.scrollTo(r?b(a).scrollLeft():o,r?o:b(a).scrollTop()):e[i]=o,t)},e,i,arguments.length,null)}});function or(e){return b.isWindow(e)?e:9===e.nodeType?e.defaultView||e.parentWindow:!1}b.each({Height:"height",Width:"width"},function(e,n){b.each({padding:"inner"+e,content:n,"":"outer"+e},function(r,i){b.fn[i]=function(i,o){var a=arguments.length&&(r||"boolean"!=typeof i),s=r||(i===!0||o===!0?"margin":"border");return b.access(this,function(n,r,i){var o;return b.isWindow(n)?n.document.documentElement["client"+e]:9===n.nodeType?(o=n.documentElement,Math.max(n.body["scroll"+e],o["scroll"+e],n.body["offset"+e],o["offset"+e],o["client"+e])):i===t?b.css(n,r,s):b.style(n,r,i,s)},n,a?i:t,a,null)}})}),e.jQuery=e.$=b,"function"==typeof define&&define.amd&&define.amd.jQuery&&define("jquery",[],function(){return b})})(window);

/* AKTODO THESE ARE NEW LIBRARIES */

/*! Picturefill - v2.3.1 - 2015-04-09
* http://scottjehl.github.io/picturefill
* Copyright (c) 2015 https://github.com/scottjehl/picturefill/blob/master/Authors.txt; Licensed MIT */
window.matchMedia||(window.matchMedia=function(){"use strict";var a=window.styleMedia||window.media;if(!a){var b=document.createElement("style"),c=document.getElementsByTagName("script")[0],d=null;b.type="text/css",b.id="matchmediajs-test",c.parentNode.insertBefore(b,c),d="getComputedStyle"in window&&window.getComputedStyle(b,null)||b.currentStyle,a={matchMedium:function(a){var c="@media "+a+"{ #matchmediajs-test { width: 1px; } }";return b.styleSheet?b.styleSheet.cssText=c:b.textContent=c,"1px"===d.width}}}return function(b){return{matches:a.matchMedium(b||"all"),media:b||"all"}}}()),function(a,b,c){"use strict";function d(b){"object"==typeof module&&"object"==typeof module.exports?module.exports=b:"function"==typeof define&&define.amd&&define("picturefill",function(){return b}),"object"==typeof a&&(a.picturefill=b)}function e(a){var b,c,d,e,f,i=a||{};b=i.elements||g.getAllElements();for(var j=0,k=b.length;k>j;j++)if(c=b[j],d=c.parentNode,e=void 0,f=void 0,"IMG"===c.nodeName.toUpperCase()&&(c[g.ns]||(c[g.ns]={}),i.reevaluate||!c[g.ns].evaluated)){if(d&&"PICTURE"===d.nodeName.toUpperCase()){if(g.removeVideoShim(d),e=g.getMatch(c,d),e===!1)continue}else e=void 0;(d&&"PICTURE"===d.nodeName.toUpperCase()||!g.sizesSupported&&c.srcset&&h.test(c.srcset))&&g.dodgeSrcset(c),e?(f=g.processSourceSet(e),g.applyBestCandidate(f,c)):(f=g.processSourceSet(c),(void 0===c.srcset||c[g.ns].srcset)&&g.applyBestCandidate(f,c)),c[g.ns].evaluated=!0}}function f(){function c(){clearTimeout(d),d=setTimeout(h,60)}g.initTypeDetects(),e();var d,f=setInterval(function(){return e(),/^loaded|^i|^c/.test(b.readyState)?void clearInterval(f):void 0},250),h=function(){e({reevaluate:!0})};a.addEventListener?a.addEventListener("resize",c,!1):a.attachEvent&&a.attachEvent("onresize",c)}if(a.HTMLPictureElement)return void d(function(){});b.createElement("picture");var g=a.picturefill||{},h=/\s+\+?\d+(e\d+)?w/;g.ns="picturefill",function(){g.srcsetSupported="srcset"in c,g.sizesSupported="sizes"in c,g.curSrcSupported="currentSrc"in c}(),g.trim=function(a){return a.trim?a.trim():a.replace(/^\s+|\s+$/g,"")},g.makeUrl=function(){var a=b.createElement("a");return function(b){return a.href=b,a.href}}(),g.restrictsMixedContent=function(){return"https:"===a.location.protocol},g.matchesMedia=function(b){return a.matchMedia&&a.matchMedia(b).matches},g.getDpr=function(){return a.devicePixelRatio||1},g.getWidthFromLength=function(a){var c;if(!a||a.indexOf("%")>-1!=!1||!(parseFloat(a)>0||a.indexOf("calc(")>-1))return!1;a=a.replace("vw","%"),g.lengthEl||(g.lengthEl=b.createElement("div"),g.lengthEl.style.cssText="border:0;display:block;font-size:1em;left:0;margin:0;padding:0;position:absolute;visibility:hidden",g.lengthEl.className="helper-from-picturefill-js"),g.lengthEl.style.width="0px";try{g.lengthEl.style.width=a}catch(d){}return b.body.appendChild(g.lengthEl),c=g.lengthEl.offsetWidth,0>=c&&(c=!1),b.body.removeChild(g.lengthEl),c},g.detectTypeSupport=function(b,c){var d=new a.Image;return d.onerror=function(){g.types[b]=!1,e()},d.onload=function(){g.types[b]=1===d.width,e()},d.src=c,"pending"},g.types=g.types||{},g.initTypeDetects=function(){g.types["image/jpeg"]=!0,g.types["image/gif"]=!0,g.types["image/png"]=!0,g.types["image/svg+xml"]=b.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#Image","1.1"),g.types["image/webp"]=g.detectTypeSupport("image/webp","data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=")},g.verifyTypeSupport=function(a){var b=a.getAttribute("type");if(null===b||""===b)return!0;var c=g.types[b];return"string"==typeof c&&"pending"!==c?(g.types[b]=g.detectTypeSupport(b,c),"pending"):"function"==typeof c?(c(),"pending"):c},g.parseSize=function(a){var b=/(\([^)]+\))?\s*(.+)/g.exec(a);return{media:b&&b[1],length:b&&b[2]}},g.findWidthFromSourceSize=function(c){for(var d,e=g.trim(c).split(/\s*,\s*/),f=0,h=e.length;h>f;f++){var i=e[f],j=g.parseSize(i),k=j.length,l=j.media;if(k&&(!l||g.matchesMedia(l))&&(d=g.getWidthFromLength(k)))break}return d||Math.max(a.innerWidth||0,b.documentElement.clientWidth)},g.parseSrcset=function(a){for(var b=[];""!==a;){a=a.replace(/^\s+/g,"");var c,d=a.search(/\s/g),e=null;if(-1!==d){c=a.slice(0,d);var f=c.slice(-1);if((","===f||""===c)&&(c=c.replace(/,+$/,""),e=""),a=a.slice(d+1),null===e){var g=a.indexOf(",");-1!==g?(e=a.slice(0,g),a=a.slice(g+1)):(e=a,a="")}}else c=a,a="";(c||e)&&b.push({url:c,descriptor:e})}return b},g.parseDescriptor=function(a,b){var c,d=b||"100vw",e=a&&a.replace(/(^\s+|\s+$)/g,""),f=g.findWidthFromSourceSize(d);if(e)for(var h=e.split(" "),i=h.length-1;i>=0;i--){var j=h[i],k=j&&j.slice(j.length-1);if("h"!==k&&"w"!==k||g.sizesSupported){if("x"===k){var l=j&&parseFloat(j,10);c=l&&!isNaN(l)?l:1}}else c=parseFloat(parseInt(j,10)/f)}return c||1},g.getCandidatesFromSourceSet=function(a,b){for(var c=g.parseSrcset(a),d=[],e=0,f=c.length;f>e;e++){var h=c[e];d.push({url:h.url,resolution:g.parseDescriptor(h.descriptor,b)})}return d},g.dodgeSrcset=function(a){a.srcset&&(a[g.ns].srcset=a.srcset,a.srcset="",a.setAttribute("data-pfsrcset",a[g.ns].srcset))},g.processSourceSet=function(a){var b=a.getAttribute("srcset"),c=a.getAttribute("sizes"),d=[];return"IMG"===a.nodeName.toUpperCase()&&a[g.ns]&&a[g.ns].srcset&&(b=a[g.ns].srcset),b&&(d=g.getCandidatesFromSourceSet(b,c)),d},g.backfaceVisibilityFix=function(a){var b=a.style||{},c="webkitBackfaceVisibility"in b,d=b.zoom;c&&(b.zoom=".999",c=a.offsetWidth,b.zoom=d)},g.setIntrinsicSize=function(){var c={},d=function(a,b,c){b&&a.setAttribute("width",parseInt(b/c,10))};return function(e,f){var h;e[g.ns]&&!a.pfStopIntrinsicSize&&(void 0===e[g.ns].dims&&(e[g.ns].dims=e.getAttribute("width")||e.getAttribute("height")),e[g.ns].dims||(f.url in c?d(e,c[f.url],f.resolution):(h=b.createElement("img"),h.onload=function(){if(c[f.url]=h.width,!c[f.url])try{b.body.appendChild(h),c[f.url]=h.width||h.offsetWidth,b.body.removeChild(h)}catch(a){}e.src===f.url&&d(e,c[f.url],f.resolution),e=null,h.onload=null,h=null},h.src=f.url)))}}(),g.applyBestCandidate=function(a,b){var c,d,e;a.sort(g.ascendingSort),d=a.length,e=a[d-1];for(var f=0;d>f;f++)if(c=a[f],c.resolution>=g.getDpr()){e=c;break}e&&(e.url=g.makeUrl(e.url),b.src!==e.url&&(g.restrictsMixedContent()&&"http:"===e.url.substr(0,"http:".length).toLowerCase()?void 0!==window.console&&console.warn("Blocked mixed content image "+e.url):(b.src=e.url,g.curSrcSupported||(b.currentSrc=b.src),g.backfaceVisibilityFix(b))),g.setIntrinsicSize(b,e))},g.ascendingSort=function(a,b){return a.resolution-b.resolution},g.removeVideoShim=function(a){var b=a.getElementsByTagName("video");if(b.length){for(var c=b[0],d=c.getElementsByTagName("source");d.length;)a.insertBefore(d[0],c);c.parentNode.removeChild(c)}},g.getAllElements=function(){for(var a=[],c=b.getElementsByTagName("img"),d=0,e=c.length;e>d;d++){var f=c[d];("PICTURE"===f.parentNode.nodeName.toUpperCase()||null!==f.getAttribute("srcset")||f[g.ns]&&null!==f[g.ns].srcset)&&a.push(f)}return a},g.getMatch=function(a,b){for(var c,d=b.childNodes,e=0,f=d.length;f>e;e++){var h=d[e];if(1===h.nodeType){if(h===a)return c;if("SOURCE"===h.nodeName.toUpperCase()){null!==h.getAttribute("src")&&void 0!==typeof console&&console.warn("The `src` attribute is invalid on `picture` `source` element; instead, use `srcset`.");var i=h.getAttribute("media");if(h.getAttribute("srcset")&&(!i||g.matchesMedia(i))){var j=g.verifyTypeSupport(h);if(j===!0){c=h;break}if("pending"===j)return!1}}}}return c},f(),e._=g,d(e)}(window,window.document,new window.Image);



!function(a,b){"function"==typeof define&&define.amd?define(["jquery"],function(a){return b(a)}):"object"==typeof exports?module.exports=b(require("jquery")):b(a.jQuery)}(this,function(a){!function(){"use strict";function b(b,d){if(this.el=b,this.$el=a(b),this.s=a.extend({},c,d),this.s.dynamic&&"undefined"!==this.s.dynamicEl&&this.s.dynamicEl.constructor===Array&&!this.s.dynamicEl.length)throw"When using dynamic mode, you must also define dynamicEl as an Array.";return this.modules={},this.lGalleryOn=!1,this.lgBusy=!1,this.hideBartimeout=!1,this.isTouch="ontouchstart"in document.documentElement,this.s.slideEndAnimatoin&&(this.s.hideControlOnEnd=!1),this.s.dynamic?this.$items=this.s.dynamicEl:"this"===this.s.selector?this.$items=this.$el:""!==this.s.selector?this.s.selectWithin?this.$items=a(this.s.selectWithin).find(this.s.selector):this.$items=this.$el.find(a(this.s.selector)):this.$items=this.$el.children(),this.$slide="",this.$outer="",this.init(),this}var c={mode:"lg-slide",cssEasing:"ease",easing:"linear",speed:600,height:"100%",width:"100%",addClass:"",startClass:"lg-start-zoom",backdropDuration:150,hideBarsDelay:6e3,useLeft:!1,closable:!0,loop:!0,escKey:!0,keyPress:!0,controls:!0,slideEndAnimatoin:!0,hideControlOnEnd:!1,mousewheel:!0,getCaptionFromTitleOrAlt:!0,appendSubHtmlTo:".lg-sub-html",subHtmlSelectorRelative:!1,preload:1,showAfterLoad:!0,selector:"",selectWithin:"",nextHtml:"",prevHtml:"",index:!1,iframeMaxWidth:"100%",download:!0,counter:!0,appendCounterTo:".lg-toolbar",swipeThreshold:50,enableSwipe:!0,enableDrag:!0,dynamic:!1,dynamicEl:[],galleryId:1};b.prototype.init=function(){var b=this;b.s.preload>b.$items.length&&(b.s.preload=b.$items.length);var c=window.location.hash;c.indexOf("lg="+this.s.galleryId)>0&&(b.index=parseInt(c.split("&slide=")[1],10),a("body").addClass("lg-from-hash"),a("body").hasClass("lg-on")||(setTimeout(function(){b.build(b.index)}),a("body").addClass("lg-on"))),b.s.dynamic?(b.$el.trigger("onBeforeOpen.lg"),b.index=b.s.index||0,a("body").hasClass("lg-on")||setTimeout(function(){b.build(b.index),a("body").addClass("lg-on")})):b.$items.on("click.lgcustom",function(c){try{c.preventDefault(),c.preventDefault()}catch(a){c.returnValue=!1}b.$el.trigger("onBeforeOpen.lg"),b.index=b.s.index||b.$items.index(this),a("body").hasClass("lg-on")||(b.build(b.index),a("body").addClass("lg-on"))})},b.prototype.build=function(b){var c=this;c.structure(),a.each(a.fn.lightGallery.modules,function(b){c.modules[b]=new a.fn.lightGallery.modules[b](c.el)}),c.slide(b,!1,!1,!1),c.s.keyPress&&c.keyPress(),c.$items.length>1?(c.arrow(),setTimeout(function(){c.enableDrag(),c.enableSwipe()},50),c.s.mousewheel&&c.mousewheel()):c.$slide.on("click.lg",function(){c.$el.trigger("onSlideClick.lg")}),c.counter(),c.closeGallery(),c.$el.trigger("onAfterOpen.lg"),c.$outer.on("mousemove.lg click.lg touchstart.lg",function(){c.$outer.removeClass("lg-hide-items"),clearTimeout(c.hideBartimeout),c.hideBartimeout=setTimeout(function(){c.$outer.addClass("lg-hide-items")},c.s.hideBarsDelay)}),c.$outer.trigger("mousemove.lg")},b.prototype.structure=function(){var b,c="",d="",e=0,f="",g=this;for(a("body").append('<div class="lg-backdrop"></div>'),a(".lg-backdrop").css("transition-duration",this.s.backdropDuration+"ms"),e=0;e<this.$items.length;e++)c+='<div class="lg-item"></div>';if(this.s.controls&&this.$items.length>1&&(d='<div class="lg-actions"><button class="lg-prev lg-icon">'+this.s.prevHtml+'</button><button class="lg-next lg-icon">'+this.s.nextHtml+"</button></div>"),".lg-sub-html"===this.s.appendSubHtmlTo&&(f='<div class="lg-sub-html"></div>'),b='<div class="lg-outer '+this.s.addClass+" "+this.s.startClass+'"><div class="lg" style="width:'+this.s.width+"; height:"+this.s.height+'"><div class="lg-inner">'+c+'</div><div class="lg-toolbar lg-group"><span class="lg-close lg-icon"></span></div>'+d+f+"</div></div>",a("body").append(b),this.$outer=a(".lg-outer"),this.$slide=this.$outer.find(".lg-item"),this.s.useLeft?(this.$outer.addClass("lg-use-left"),this.s.mode="lg-slide"):this.$outer.addClass("lg-use-css3"),g.setTop(),a(window).on("resize.lg orientationchange.lg",function(){setTimeout(function(){g.setTop()},100)}),this.$slide.eq(this.index).addClass("lg-current"),this.doCss()?this.$outer.addClass("lg-css3"):(this.$outer.addClass("lg-css"),this.s.speed=0),this.$outer.addClass(this.s.mode),this.s.enableDrag&&this.$items.length>1&&this.$outer.addClass("lg-grab"),this.s.showAfterLoad&&this.$outer.addClass("lg-show-after-load"),this.doCss()){var h=this.$outer.find(".lg-inner");h.css("transition-timing-function",this.s.cssEasing),h.css("transition-duration",this.s.speed+"ms")}setTimeout(function(){a(".lg-backdrop").addClass("in")}),setTimeout(function(){g.$outer.addClass("lg-visible")},this.s.backdropDuration),this.s.download&&this.$outer.find(".lg-toolbar").append('<a id="lg-download" target="_blank" download class="lg-download lg-icon"></a>'),this.prevScrollTop=a(window).scrollTop()},b.prototype.setTop=function(){if("100%"!==this.s.height){var b=a(window).height(),c=(b-parseInt(this.s.height,10))/2,d=this.$outer.find(".lg");b>=parseInt(this.s.height,10)?d.css("top",c+"px"):d.css("top","0px")}},b.prototype.doCss=function(){var a=function(){var a=["transition","MozTransition","WebkitTransition","OTransition","msTransition","KhtmlTransition"],b=document.documentElement,c=0;for(c=0;c<a.length;c++)if(a[c]in b.style)return!0};return!!a()},b.prototype.isVideo=function(a,b){var c;if(c=this.s.dynamic?this.s.dynamicEl[b].html:this.$items.eq(b).attr("data-html"),!a)return c?{html5:!0}:(console.error("lightGallery :- data-src is not pvovided on slide item "+(b+1)+". Please make sure the selector property is properly configured. More info - http://sachinchoolur.github.io/lightGallery/demos/html-markup.html"),!1);var d=a.match(/\/\/(?:www\.)?youtu(?:\.be|be\.com)\/(?:watch\?v=|embed\/)?([a-z0-9\-\_\%]+)/i),e=a.match(/\/\/(?:www\.)?vimeo.com\/([0-9a-z\-_]+)/i),f=a.match(/\/\/(?:www\.)?dai.ly\/([0-9a-z\-_]+)/i),g=a.match(/\/\/(?:www\.)?(?:vk\.com|vkontakte\.ru)\/(?:video_ext\.php\?)(.*)/i);return d?{youtube:d}:e?{vimeo:e}:f?{dailymotion:f}:g?{vk:g}:void 0},b.prototype.counter=function(){this.s.counter&&a(this.s.appendCounterTo).append('<div id="lg-counter"><span id="lg-counter-current">'+(parseInt(this.index,10)+1)+'</span> / <span id="lg-counter-all">'+this.$items.length+"</span></div>")},b.prototype.addHtml=function(b){var c,d,e=null;if(this.s.dynamic?this.s.dynamicEl[b].subHtmlUrl?c=this.s.dynamicEl[b].subHtmlUrl:e=this.s.dynamicEl[b].subHtml:(d=this.$items.eq(b),d.attr("data-sub-html-url")?c=d.attr("data-sub-html-url"):(e=d.attr("data-sub-html"),this.s.getCaptionFromTitleOrAlt&&!e&&(e=d.attr("title")||d.find("img").first().attr("alt")))),!c)if("undefined"!=typeof e&&null!==e){var f=e.substring(0,1);"."!==f&&"#"!==f||(e=this.s.subHtmlSelectorRelative&&!this.s.dynamic?d.find(e).html():a(e).html())}else e="";".lg-sub-html"===this.s.appendSubHtmlTo?c?this.$outer.find(this.s.appendSubHtmlTo).load(c):this.$outer.find(this.s.appendSubHtmlTo).html(e):c?this.$slide.eq(b).load(c):this.$slide.eq(b).append(e),"undefined"!=typeof e&&null!==e&&(""===e?this.$outer.find(this.s.appendSubHtmlTo).addClass("lg-empty-html"):this.$outer.find(this.s.appendSubHtmlTo).removeClass("lg-empty-html")),this.$el.trigger("onAfterAppendSubHtml.lg",[b])},b.prototype.preload=function(a){var b=1,c=1;for(b=1;b<=this.s.preload&&!(b>=this.$items.length-a);b++)this.loadContent(a+b,!1,0);for(c=1;c<=this.s.preload&&!(a-c<0);c++)this.loadContent(a-c,!1,0)},b.prototype.loadContent=function(b,c,d){var e,f,g,h,i,j,k=this,l=!1,m=function(b){for(var c=[],d=[],e=0;e<b.length;e++){var g=b[e].split(" ");""===g[0]&&g.splice(0,1),d.push(g[0]),c.push(g[1])}for(var h=a(window).width(),i=0;i<c.length;i++)if(parseInt(c[i],10)>h){f=d[i];break}};if(k.s.dynamic){if(k.s.dynamicEl[b].poster&&(l=!0,g=k.s.dynamicEl[b].poster),j=k.s.dynamicEl[b].html,f=k.s.dynamicEl[b].src,k.s.dynamicEl[b].responsive){var n=k.s.dynamicEl[b].responsive.split(",");m(n)}h=k.s.dynamicEl[b].srcset,i=k.s.dynamicEl[b].sizes}else{if(k.$items.eq(b).attr("data-poster")&&(l=!0,g=k.$items.eq(b).attr("data-poster")),j=k.$items.eq(b).attr("data-html"),f=k.$items.eq(b).attr("href")||k.$items.eq(b).attr("data-src"),k.$items.eq(b).attr("data-responsive")){var o=k.$items.eq(b).attr("data-responsive").split(",");m(o)}h=k.$items.eq(b).attr("data-srcset"),i=k.$items.eq(b).attr("data-sizes")}var p=!1;k.s.dynamic?k.s.dynamicEl[b].iframe&&(p=!0):"true"===k.$items.eq(b).attr("data-iframe")&&(p=!0);var q=k.isVideo(f,b);if(!k.$slide.eq(b).hasClass("lg-loaded")){if(p)k.$slide.eq(b).prepend('<div class="lg-video-cont lg-has-iframe" style="max-width:'+k.s.iframeMaxWidth+'"><div class="lg-video"><iframe class="lg-object" frameborder="0" src="'+f+'"  allowfullscreen="true"></iframe></div></div>');else if(l){var r="";r=q&&q.youtube?"lg-has-youtube":q&&q.vimeo?"lg-has-vimeo":"lg-has-html5",k.$slide.eq(b).prepend('<div class="lg-video-cont '+r+' "><div class="lg-video"><span class="lg-video-play"></span><img class="lg-object lg-has-poster" src="'+g+'" /></div></div>')}else q?(k.$slide.eq(b).prepend('<div class="lg-video-cont "><div class="lg-video"></div></div>'),k.$el.trigger("hasVideo.lg",[b,f,j])):k.$slide.eq(b).prepend('<div class="lg-img-wrap"><img class="lg-object lg-image" src="'+f+'" /></div>');if(k.$el.trigger("onAferAppendSlide.lg",[b]),e=k.$slide.eq(b).find(".lg-object"),i&&e.attr("sizes",i),h){e.attr("srcset",h);try{picturefill({elements:[e[0]]})}catch(a){console.warn("lightGallery :- If you want srcset to be supported for older browser please include picturefil version 2 javascript library in your document.")}}".lg-sub-html"!==this.s.appendSubHtmlTo&&k.addHtml(b),k.$slide.eq(b).addClass("lg-loaded")}k.$slide.eq(b).find(".lg-object").on("load.lg error.lg",function(){var c=0;d&&!a("body").hasClass("lg-from-hash")&&(c=d),setTimeout(function(){k.$slide.eq(b).addClass("lg-complete"),k.$el.trigger("onSlideItemLoad.lg",[b,d||0])},c)}),q&&q.html5&&!l&&k.$slide.eq(b).addClass("lg-complete"),c===!0&&(k.$slide.eq(b).hasClass("lg-complete")?k.preload(b):k.$slide.eq(b).find(".lg-object").on("load.lg error.lg",function(){k.preload(b)}))},b.prototype.slide=function(b,c,d,e){var f=this.$outer.find(".lg-current").index(),g=this;if(!g.lGalleryOn||f!==b){var h=this.$slide.length,i=g.lGalleryOn?this.s.speed:0;if(!g.lgBusy){if(this.s.download){var j;j=g.s.dynamic?g.s.dynamicEl[b].downloadUrl!==!1&&(g.s.dynamicEl[b].downloadUrl||g.s.dynamicEl[b].src):"false"!==g.$items.eq(b).attr("data-download-url")&&(g.$items.eq(b).attr("data-download-url")||g.$items.eq(b).attr("href")||g.$items.eq(b).attr("data-src")),j?(a("#lg-download").attr("href",j),g.$outer.removeClass("lg-hide-download")):g.$outer.addClass("lg-hide-download")}if(this.$el.trigger("onBeforeSlide.lg",[f,b,c,d]),g.lgBusy=!0,clearTimeout(g.hideBartimeout),".lg-sub-html"===this.s.appendSubHtmlTo&&setTimeout(function(){g.addHtml(b)},i),this.arrowDisable(b),e||(b<f?e="prev":b>f&&(e="next")),c){this.$slide.removeClass("lg-prev-slide lg-current lg-next-slide");var k,l;h>2?(k=b-1,l=b+1,0===b&&f===h-1?(l=0,k=h-1):b===h-1&&0===f&&(l=0,k=h-1)):(k=0,l=1),"prev"===e?g.$slide.eq(l).addClass("lg-next-slide"):g.$slide.eq(k).addClass("lg-prev-slide"),g.$slide.eq(b).addClass("lg-current")}else g.$outer.addClass("lg-no-trans"),this.$slide.removeClass("lg-prev-slide lg-next-slide"),"prev"===e?(this.$slide.eq(b).addClass("lg-prev-slide"),this.$slide.eq(f).addClass("lg-next-slide")):(this.$slide.eq(b).addClass("lg-next-slide"),this.$slide.eq(f).addClass("lg-prev-slide")),setTimeout(function(){g.$slide.removeClass("lg-current"),g.$slide.eq(b).addClass("lg-current"),g.$outer.removeClass("lg-no-trans")},50);g.lGalleryOn?(setTimeout(function(){g.loadContent(b,!0,0)},this.s.speed+50),setTimeout(function(){g.lgBusy=!1,g.$el.trigger("onAfterSlide.lg",[f,b,c,d])},this.s.speed)):(g.loadContent(b,!0,g.s.backdropDuration),g.lgBusy=!1,g.$el.trigger("onAfterSlide.lg",[f,b,c,d])),g.lGalleryOn=!0,this.s.counter&&a("#lg-counter-current").text(b+1)}g.index=b}},b.prototype.goToNextSlide=function(a){var b=this,c=b.s.loop;a&&b.$slide.length<3&&(c=!1),b.lgBusy||(b.index+1<b.$slide.length?(b.index++,b.$el.trigger("onBeforeNextSlide.lg",[b.index]),b.slide(b.index,a,!1,"next")):c?(b.index=0,b.$el.trigger("onBeforeNextSlide.lg",[b.index]),b.slide(b.index,a,!1,"next")):b.s.slideEndAnimatoin&&!a&&(b.$outer.addClass("lg-right-end"),setTimeout(function(){b.$outer.removeClass("lg-right-end")},400)))},b.prototype.goToPrevSlide=function(a){var b=this,c=b.s.loop;a&&b.$slide.length<3&&(c=!1),b.lgBusy||(b.index>0?(b.index--,b.$el.trigger("onBeforePrevSlide.lg",[b.index,a]),b.slide(b.index,a,!1,"prev")):c?(b.index=b.$items.length-1,b.$el.trigger("onBeforePrevSlide.lg",[b.index,a]),b.slide(b.index,a,!1,"prev")):b.s.slideEndAnimatoin&&!a&&(b.$outer.addClass("lg-left-end"),setTimeout(function(){b.$outer.removeClass("lg-left-end")},400)))},b.prototype.keyPress=function(){var b=this;this.$items.length>1&&a(window).on("keyup.lg",function(a){b.$items.length>1&&(37===a.keyCode&&(a.preventDefault(),b.goToPrevSlide()),39===a.keyCode&&(a.preventDefault(),b.goToNextSlide()))}),a(window).on("keydown.lg",function(a){b.s.escKey===!0&&27===a.keyCode&&(a.preventDefault(),b.$outer.hasClass("lg-thumb-open")?b.$outer.removeClass("lg-thumb-open"):b.destroy())})},b.prototype.arrow=function(){var a=this;this.$outer.find(".lg-prev").on("click.lg",function(){a.goToPrevSlide()}),this.$outer.find(".lg-next").on("click.lg",function(){a.goToNextSlide()})},b.prototype.arrowDisable=function(a){!this.s.loop&&this.s.hideControlOnEnd&&(a+1<this.$slide.length?this.$outer.find(".lg-next").removeAttr("disabled").removeClass("disabled"):this.$outer.find(".lg-next").attr("disabled","disabled").addClass("disabled"),a>0?this.$outer.find(".lg-prev").removeAttr("disabled").removeClass("disabled"):this.$outer.find(".lg-prev").attr("disabled","disabled").addClass("disabled"))},b.prototype.setTranslate=function(a,b,c){this.s.useLeft?a.css("left",b):a.css({transform:"translate3d("+b+"px, "+c+"px, 0px)"})},b.prototype.touchMove=function(b,c){var d=c-b;Math.abs(d)>15&&(this.$outer.addClass("lg-dragging"),this.setTranslate(this.$slide.eq(this.index),d,0),this.setTranslate(a(".lg-prev-slide"),-this.$slide.eq(this.index).width()+d,0),this.setTranslate(a(".lg-next-slide"),this.$slide.eq(this.index).width()+d,0))},b.prototype.touchEnd=function(a){var b=this;"lg-slide"!==b.s.mode&&b.$outer.addClass("lg-slide"),this.$slide.not(".lg-current, .lg-prev-slide, .lg-next-slide").css("opacity","0"),setTimeout(function(){b.$outer.removeClass("lg-dragging"),a<0&&Math.abs(a)>b.s.swipeThreshold?b.goToNextSlide(!0):a>0&&Math.abs(a)>b.s.swipeThreshold?b.goToPrevSlide(!0):Math.abs(a)<5&&b.$el.trigger("onSlideClick.lg"),b.$slide.removeAttr("style")}),setTimeout(function(){b.$outer.hasClass("lg-dragging")||"lg-slide"===b.s.mode||b.$outer.removeClass("lg-slide")},b.s.speed+100)},b.prototype.enableSwipe=function(){var a=this,b=0,c=0,d=!1;a.s.enableSwipe&&a.doCss()&&(a.$slide.on("touchstart.lg",function(c){a.$outer.hasClass("lg-zoomed")||a.lgBusy||(c.preventDefault(),a.manageSwipeClass(),b=c.originalEvent.targetTouches[0].pageX)}),a.$slide.on("touchmove.lg",function(e){a.$outer.hasClass("lg-zoomed")||(e.preventDefault(),c=e.originalEvent.targetTouches[0].pageX,a.touchMove(b,c),d=!0)}),a.$slide.on("touchend.lg",function(){a.$outer.hasClass("lg-zoomed")||(d?(d=!1,a.touchEnd(c-b)):a.$el.trigger("onSlideClick.lg"))}))},b.prototype.enableDrag=function(){var b=this,c=0,d=0,e=!1,f=!1;b.s.enableDrag&&b.doCss()&&(b.$outer.on("mousedown.lg",function(d){b.$outer.hasClass("lg-zoomed")||b.lgBusy||a(d.target).text()||(d.preventDefault(),b.manageSwipeClass(),c=d.pageX,e=!0,b.$outer.scrollLeft+=1,b.$outer.scrollLeft-=1,b.$outer.removeClass("lg-grab").addClass("lg-grabbing"),b.$el.trigger("onDragstart.lg"))}),a(window).on("mousemove.lg",function(a){e&&(f=!0,d=a.pageX,b.touchMove(c,d),b.$el.trigger("onDragmove.lg"))}),a(window).on("mouseup.lg",function(g){f?(f=!1,b.touchEnd(d-c),b.$el.trigger("onDragend.lg")):(a(g.target).hasClass("lg-object")||a(g.target).hasClass("lg-video-play"))&&b.$el.trigger("onSlideClick.lg"),e&&(e=!1,b.$outer.removeClass("lg-grabbing").addClass("lg-grab"))}))},b.prototype.manageSwipeClass=function(){var a=this.index+1,b=this.index-1;this.s.loop&&this.$slide.length>2&&(0===this.index?b=this.$slide.length-1:this.index===this.$slide.length-1&&(a=0)),this.$slide.removeClass("lg-next-slide lg-prev-slide"),b>-1&&this.$slide.eq(b).addClass("lg-prev-slide"),this.$slide.eq(a).addClass("lg-next-slide")},b.prototype.mousewheel=function(){var a=this;a.$outer.on("mousewheel.lg",function(b){b.deltaY&&(b.deltaY>0?a.goToPrevSlide():a.goToNextSlide(),b.preventDefault())})},b.prototype.closeGallery=function(){var b=this,c=!1;this.$outer.find(".lg-close").on("click.lg",function(){b.destroy()}),b.s.closable&&(b.$outer.on("mousedown.lg",function(b){c=!!(a(b.target).is(".lg-outer")||a(b.target).is(".lg-item ")||a(b.target).is(".lg-img-wrap"))}),b.$outer.on("mousemove.lg",function(){c=!1}),b.$outer.on("mouseup.lg",function(d){(a(d.target).is(".lg-outer")||a(d.target).is(".lg-item ")||a(d.target).is(".lg-img-wrap")&&c)&&(b.$outer.hasClass("lg-dragging")||b.destroy())}))},b.prototype.destroy=function(b){var c=this;b||(c.$el.trigger("onBeforeClose.lg"),a(window).scrollTop(c.prevScrollTop)),b&&(c.s.dynamic||this.$items.off("click.lg click.lgcustom"),a.removeData(c.el,"lightGallery")),this.$el.off(".lg.tm"),a.each(a.fn.lightGallery.modules,function(a){c.modules[a]&&c.modules[a].destroy()}),this.lGalleryOn=!1,clearTimeout(c.hideBartimeout),this.hideBartimeout=!1,a(window).off(".lg"),a("body").removeClass("lg-on lg-from-hash"),c.$outer&&c.$outer.removeClass("lg-visible"),a(".lg-backdrop").removeClass("in"),setTimeout(function(){c.$outer&&c.$outer.remove(),a(".lg-backdrop").remove(),b||c.$el.trigger("onCloseAfter.lg")},c.s.backdropDuration+50)},a.fn.lightGallery=function(c){return this.each(function(){if(a.data(this,"lightGallery"))try{a(this).data("lightGallery").init()}catch(a){console.error("lightGallery has not initiated properly")}else a.data(this,"lightGallery",new b(this,c))})},a.fn.lightGallery.modules={}}()}),function(a,b){"function"==typeof define&&define.amd?define(["jquery"],function(a){return b(a)}):"object"==typeof exports?module.exports=b(require("jquery")):b(jQuery)}(this,function(a){!function(){"use strict";var b={autoplay:!1,pause:5e3,progressBar:!0,fourceAutoplay:!1,autoplayControls:!0,appendAutoplayControlsTo:".lg-toolbar"},c=function(c){return this.core=a(c).data("lightGallery"),this.$el=a(c),!(this.core.$items.length<2)&&(this.core.s=a.extend({},b,this.core.s),this.interval=!1,this.fromAuto=!0,this.canceledOnTouch=!1,this.fourceAutoplayTemp=this.core.s.fourceAutoplay,this.core.doCss()||(this.core.s.progressBar=!1),this.init(),this)};c.prototype.init=function(){var a=this;a.core.s.autoplayControls&&a.controls(),a.core.s.progressBar&&a.core.$outer.find(".lg").append('<div class="lg-progress-bar"><div class="lg-progress"></div></div>'),a.progress(),a.core.s.autoplay&&a.$el.one("onSlideItemLoad.lg.tm",function(){a.startlAuto()}),a.$el.on("onDragstart.lg.tm touchstart.lg.tm",function(){a.interval&&(a.cancelAuto(),a.canceledOnTouch=!0)}),a.$el.on("onDragend.lg.tm touchend.lg.tm onSlideClick.lg.tm",function(){!a.interval&&a.canceledOnTouch&&(a.startlAuto(),a.canceledOnTouch=!1)})},c.prototype.progress=function(){var a,b,c=this;c.$el.on("onBeforeSlide.lg.tm",function(){c.core.s.progressBar&&c.fromAuto&&(a=c.core.$outer.find(".lg-progress-bar"),b=c.core.$outer.find(".lg-progress"),c.interval&&(b.removeAttr("style"),a.removeClass("lg-start"),setTimeout(function(){b.css("transition","width "+(c.core.s.speed+c.core.s.pause)+"ms ease 0s"),a.addClass("lg-start")},20))),c.fromAuto||c.core.s.fourceAutoplay||c.cancelAuto(),c.fromAuto=!1})},c.prototype.controls=function(){var b=this,c='<span class="lg-autoplay-button lg-icon"></span>';a(this.core.s.appendAutoplayControlsTo).append(c),b.core.$outer.find(".lg-autoplay-button").on("click.lg",function(){a(b.core.$outer).hasClass("lg-show-autoplay")?(b.cancelAuto(),b.core.s.fourceAutoplay=!1):b.interval||(b.startlAuto(),b.core.s.fourceAutoplay=b.fourceAutoplayTemp)})},c.prototype.startlAuto=function(){var a=this;a.core.$outer.find(".lg-progress").css("transition","width "+(a.core.s.speed+a.core.s.pause)+"ms ease 0s"),a.core.$outer.addClass("lg-show-autoplay"),a.core.$outer.find(".lg-progress-bar").addClass("lg-start"),a.interval=setInterval(function(){a.core.index+1<a.core.$items.length?a.core.index++:a.core.index=0,a.fromAuto=!0,a.core.slide(a.core.index,!1,!1,"next")},a.core.s.speed+a.core.s.pause)},c.prototype.cancelAuto=function(){clearInterval(this.interval),this.interval=!1,this.core.$outer.find(".lg-progress").removeAttr("style"),this.core.$outer.removeClass("lg-show-autoplay"),this.core.$outer.find(".lg-progress-bar").removeClass("lg-start")},c.prototype.destroy=function(){this.cancelAuto(),this.core.$outer.find(".lg-progress-bar").remove()},a.fn.lightGallery.modules.autoplay=c}()}),function(a,b){"function"==typeof define&&define.amd?define(["jquery"],function(a){return b(a)}):"object"==typeof exports?module.exports=b(require("jquery")):b(jQuery)}(this,function(a){!function(){"use strict";var b={fullScreen:!0},c=function(c){return this.core=a(c).data("lightGallery"),this.$el=a(c),this.core.s=a.extend({},b,this.core.s),this.init(),this};c.prototype.init=function(){var a="";if(this.core.s.fullScreen){if(!(document.fullscreenEnabled||document.webkitFullscreenEnabled||document.mozFullScreenEnabled||document.msFullscreenEnabled))return;a='<span class="lg-fullscreen lg-icon"></span>',this.core.$outer.find(".lg-toolbar").append(a),this.fullScreen()}},c.prototype.requestFullscreen=function(){var a=document.documentElement;a.requestFullscreen?a.requestFullscreen():a.msRequestFullscreen?a.msRequestFullscreen():a.mozRequestFullScreen?a.mozRequestFullScreen():a.webkitRequestFullscreen&&a.webkitRequestFullscreen()},c.prototype.exitFullscreen=function(){document.exitFullscreen?document.exitFullscreen():document.msExitFullscreen?document.msExitFullscreen():document.mozCancelFullScreen?document.mozCancelFullScreen():document.webkitExitFullscreen&&document.webkitExitFullscreen()},c.prototype.fullScreen=function(){var b=this;a(document).on("fullscreenchange.lg webkitfullscreenchange.lg mozfullscreenchange.lg MSFullscreenChange.lg",function(){b.core.$outer.toggleClass("lg-fullscreen-on")}),this.core.$outer.find(".lg-fullscreen").on("click.lg",function(){document.fullscreenElement||document.mozFullScreenElement||document.webkitFullscreenElement||document.msFullscreenElement?b.exitFullscreen():b.requestFullscreen()})},c.prototype.destroy=function(){this.exitFullscreen(),a(document).off("fullscreenchange.lg webkitfullscreenchange.lg mozfullscreenchange.lg MSFullscreenChange.lg")},a.fn.lightGallery.modules.fullscreen=c}()}),function(a,b){"function"==typeof define&&define.amd?define(["jquery"],function(a){return b(a)}):"object"==typeof exports?module.exports=b(require("jquery")):b(jQuery)}(this,function(a){!function(){"use strict";var b={pager:!1},c=function(c){return this.core=a(c).data("lightGallery"),this.$el=a(c),this.core.s=a.extend({},b,this.core.s),this.core.s.pager&&this.core.$items.length>1&&this.init(),this};c.prototype.init=function(){var b,c,d,e=this,f="";if(e.core.$outer.find(".lg").append('<div class="lg-pager-outer"></div>'),e.core.s.dynamic)for(var g=0;g<e.core.s.dynamicEl.length;g++)f+='<span class="lg-pager-cont"> <span class="lg-pager"></span><div class="lg-pager-thumb-cont"><span class="lg-caret"></span> <img src="'+e.core.s.dynamicEl[g].thumb+'" /></div></span>';else e.core.$items.each(function(){f+=e.core.s.exThumbImage?'<span class="lg-pager-cont"> <span class="lg-pager"></span><div class="lg-pager-thumb-cont"><span class="lg-caret"></span> <img src="'+a(this).attr(e.core.s.exThumbImage)+'" /></div></span>':'<span class="lg-pager-cont"> <span class="lg-pager"></span><div class="lg-pager-thumb-cont"><span class="lg-caret"></span> <img src="'+a(this).find("img").attr("src")+'" /></div></span>'});c=e.core.$outer.find(".lg-pager-outer"),c.html(f),b=e.core.$outer.find(".lg-pager-cont"),b.on("click.lg touchend.lg",function(){var b=a(this);e.core.index=b.index(),e.core.slide(e.core.index,!1,!0,!1)}),c.on("mouseover.lg",function(){clearTimeout(d),c.addClass("lg-pager-hover")}),c.on("mouseout.lg",function(){d=setTimeout(function(){c.removeClass("lg-pager-hover")})}),e.core.$el.on("onBeforeSlide.lg.tm",function(a,c,d){b.removeClass("lg-pager-active"),b.eq(d).addClass("lg-pager-active")})},c.prototype.destroy=function(){},a.fn.lightGallery.modules.pager=c}()}),function(a,b){"function"==typeof define&&define.amd?define(["jquery"],function(a){return b(a)}):"object"==typeof exports?module.exports=b(require("jquery")):b(jQuery)}(this,function(a){!function(){"use strict";var b={thumbnail:!0,animateThumb:!0,currentPagerPosition:"middle",thumbWidth:100,thumbHeight:"80px",thumbContHeight:100,thumbMargin:5,exThumbImage:!1,showThumbByDefault:!0,toogleThumb:!0,pullCaptionUp:!0,enableThumbDrag:!0,enableThumbSwipe:!0,swipeThreshold:50,loadYoutubeThumbnail:!0,youtubeThumbSize:1,loadVimeoThumbnail:!0,vimeoThumbSize:"thumbnail_small",loadDailymotionThumbnail:!0},c=function(c){return this.core=a(c).data("lightGallery"),this.core.s=a.extend({},b,this.core.s),this.$el=a(c),this.$thumbOuter=null,this.thumbOuterWidth=0,this.thumbTotalWidth=this.core.$items.length*(this.core.s.thumbWidth+this.core.s.thumbMargin),this.thumbIndex=this.core.index,this.core.s.animateThumb&&(this.core.s.thumbHeight="100%"),this.left=0,this.init(),this};c.prototype.init=function(){var a=this;this.core.s.thumbnail&&this.core.$items.length>1&&(this.core.s.showThumbByDefault&&setTimeout(function(){a.core.$outer.addClass("lg-thumb-open")},700),this.core.s.pullCaptionUp&&this.core.$outer.addClass("lg-pull-caption-up"),this.build(),this.core.s.animateThumb&&this.core.doCss()?(this.core.s.enableThumbDrag&&this.enableThumbDrag(),this.core.s.enableThumbSwipe&&this.enableThumbSwipe(),this.thumbClickable=!1):this.thumbClickable=!0,this.toogle(),this.thumbkeyPress())},c.prototype.build=function(){function b(a,b,c){var g,h=d.core.isVideo(a,c)||{},i="";h.youtube||h.vimeo||h.dailymotion?h.youtube?g=d.core.s.loadYoutubeThumbnail?"//img.youtube.com/vi/"+h.youtube[1]+"/"+d.core.s.youtubeThumbSize+".jpg":b:h.vimeo?d.core.s.loadVimeoThumbnail?(g="//i.vimeocdn.com/video/error_"+f+".jpg",i=h.vimeo[1]):g=b:h.dailymotion&&(g=d.core.s.loadDailymotionThumbnail?"//www.dailymotion.com/thumbnail/video/"+h.dailymotion[1]:b):g=b,e+='<div data-vimeo-id="'+i+'" class="lg-thumb-item" style="width:'+d.core.s.thumbWidth+"px; height: "+d.core.s.thumbHeight+"; margin-right: "+d.core.s.thumbMargin+'px"><img src="'+g+'" /></div>',i=""}var c,d=this,e="",f="",g='<div class="lg-thumb-outer"><div class="lg-thumb lg-group"></div></div>';switch(this.core.s.vimeoThumbSize){case"thumbnail_large":f="640";break;case"thumbnail_medium":f="200x150";break;case"thumbnail_small":f="100x75"}if(d.core.$outer.addClass("lg-has-thumb"),d.core.$outer.find(".lg").append(g),d.$thumbOuter=d.core.$outer.find(".lg-thumb-outer"),d.thumbOuterWidth=d.$thumbOuter.width(),d.core.s.animateThumb&&d.core.$outer.find(".lg-thumb").css({width:d.thumbTotalWidth+"px",position:"relative"}),this.core.s.animateThumb&&d.$thumbOuter.css("height",d.core.s.thumbContHeight+"px"),d.core.s.dynamic)for(var h=0;h<d.core.s.dynamicEl.length;h++)b(d.core.s.dynamicEl[h].src,d.core.s.dynamicEl[h].thumb,h);else d.core.$items.each(function(c){d.core.s.exThumbImage?b(a(this).attr("href")||a(this).attr("data-src"),a(this).attr(d.core.s.exThumbImage),c):b(a(this).attr("href")||a(this).attr("data-src"),a(this).find("img").attr("src"),c)});d.core.$outer.find(".lg-thumb").html(e),c=d.core.$outer.find(".lg-thumb-item"),c.each(function(){var b=a(this),c=b.attr("data-vimeo-id");c&&a.getJSON("//www.vimeo.com/api/v2/video/"+c+".json?callback=?",{format:"json"},function(a){b.find("img").attr("src",a[0][d.core.s.vimeoThumbSize])})}),c.eq(d.core.index).addClass("active"),d.core.$el.on("onBeforeSlide.lg.tm",function(){c.removeClass("active"),c.eq(d.core.index).addClass("active")}),c.on("click.lg touchend.lg",function(){var b=a(this);setTimeout(function(){(d.thumbClickable&&!d.core.lgBusy||!d.core.doCss())&&(d.core.index=b.index(),d.core.slide(d.core.index,!1,!0,!1))},50)}),d.core.$el.on("onBeforeSlide.lg.tm",function(){d.animateThumb(d.core.index)}),a(window).on("resize.lg.thumb orientationchange.lg.thumb",function(){setTimeout(function(){d.animateThumb(d.core.index),d.thumbOuterWidth=d.$thumbOuter.width()},200)})},c.prototype.setTranslate=function(a){this.core.$outer.find(".lg-thumb").css({transform:"translate3d(-"+a+"px, 0px, 0px)"})},c.prototype.animateThumb=function(a){var b=this.core.$outer.find(".lg-thumb");if(this.core.s.animateThumb){var c;switch(this.core.s.currentPagerPosition){case"left":c=0;break;case"middle":c=this.thumbOuterWidth/2-this.core.s.thumbWidth/2;break;case"right":c=this.thumbOuterWidth-this.core.s.thumbWidth}this.left=(this.core.s.thumbWidth+this.core.s.thumbMargin)*a-1-c,this.left>this.thumbTotalWidth-this.thumbOuterWidth&&(this.left=this.thumbTotalWidth-this.thumbOuterWidth),this.left<0&&(this.left=0),this.core.lGalleryOn?(b.hasClass("on")||this.core.$outer.find(".lg-thumb").css("transition-duration",this.core.s.speed+"ms"),this.core.doCss()||b.animate({left:-this.left+"px"},this.core.s.speed)):this.core.doCss()||b.css("left",-this.left+"px"),this.setTranslate(this.left)}},c.prototype.enableThumbDrag=function(){var b=this,c=0,d=0,e=!1,f=!1,g=0;b.$thumbOuter.addClass("lg-grab"),b.core.$outer.find(".lg-thumb").on("mousedown.lg.thumb",function(a){b.thumbTotalWidth>b.thumbOuterWidth&&(a.preventDefault(),c=a.pageX,e=!0,b.core.$outer.scrollLeft+=1,b.core.$outer.scrollLeft-=1,b.thumbClickable=!1,b.$thumbOuter.removeClass("lg-grab").addClass("lg-grabbing"))}),a(window).on("mousemove.lg.thumb",function(a){e&&(g=b.left,f=!0,d=a.pageX,b.$thumbOuter.addClass("lg-dragging"),g-=d-c,g>b.thumbTotalWidth-b.thumbOuterWidth&&(g=b.thumbTotalWidth-b.thumbOuterWidth),g<0&&(g=0),b.setTranslate(g))}),a(window).on("mouseup.lg.thumb",function(){f?(f=!1,b.$thumbOuter.removeClass("lg-dragging"),b.left=g,Math.abs(d-c)<b.core.s.swipeThreshold&&(b.thumbClickable=!0)):b.thumbClickable=!0,e&&(e=!1,b.$thumbOuter.removeClass("lg-grabbing").addClass("lg-grab"))})},c.prototype.enableThumbSwipe=function(){var a=this,b=0,c=0,d=!1,e=0;a.core.$outer.find(".lg-thumb").on("touchstart.lg",function(c){a.thumbTotalWidth>a.thumbOuterWidth&&(c.preventDefault(),b=c.originalEvent.targetTouches[0].pageX,a.thumbClickable=!1)}),a.core.$outer.find(".lg-thumb").on("touchmove.lg",function(f){a.thumbTotalWidth>a.thumbOuterWidth&&(f.preventDefault(),c=f.originalEvent.targetTouches[0].pageX,d=!0,a.$thumbOuter.addClass("lg-dragging"),e=a.left,e-=c-b,e>a.thumbTotalWidth-a.thumbOuterWidth&&(e=a.thumbTotalWidth-a.thumbOuterWidth),e<0&&(e=0),a.setTranslate(e))}),a.core.$outer.find(".lg-thumb").on("touchend.lg",function(){a.thumbTotalWidth>a.thumbOuterWidth&&d?(d=!1,a.$thumbOuter.removeClass("lg-dragging"),Math.abs(c-b)<a.core.s.swipeThreshold&&(a.thumbClickable=!0),a.left=e):a.thumbClickable=!0})},c.prototype.toogle=function(){var a=this;a.core.s.toogleThumb&&(a.core.$outer.addClass("lg-can-toggle"),a.$thumbOuter.append('<span class="lg-toogle-thumb lg-icon"></span>'),a.core.$outer.find(".lg-toogle-thumb").on("click.lg",function(){a.core.$outer.toggleClass("lg-thumb-open")}))},c.prototype.thumbkeyPress=function(){var b=this;a(window).on("keydown.lg.thumb",function(a){38===a.keyCode?(a.preventDefault(),b.core.$outer.addClass("lg-thumb-open")):40===a.keyCode&&(a.preventDefault(),b.core.$outer.removeClass("lg-thumb-open"))})},c.prototype.destroy=function(){this.core.s.thumbnail&&this.core.$items.length>1&&(a(window).off("resize.lg.thumb orientationchange.lg.thumb keydown.lg.thumb"),
this.$thumbOuter.remove(),this.core.$outer.removeClass("lg-has-thumb"))},a.fn.lightGallery.modules.Thumbnail=c}()}),function(a,b){"function"==typeof define&&define.amd?define(["jquery"],function(a){return b(a)}):"object"==typeof exports?module.exports=b(require("jquery")):b(jQuery)}(this,function(a){!function(){"use strict";function b(a,b,c,d){var e=this;if(e.core.$slide.eq(b).find(".lg-video").append(e.loadVideo(c,"lg-object",!0,b,d)),d)if(e.core.s.videojs)try{videojs(e.core.$slide.eq(b).find(".lg-html5").get(0),e.core.s.videojsOptions,function(){!e.videoLoaded&&e.core.s.autoplayFirstVideo&&this.play()})}catch(a){console.error("Make sure you have included videojs")}else!e.videoLoaded&&e.core.s.autoplayFirstVideo&&e.core.$slide.eq(b).find(".lg-html5").get(0).play()}function c(a,b){var c=this.core.$slide.eq(b).find(".lg-video-cont");c.hasClass("lg-has-iframe")||(c.css("max-width",this.core.s.videoMaxWidth),this.videoLoaded=!0)}function d(b,c,d){var e=this,f=e.core.$slide.eq(c),g=f.find(".lg-youtube").get(0),h=f.find(".lg-vimeo").get(0),i=f.find(".lg-dailymotion").get(0),j=f.find(".lg-vk").get(0),k=f.find(".lg-html5").get(0);if(g)g.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}',"*");else if(h)try{$f(h).api("pause")}catch(a){console.error("Make sure you have included froogaloop2 js")}else if(i)i.contentWindow.postMessage("pause","*");else if(k)if(e.core.s.videojs)try{videojs(k).pause()}catch(a){console.error("Make sure you have included videojs")}else k.pause();j&&a(j).attr("src",a(j).attr("src").replace("&autoplay","&noplay"));var l;l=e.core.s.dynamic?e.core.s.dynamicEl[d].src:e.core.$items.eq(d).attr("href")||e.core.$items.eq(d).attr("data-src");var m=e.core.isVideo(l,d)||{};(m.youtube||m.vimeo||m.dailymotion||m.vk)&&e.core.$outer.addClass("lg-hide-download")}var e={videoMaxWidth:"855px",autoplayFirstVideo:!0,youtubePlayerParams:!1,vimeoPlayerParams:!1,dailymotionPlayerParams:!1,vkPlayerParams:!1,videojs:!1,videojsOptions:{}},f=function(b){return this.core=a(b).data("lightGallery"),this.$el=a(b),this.core.s=a.extend({},e,this.core.s),this.videoLoaded=!1,this.init(),this};f.prototype.init=function(){var e=this;e.core.$el.on("hasVideo.lg.tm",b.bind(this)),e.core.$el.on("onAferAppendSlide.lg.tm",c.bind(this)),e.core.doCss()&&e.core.$items.length>1&&(e.core.s.enableSwipe||e.core.s.enableDrag)?e.core.$el.on("onSlideClick.lg.tm",function(){var a=e.core.$slide.eq(e.core.index);e.loadVideoOnclick(a)}):e.core.$slide.on("click.lg",function(){e.loadVideoOnclick(a(this))}),e.core.$el.on("onBeforeSlide.lg.tm",d.bind(this)),e.core.$el.on("onAfterSlide.lg.tm",function(a,b){e.core.$slide.eq(b).removeClass("lg-video-playing")})},f.prototype.loadVideo=function(b,c,d,e,f){var g="",h=1,i="",j=this.core.isVideo(b,e)||{};if(d&&(h=this.videoLoaded?0:this.core.s.autoplayFirstVideo?1:0),j.youtube)i="?wmode=opaque&autoplay="+h+"&enablejsapi=1",this.core.s.youtubePlayerParams&&(i=i+"&"+a.param(this.core.s.youtubePlayerParams)),g='<iframe class="lg-video-object lg-youtube '+c+'" width="560" height="315" src="//www.youtube.com/embed/'+j.youtube[1]+i+'" frameborder="0" allowfullscreen></iframe>';else if(j.vimeo)i="?autoplay="+h+"&api=1",this.core.s.vimeoPlayerParams&&(i=i+"&"+a.param(this.core.s.vimeoPlayerParams)),g='<iframe class="lg-video-object lg-vimeo '+c+'" width="560" height="315"  src="//player.vimeo.com/video/'+j.vimeo[1]+i+'" frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>';else if(j.dailymotion)i="?wmode=opaque&autoplay="+h+"&api=postMessage",this.core.s.dailymotionPlayerParams&&(i=i+"&"+a.param(this.core.s.dailymotionPlayerParams)),g='<iframe class="lg-video-object lg-dailymotion '+c+'" width="560" height="315" src="//www.dailymotion.com/embed/video/'+j.dailymotion[1]+i+'" frameborder="0" allowfullscreen></iframe>';else if(j.html5){var k=f.substring(0,1);"."!==k&&"#"!==k||(f=a(f).html()),g=f}else j.vk&&(i="&autoplay="+h,this.core.s.vkPlayerParams&&(i=i+"&"+a.param(this.core.s.vkPlayerParams)),g='<iframe class="lg-video-object lg-vk '+c+'" width="560" height="315" src="http://vk.com/video_ext.php?'+j.vk[1]+i+'" frameborder="0" allowfullscreen></iframe>');return g},f.prototype.loadVideoOnclick=function(a){var b=this;if(a.find(".lg-object").hasClass("lg-has-poster")&&a.find(".lg-object").is(":visible"))if(a.hasClass("lg-has-video")){var c=a.find(".lg-youtube").get(0),d=a.find(".lg-vimeo").get(0),e=a.find(".lg-dailymotion").get(0),f=a.find(".lg-html5").get(0);if(c)c.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}',"*");else if(d)try{$f(d).api("play")}catch(a){console.error("Make sure you have included froogaloop2 js")}else if(e)e.contentWindow.postMessage("play","*");else if(f)if(b.core.s.videojs)try{videojs(f).play()}catch(a){console.error("Make sure you have included videojs")}else f.play();a.addClass("lg-video-playing")}else{a.addClass("lg-video-playing lg-has-video");var g,h,i=function(c,d){if(a.find(".lg-video").append(b.loadVideo(c,"",!1,b.core.index,d)),d)if(b.core.s.videojs)try{videojs(b.core.$slide.eq(b.core.index).find(".lg-html5").get(0),b.core.s.videojsOptions,function(){this.play()})}catch(a){console.error("Make sure you have included videojs")}else b.core.$slide.eq(b.core.index).find(".lg-html5").get(0).play()};b.core.s.dynamic?(g=b.core.s.dynamicEl[b.core.index].src,h=b.core.s.dynamicEl[b.core.index].html,i(g,h)):(g=b.core.$items.eq(b.core.index).attr("href")||b.core.$items.eq(b.core.index).attr("data-src"),h=b.core.$items.eq(b.core.index).attr("data-html"),i(g,h));var j=a.find(".lg-object");a.find(".lg-video").append(j),a.find(".lg-video-object").hasClass("lg-html5")||(a.removeClass("lg-complete"),a.find(".lg-video-object").on("load.lg error.lg",function(){a.addClass("lg-complete")}))}},f.prototype.destroy=function(){this.videoLoaded=!1},a.fn.lightGallery.modules.video=f}()}),function(a,b){"function"==typeof define&&define.amd?define(["jquery"],function(a){return b(a)}):"object"==typeof exports?module.exports=b(require("jquery")):b(jQuery)}(this,function(a){!function(){"use strict";var b=function(){var a=!1,b=navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);return b&&parseInt(b[2],10)<54&&(a=!0),a},c={scale:1,zoom:!0,actualSize:!0,enableZoomAfter:300,useLeftForZoom:b()},d=function(b){return this.core=a(b).data("lightGallery"),this.core.s=a.extend({},c,this.core.s),this.core.s.zoom&&this.core.doCss()&&(this.init(),this.zoomabletimeout=!1,this.pageX=a(window).width()/2,this.pageY=a(window).height()/2+a(window).scrollTop()),this};d.prototype.init=function(){var b=this,c='<span id="lg-zoom-in" class="lg-icon"></span><span id="lg-zoom-out" class="lg-icon"></span>';b.core.s.actualSize&&(c+='<span id="lg-actual-size" class="lg-icon"></span>'),b.core.s.useLeftForZoom?b.core.$outer.addClass("lg-use-left-for-zoom"):b.core.$outer.addClass("lg-use-transition-for-zoom"),this.core.$outer.find(".lg-toolbar").append(c),b.core.$el.on("onSlideItemLoad.lg.tm.zoom",function(c,d,e){var f=b.core.s.enableZoomAfter+e;a("body").hasClass("lg-from-hash")&&e?f=0:a("body").removeClass("lg-from-hash"),b.zoomabletimeout=setTimeout(function(){b.core.$slide.eq(d).addClass("lg-zoomable")},f+30)});var d=1,e=function(c){var d,e,f=b.core.$outer.find(".lg-current .lg-image"),g=(a(window).width()-f.prop("offsetWidth"))/2,h=(a(window).height()-f.prop("offsetHeight"))/2+a(window).scrollTop();d=b.pageX-g,e=b.pageY-h;var i=(c-1)*d,j=(c-1)*e;f.css("transform","scale3d("+c+", "+c+", 1)").attr("data-scale",c),b.core.s.useLeftForZoom?f.parent().css({left:-i+"px",top:-j+"px"}).attr("data-x",i).attr("data-y",j):f.parent().css("transform","translate3d(-"+i+"px, -"+j+"px, 0)").attr("data-x",i).attr("data-y",j)},f=function(){d>1?b.core.$outer.addClass("lg-zoomed"):b.resetZoom(),d<1&&(d=1),e(d)},g=function(c,e,g,h){var i,j=e.prop("offsetWidth");i=b.core.s.dynamic?b.core.s.dynamicEl[g].width||e[0].naturalWidth||j:b.core.$items.eq(g).attr("data-width")||e[0].naturalWidth||j;var k;b.core.$outer.hasClass("lg-zoomed")?d=1:i>j&&(k=i/j,d=k||2),h?(b.pageX=a(window).width()/2,b.pageY=a(window).height()/2+a(window).scrollTop()):(b.pageX=c.pageX||c.originalEvent.targetTouches[0].pageX,b.pageY=c.pageY||c.originalEvent.targetTouches[0].pageY),f(),setTimeout(function(){b.core.$outer.removeClass("lg-grabbing").addClass("lg-grab")},10)},h=!1;b.core.$el.on("onAferAppendSlide.lg.tm.zoom",function(a,c){var d=b.core.$slide.eq(c).find(".lg-image");d.on("dblclick",function(a){g(a,d,c)}),d.on("touchstart",function(a){h?(clearTimeout(h),h=null,g(a,d,c)):h=setTimeout(function(){h=null},300),a.preventDefault()})}),a(window).on("resize.lg.zoom scroll.lg.zoom orientationchange.lg.zoom",function(){b.pageX=a(window).width()/2,b.pageY=a(window).height()/2+a(window).scrollTop(),e(d)}),a("#lg-zoom-out").on("click.lg",function(){b.core.$outer.find(".lg-current .lg-image").length&&(d-=b.core.s.scale,f())}),a("#lg-zoom-in").on("click.lg",function(){b.core.$outer.find(".lg-current .lg-image").length&&(d+=b.core.s.scale,f())}),a("#lg-actual-size").on("click.lg",function(a){g(a,b.core.$slide.eq(b.core.index).find(".lg-image"),b.core.index,!0)}),b.core.$el.on("onBeforeSlide.lg.tm",function(){d=1,b.resetZoom()}),b.zoomDrag(),b.zoomSwipe()},d.prototype.resetZoom=function(){this.core.$outer.removeClass("lg-zoomed"),this.core.$slide.find(".lg-img-wrap").removeAttr("style data-x data-y"),this.core.$slide.find(".lg-image").removeAttr("style data-scale"),this.pageX=a(window).width()/2,this.pageY=a(window).height()/2+a(window).scrollTop()},d.prototype.zoomSwipe=function(){var a=this,b={},c={},d=!1,e=!1,f=!1;a.core.$slide.on("touchstart.lg",function(c){if(a.core.$outer.hasClass("lg-zoomed")){var d=a.core.$slide.eq(a.core.index).find(".lg-object");f=d.prop("offsetHeight")*d.attr("data-scale")>a.core.$outer.find(".lg").height(),e=d.prop("offsetWidth")*d.attr("data-scale")>a.core.$outer.find(".lg").width(),(e||f)&&(c.preventDefault(),b={x:c.originalEvent.targetTouches[0].pageX,y:c.originalEvent.targetTouches[0].pageY})}}),a.core.$slide.on("touchmove.lg",function(g){if(a.core.$outer.hasClass("lg-zoomed")){var h,i,j=a.core.$slide.eq(a.core.index).find(".lg-img-wrap");g.preventDefault(),d=!0,c={x:g.originalEvent.targetTouches[0].pageX,y:g.originalEvent.targetTouches[0].pageY},a.core.$outer.addClass("lg-zoom-dragging"),i=f?-Math.abs(j.attr("data-y"))+(c.y-b.y):-Math.abs(j.attr("data-y")),h=e?-Math.abs(j.attr("data-x"))+(c.x-b.x):-Math.abs(j.attr("data-x")),(Math.abs(c.x-b.x)>15||Math.abs(c.y-b.y)>15)&&(a.core.s.useLeftForZoom?j.css({left:h+"px",top:i+"px"}):j.css("transform","translate3d("+h+"px, "+i+"px, 0)"))}}),a.core.$slide.on("touchend.lg",function(){a.core.$outer.hasClass("lg-zoomed")&&d&&(d=!1,a.core.$outer.removeClass("lg-zoom-dragging"),a.touchendZoom(b,c,e,f))})},d.prototype.zoomDrag=function(){var b=this,c={},d={},e=!1,f=!1,g=!1,h=!1;b.core.$slide.on("mousedown.lg.zoom",function(d){var f=b.core.$slide.eq(b.core.index).find(".lg-object");h=f.prop("offsetHeight")*f.attr("data-scale")>b.core.$outer.find(".lg").height(),g=f.prop("offsetWidth")*f.attr("data-scale")>b.core.$outer.find(".lg").width(),b.core.$outer.hasClass("lg-zoomed")&&a(d.target).hasClass("lg-object")&&(g||h)&&(d.preventDefault(),c={x:d.pageX,y:d.pageY},e=!0,b.core.$outer.scrollLeft+=1,b.core.$outer.scrollLeft-=1,b.core.$outer.removeClass("lg-grab").addClass("lg-grabbing"))}),a(window).on("mousemove.lg.zoom",function(a){if(e){var i,j,k=b.core.$slide.eq(b.core.index).find(".lg-img-wrap");f=!0,d={x:a.pageX,y:a.pageY},b.core.$outer.addClass("lg-zoom-dragging"),j=h?-Math.abs(k.attr("data-y"))+(d.y-c.y):-Math.abs(k.attr("data-y")),i=g?-Math.abs(k.attr("data-x"))+(d.x-c.x):-Math.abs(k.attr("data-x")),b.core.s.useLeftForZoom?k.css({left:i+"px",top:j+"px"}):k.css("transform","translate3d("+i+"px, "+j+"px, 0)")}}),a(window).on("mouseup.lg.zoom",function(a){e&&(e=!1,b.core.$outer.removeClass("lg-zoom-dragging"),!f||c.x===d.x&&c.y===d.y||(d={x:a.pageX,y:a.pageY},b.touchendZoom(c,d,g,h)),f=!1),b.core.$outer.removeClass("lg-grabbing").addClass("lg-grab")})},d.prototype.touchendZoom=function(a,b,c,d){var e=this,f=e.core.$slide.eq(e.core.index).find(".lg-img-wrap"),g=e.core.$slide.eq(e.core.index).find(".lg-object"),h=-Math.abs(f.attr("data-x"))+(b.x-a.x),i=-Math.abs(f.attr("data-y"))+(b.y-a.y),j=(e.core.$outer.find(".lg").height()-g.prop("offsetHeight"))/2,k=Math.abs(g.prop("offsetHeight")*Math.abs(g.attr("data-scale"))-e.core.$outer.find(".lg").height()+j),l=(e.core.$outer.find(".lg").width()-g.prop("offsetWidth"))/2,m=Math.abs(g.prop("offsetWidth")*Math.abs(g.attr("data-scale"))-e.core.$outer.find(".lg").width()+l);(Math.abs(b.x-a.x)>15||Math.abs(b.y-a.y)>15)&&(d&&(i<=-k?i=-k:i>=-j&&(i=-j)),c&&(h<=-m?h=-m:h>=-l&&(h=-l)),d?f.attr("data-y",Math.abs(i)):i=-Math.abs(f.attr("data-y")),c?f.attr("data-x",Math.abs(h)):h=-Math.abs(f.attr("data-x")),e.core.s.useLeftForZoom?f.css({left:h+"px",top:i+"px"}):f.css("transform","translate3d("+h+"px, "+i+"px, 0)"))},d.prototype.destroy=function(){var b=this;b.core.$el.off(".lg.zoom"),a(window).off(".lg.zoom"),b.core.$slide.off(".lg.zoom"),b.core.$el.off(".lg.tm.zoom"),b.resetZoom(),clearTimeout(b.zoomabletimeout),b.zoomabletimeout=!1},a.fn.lightGallery.modules.zoom=d}()}),function(a,b){"function"==typeof define&&define.amd?define(["jquery"],function(a){return b(a)}):"object"==typeof exports?module.exports=b(require("jquery")):b(jQuery)}(this,function(a){!function(){"use strict";var b={hash:!0},c=function(c){return this.core=a(c).data("lightGallery"),this.core.s=a.extend({},b,this.core.s),this.core.s.hash&&(this.oldHash=window.location.hash,this.init()),this};c.prototype.init=function(){var b,c=this;c.core.$el.on("onAfterSlide.lg.tm",function(a,b,d){history.replaceState?history.replaceState(null,null,null):xxxx=window.location.hash}),a(window).on("hashchange.lg.hash",function(){ b=xxxx;var a=parseInt(b.split("&slide=")[1],10);b.indexOf("lg="+c.core.s.galleryId)>-1?c.core.slide(a,!1,!1):c.core.lGalleryOn&&c.core.destroy() })},c.prototype.destroy=function(){this.core.s.hash&&(this.oldHash&&this.oldHash.indexOf("lg="+this.core.s.galleryId)<0?history.replaceState?history.replaceState(null,null,this.oldHash):xxxx=this.oldHash:history.replaceState?history.replaceState(null,document.title,window.location.pathname+window.location.search):xxxx="",this.core.$el.off(".lg.hash"))},a.fn.lightGallery.modules.hash=c}()}),function(a,b){"function"==typeof define&&define.amd?define(["jquery"],function(a){return b(a)}):"object"==typeof exports?module.exports=b(require("jquery")):b(jQuery)}(this,function(a){!function(){"use strict";var b={share:!0,facebook:!0,facebookDropdownText:"Facebook",twitter:!0,twitterDropdownText:"Twitter",googlePlus:!0,googlePlusDropdownText:"GooglePlus",pinterest:!0,pinterestDropdownText:"Pinterest"},c=function(c){return this.core=a(c).data("lightGallery"),this.core.s=a.extend({},b,this.core.s),this.core.s.share&&this.init(),this};c.prototype.init=function(){var b=this,c='<span id="lg-share" class="lg-icon"><ul class="lg-dropdown" style="position: absolute;">';c+=b.core.s.facebook?'<li><a id="lg-share-facebook" target="_blank"><span class="lg-icon"></span><span class="lg-dropdown-text">'+this.core.s.facebookDropdownText+"</span></a></li>":"",c+=b.core.s.twitter?'<li><a id="lg-share-twitter" target="_blank"><span class="lg-icon"></span><span class="lg-dropdown-text">'+this.core.s.twitterDropdownText+"</span></a></li>":"",c+=b.core.s.googlePlus?'<li><a id="lg-share-googleplus" target="_blank"><span class="lg-icon"></span><span class="lg-dropdown-text">'+this.core.s.googlePlusDropdownText+"</span></a></li>":"",c+=b.core.s.pinterest?'<li><a id="lg-share-pinterest" target="_blank"><span class="lg-icon"></span><span class="lg-dropdown-text">'+this.core.s.pinterestDropdownText+"</span></a></li>":"",c+="</ul></span>",this.core.$outer.find(".lg-toolbar").append(c),this.core.$outer.find(".lg").append('<div id="lg-dropdown-overlay"></div>'),a("#lg-share").on("click.lg",function(){b.core.$outer.toggleClass("lg-dropdown-active")}),a("#lg-dropdown-overlay").on("click.lg",function(){b.core.$outer.removeClass("lg-dropdown-active")}),b.core.$el.on("onAfterSlide.lg.tm",function(c,d,e){setTimeout(function(){a("#lg-share-facebook").attr("href","https://www.facebook.com/sharer/sharer.php?u="+encodeURIComponent(b.getSahreProps(e,"facebookShareUrl")||window.location.href)),a("#lg-share-twitter").attr("href","https://twitter.com/intent/tweet?text="+b.getSahreProps(e,"tweetText")+"&url="+encodeURIComponent(b.getSahreProps(e,"twitterShareUrl")||window.location.href)),a("#lg-share-googleplus").attr("href","https://plus.google.com/share?url="+encodeURIComponent(b.getSahreProps(e,"googleplusShareUrl")||window.location.href)),a("#lg-share-pinterest").attr("href","http://www.pinterest.com/pin/create/button/?url="+encodeURIComponent(b.getSahreProps(e,"pinterestShareUrl")||window.location.href)+"&media="+encodeURIComponent(b.getSahreProps(e,"src"))+"&description="+b.getSahreProps(e,"pinterestText"))},100)})},c.prototype.getSahreProps=function(a,b){var c="";if(this.core.s.dynamic)c=this.core.s.dynamicEl[a][b];else{var d=this.core.$items.eq(a).attr("href"),e=this.core.$items.eq(a).data(b);c="src"===b?d||e:e}return c},c.prototype.destroy=function(){},a.fn.lightGallery.modules.share=c}()});


jQPac = jQuery.noConflict(true);/*!
  jQuery rondell plugin
  @name jquery.rondell.js
  @author Sebastian Helzle (sebastian@helzle.net or @sebobo)
  @version 1.0.4
  @date 07/05/2013
  @category jQuery plugin
  @copyright (c) 2009-2013 Sebastian Helzle (www.sebastianhelzle.net)
  @license Licensed under the MIT (http://www.opensource.org/licenses/mit-license.php) license.
*/

var __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

(function($) {
  /* Global rondell plugin properties*/

  var $document, $window, Rondell, closeLightbox, delayCall, getActiveRondell, getLightbox, lightboxIsVisible, resizeLightbox, resizeTimer, updateLightbox, _base;
  $.rondell || ($.rondell = {
    version: '1.0.4',
    name: 'rondell',
    lightbox: {
      instance: void 0,
      template: $.trim('\
        <div class="rondell-lightbox">\
          <div class="rondell-lightbox-overlay">&nbsp;</div>\
          <div class="rondell-lightbox-content">\
            <div class="rondell-lightbox-inner"/>\
            <div class="rondell-lightbox-close">&nbsp;</div>\
            <div class="rondell-lightbox-prev">&nbsp;</div>\
            <div class="rondell-lightbox-position">1</div>\
            <div class="rondell-lightbox-next">&nbsp;</div>\
          </div>\
        </div>')
    },
    defaults: {
      showContainer: true,
      classes: {
        container: "rondell-container",
        initializing: "rondell-initializing",
        themePrefix: "rondell-theme",
        caption: "rondell-caption",
        noScale: "no-scale",
        item: "rondell-item",
        image: "rondell-item-image",
        resizeable: "rondell-item-resizeable",
        small: "rondell-item-small",
        hidden: "rondell-item-hidden",
        loading: "rondell-item-loading",
        hovered: "rondell-item-hovered",
        overlay: "rondell-item-overlay",
        focused: "rondell-item-focused",
        crop: "rondell-item-crop",
        error: "rondell-item-error",
        control: "rondell-control",
        shiftLeft: "rondell-shift-left",
        shiftRight: "rondell-shift-right"
      },
      currentLayer: 0,
      container: null,
      radius: {
        x: 250,
        y: 50
      },
      center: {
        left: 340,
        top: 160
      },
      size: {
        width: null,
        height: null
      },
      visibleItems: 'auto',
      scaling: 2,
      opacityMin: 0.05,
      fadeTime: 300,
      keyDelay: 300,
      zIndex: 200,
      itemProperties: {
        delay: 100,
        size: {
          width: 150,
          height: 150
        },
        sizeFocused: {
          width: 0,
          height: 0
        }
      },
      lightbox: {
        enabled: true,
        displayReferencedImages: true
      },
      imageFiletypes: ['png', 'jpg', 'jpeg', 'gif', 'bmp'],
      repeating: true,
      wrapIndices: true,
      switchIndices: false,
      alwaysShowCaption: false,
      captionsEnabled: true,
      autoRotation: {
        enabled: false,
        paused: false,
        direction: 0,
        once: false,
        delay: 5000
      },
      controls: {
        enabled: true,
        fadeTime: 400,
        margin: {
          x: 130,
          y: 270
        }
      },
      strings: {
        prev: 'prev',
        next: 'next',
        loadingError: 'An error occured while loading <b>%s</b>',
        more: 'More...'
      },
      mousewheel: {
        enabled: true,
        threshold: 0,
        minTimeBetweenShifts: 500
      },
      touch: {
        enabled: true,
        preventDefaults: true,
        threshold: 70
      },
      randomStart: false,
      funcEase: 'easeInOutQuad',
      theme: 'default',
      preset: '',
      effect: null,
      onAfterShift: null,
      onUpdateLightbox: null,
      cropThumbnails: false,
      scrollbar: {
        enabled: false,
        orientation: "bottom",
        start: 1,
        end: 100,
        stepSize: 1,
        keepStepOrder: true,
        position: 1,
        padding: 10,
        style: {
          width: "100%",
          height: 20,
          left: "auto",
          right: "auto",
          top: "auto",
          bottom: "auto"
        },
        repeating: false,
        onScroll: void 0,
        scrollOnHover: false,
        scrollOnDrag: true,
        animationDuration: 300,
        easing: "easeInOutQuad",
        classes: {
          container: "rondell-scrollbar",
          control: "rondell-scrollbar-control",
          dragging: "rondell-scrollbar-dragging",
          background: "rondell-scrollbar-background",
          scrollLeft: "rondell-scrollbar-left",
          scrollRight: "rondell-scrollbar-right",
          scrollInner: "rondell-scrollbar-inner"
        }
      }
    }
  });
  /* Add default easing function for rondell to jQuery if missing*/

  (_base = $.easing).easeInOutQuad || (_base.easeInOutQuad = function(x, t, b, c, d) {
    if ((t /= d / 2) < 1) {
      return c / 2 * t * t + b;
    } else {
      return -c / 2 * ((--t) * (t - 2) - 1) + b;
    }
  });
  delayCall = function(delay, callback) {
    return setTimeout(callback, delay);
  };
  $window = $(window);
  $document = $(document);
  Rondell = (function() {
    Rondell.rondellCount = 0;

    Rondell.activeRondell = null;

    function Rondell(items, options, numItems, initCallback) {
      var containerWrap, scrollbarContainer;
      if (initCallback == null) {
        initCallback = void 0;
      }
      this.showLightbox = __bind(this.showLightbox, this);
      this.keyDown = __bind(this.keyDown, this);
      this.isFocused = __bind(this.isFocused, this);
      this.onWindowBlur = __bind(this.onWindowBlur, this);
      this.onWindowFocus = __bind(this.onWindowFocus, this);
      this._autoShift = __bind(this._autoShift, this);
      this._autoShiftInit = __bind(this._autoShiftInit, this);
      this.shiftRight = __bind(this.shiftRight, this);
      this.shiftLeft = __bind(this.shiftLeft, this);
      this._refreshControls = __bind(this._refreshControls, this);
      this.getIndexInRange = __bind(this.getIndexInRange, this);
      this.getRelativeItemPosition = __bind(this.getRelativeItemPosition, this);
      this.shiftTo = __bind(this.shiftTo, this);
      this._hover = __bind(this._hover, this);
      this._onTouch = __bind(this._onTouch, this);
      this._onMousewheel = __bind(this._onMousewheel, this);
      this.bindEvents = __bind(this.bindEvents, this);
      this._start = __bind(this._start, this);
      this.onItemInit = __bind(this.onItemInit, this);
      this._loadItem = __bind(this._loadItem, this);
      this._getItem = __bind(this._getItem, this);
      this._onMouseLeaveItem = __bind(this._onMouseLeaveItem, this);
      this._onMouseEnterItem = __bind(this._onMouseEnterItem, this);
      this.fitToContainer = __bind(this.fitToContainer, this);
      this.id = ++Rondell.rondellCount;
      this.items = [];
      this.maxItems = numItems;
      this.loadedItems = 0;
      this.initCallback = initCallback;
	window.rondelInst = this;

      if (this.id === 1) {
        Rondell.activeRondell = this.id;
      }
      if ((options != null ? options.preset : void 0) in $.rondell.presets) {
        $.extend(true, this, $.rondell.defaults, $.rondell.presets[options.preset], options || {});
      } else {
        $.extend(true, this, $.rondell.defaults, options || {});
      }
      $.extend(true, this, {
        _dimensions: {
          computed: false
        },
        _lastKeyEvent: 0,
        _windowFocused: true,
        _focusedIndex: this.currentLayer,
        _itemIndices: {
          0: 0
        },
        autoRotation: {
          _timer: -1
        },
        controls: {
          _lastShift: 0
        },
        touch: {
          _start: void 0,
          _end: void 0
        },
        scrollbar: {
          _instance: null
        }
      });
      this.itemProperties.sizeFocused = {
        width: this.itemProperties.sizeFocused.width || this.itemProperties.size.width * this.scaling,
        height: this.itemProperties.sizeFocused.height || this.itemProperties.size.height * this.scaling
      };
      this.size = {
        width: this.size.width || this.center.left * 2,
        height: this.size.height || this.center.top * 2
      };
      containerWrap = $("<div/>").css(this.size).addClass("" + this.classes.initializing + " " + this.classes.container + " " + this.classes.themePrefix + "-" + this.theme);
      this.container = items.wrapAll(containerWrap).parent().addClass("rondell-instance-" + this.id).data('api', this);
      if (this.showContainer) {
        this.container.parent().show();
      }
      if (this.scrollbar.enabled) {
        scrollbarContainer = $('<div/>');
        this.container.append(scrollbarContainer);
        $.extend(true, this.scrollbar, {
          onScroll: this.shiftTo,
          end: this.maxItems,
          position: this.currentLayer,
          repeating: this.repeating
        });
        this.scrollbar._instance = new $.rondell.RondellScrollbar(scrollbarContainer, this.scrollbar);
      }
    }

    Rondell.prototype.log = function(msg) {
      return typeof console !== "undefined" && console !== null ? console.log(msg) : void 0;
    };

    Rondell.prototype.equals = function(objA, objB) {
      var key, value;
      for (key in objA) {
        value = objA[key];
        if (objB[key] !== value) {
          return false;
        }
      }
      for (key in objB) {
        value = objB[key];
        if (objA[key] !== value) {
          return false;
        }
      }
      return true;
    };

    Rondell.prototype.funcLeft = function(l, r, i) {
      return r.center.left - r.itemProperties.size.width / 2.0 + Math.sin(l) * r.radius.x;
    };

    Rondell.prototype.funcTop = function(l, r, i) {
      return r.center.top - r.itemProperties.size.height / 2.0 + Math.cos(l) * r.radius.y;
    };

    Rondell.prototype.funcDiff = function(d, r, i) {
      return Math.pow(Math.abs(d) / r.maxItems, 0.5) * Math.PI;
    };

    Rondell.prototype.funcOpacity = function(l, r, i) {
      if (r.visibleItems > 1) {
        return Math.max(0, 1.0 - Math.pow(l / r.visibleItems, 2));
      } else {
        return 0;
      }
    };

    Rondell.prototype.funcSize = function(l, r, i) {
      return 1;
    };

    Rondell.prototype.fitToContainer = function() {
      var newHeight, newWidth, oldHeight, oldWidth, parentContainer;
      parentContainer = this.container.parent();
      newWidth = parentContainer.innerWidth();
      newHeight = parentContainer.innerHeight();
      if (!this._dimensions.computed) {
        oldWidth = this.size.width;
        oldHeight = this.size.height;
        $.extend(true, this._dimensions, {
          computed: true,
          center: {
            left: this.center.left / oldWidth,
            top: this.center.top / oldHeight
          },
          radius: {
            x: this.radius.x / oldWidth,
            y: this.radius.y / oldHeight
          },
          controls: {
            margin: {
              x: this.controls.margin.x / oldWidth,
              y: this.controls.margin.y / oldHeight
            }
          },
          itemProperties: {
            size: {
              width: this.itemProperties.size.width / oldWidth,
              height: this.itemProperties.size.height / oldHeight
            },
            sizeFocused: {
              width: this.itemProperties.sizeFocused.width / oldWidth,
              height: this.itemProperties.sizeFocused.height / oldHeight
            }
          }
        });
      }
      $.extend(true, this, {
        size: {
          width: newWidth,
          height: newHeight
        },
        center: {
          left: this._dimensions.center.left * newWidth,
          top: this._dimensions.center.top * newHeight
        },
        radius: {
          x: this._dimensions.radius.x * newWidth,
          y: this._dimensions.radius.y * newHeight
        },
        controls: {
          margin: {
            x: this._dimensions.controls.margin.x * newWidth,
            y: this._dimensions.controls.margin.y * newHeight
          }
        },
        itemProperties: {
          size: {
            width: this._dimensions.itemProperties.size.width * newWidth,
            height: this._dimensions.itemProperties.size.height * newHeight
          },
          sizeFocused: {
            width: this._dimensions.itemProperties.sizeFocused.width * newWidth,
            height: this._dimensions.itemProperties.sizeFocused.height * newHeight
          }
        }
      });
      this.container.css(this.size);
      return this.shiftTo(this.currentLayer);
    };

    Rondell.prototype._onMouseEnterItem = function(idx) {
      return this._getItem(idx).onMouseEnter();
    };

    Rondell.prototype._onMouseLeaveItem = function(idx) {
      return this._getItem(idx).onMouseLeave();
    };

    Rondell.prototype._getItem = function(idx) {
      return this.items[idx - 1];
    };

    Rondell.prototype._loadItem = function(idx, obj) {
      var item;
      item = new $.rondell.RondellItem(idx, obj, this);
      this.items[idx - 1] = item;
      this._itemIndices[idx] = idx;
      item.init();
      if (++this.loadedItems === this.maxItems) {
        return this._start();
      }
    };

    Rondell.prototype.onItemInit = function(idx) {
      var item;
      item = this._getItem(idx);
      if (idx === this.currentLayer) {
        item.prepareFadeIn();
      } else {
        item.prepareFadeOut();
      }
      return item.runAnimation(true);
    };

    Rondell.prototype._start = function() {
      var controls;
      if (this.randomStart) {
        this.currentLayer = Math.round(Math.random() * (this.maxItems - 1));
      } else {
        this.currentLayer = Math.max(0, Math.min(this.currentLayer || Math.round(this.maxItems / 2), this.maxItems));
      }
      if (this.visibleItems === "auto") {
        this.visibleItems = Math.max(2, ~~(this.maxItems / 2));
      }
      controls = this.controls;
      if (controls.enabled) {
        this.controls._shiftLeft = $("<a href=\"#\"/>").addClass("" + this.classes.control + " lg-actions lg-gs-left").html(this.strings.prev).click(this.shiftLeft).css({
          left: controls.margin.x,
          top: controls.margin.y,
          zIndex: this.zIndex + this.maxItems + 2
        });
        this.controls._shiftRight = $("<a href=\"#\"/>").addClass("" + this.classes.control + " lg-actions").html(this.strings.next).click(this.shiftRight).css({
          right: controls.margin.x,
          top: controls.margin.y,
          zIndex: this.zIndex + this.maxItems + 2
        });
        this.container.append(this.controls._shiftLeft, this.controls._shiftRight);
      }
      this.bindEvents();
      this.container.removeClass(this.classes.initializing);
      if (typeof this.initCallback === "function") {
        this.initCallback(this);
      }
      if (this._focusedItem == null) {
        this._focusedItem = this._getItem(this.currentLayer);
      }
      return this.shiftTo(this.currentLayer);
    };

    Rondell.prototype.bindEvents = function() {
      var rondell;
      $document.keydown(this.keyDown);
      $window.blur(this.onWindowBlur).focus(this.onWindowFocus);
      $document.focusout(this.onWindowBlur).focusin(this.onWindowFocus);
      if (this.mousewheel.enabled && ($.fn.mousewheel != null)) {
        this.container.bind("mousewheel.rondell", this._onMousewheel);
      }
      if (this._onMobile()) {
        if (this.touch.enabled) {
          this.container.bind("touchstart.rondell touchmove.rondell touchend.rondell", this._onTouch);
        }
      } else {
        this.container.bind("mouseenter.rondell mouseleave.rondell", this._hover);
      }
      rondell = this;
      return this.container.delegate("." + this.classes.item, "click.rondell", function(e) {
        var item;
        item = $(this).data("item");
        if (rondell._focusedItem.id === item.id) {
          if (rondell.lightbox.enabled) {
            e.preventDefault();
			try {
				jQPac("#admin_bar_iframe").hide();
			}
			catch(err) {}
			
			if(jQPac(item.icon[0]).parents('.rondell-item-focused').length > 0) {
			jQPac("#zoom" + jQPac(item.icon[0]).attr("id")).trigger('click');
			}

            //return rondell.showLightbox();
          }
	  else {
	    return false;
	  }
        } else {
          e.preventDefault();
	  if ((presentationType == 3) || (!item.hidden && item.object.is(":visible"))) {
            return rondell.shiftTo(item.currentSlot);
          }
        }
      }).delegate("." + this.classes.item, "mouseenter.rondell mouseleave.rondell", function(e) {
        var item;
        item = $(this).data("item");
        if (e.type === "mouseenter") {
          return rondell._onMouseEnterItem(item.id);
        } else {
          return rondell._onMouseLeaveItem(item.id);
        }
      });
    };

    Rondell.prototype._onMobile = function() {
if((typeof Modernizr !== "undefined" && Modernizr !== null && Modernizr.touch) ||  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
	return true;
}

      /*
      Mobile device detection.
      Check for touch functionality is currently enough.
      */
	return false;
      return typeof Modernizr !== "undefined" && Modernizr !== null ? Modernizr.touch : void 0;
    };

    Rondell.prototype._onMousewheel = function(e, d, dx, dy) {
      /*
      Allows rondell traveling with mousewheel.
      Requires mousewheel plugin for jQuery.
      */

      var now, selfYCenter, viewportBottom, viewportTop;
      if (!(this.mousewheel.enabled && this.isFocused())) {
        return;
      }
      now = (new Date()).getTime();
      if (now - this.mousewheel._lastShift < this.mousewheel.minTimeBetweenShifts) {
        return;
      }
      viewportTop = $window.scrollTop();
      viewportBottom = viewportTop + $window.height();
      selfYCenter = this.container.offset().top + this.container.outerHeight() / 2;
      if (selfYCenter > viewportTop && selfYCenter < viewportBottom && Math.abs(dx) > this.mousewheel.threshold) {
        e.preventDefault();
        if (dx < 0) {
          this.shiftLeft();
        } else {
          this.shiftRight();
        }
        return this.mousewheel._lastShift = now;
      }
    };

    Rondell.prototype._onTouch = function(e) {
      var changeX, touch;
      if (!this.touch.enabled) {
        return;
      }
      touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
      switch (e.type) {
        case "touchstart":
          this.touch._start = {
            x: touch.pageX,
            y: touch.pageY
          };
          break;
        case "touchmove":
          if (this.touch.preventDefaults) {
            //e.preventDefault();
          }
          this.touch._end = {
            x: touch.pageX,
            y: touch.pageY
          };
          break;
        case "touchend":
          if (this.touch._start && this.touch._end) {
            changeX = this.touch._end.x - this.touch._start.x;
            if (Math.abs(changeX) > this.touch.threshold) {
              if (changeX > 0) {
                //this.shiftRight();
		this.shiftLeft();
              } else if (changeX < 0) {
                this.shiftRight();
		//this.shiftLeft();
              }
            }
            this.touch._start = this.touch._end = void 0;
          }
      }
	return;
	//return false;
      return true;
    };

    Rondell.prototype._hover = function(e) {
      /*
      Shows/hides rondell controls.
      Starts/pauses autorotation.
      Updates active rondell id.
      */

      var paused;
      paused = this.autoRotation.paused;
      if (e.type === "mouseenter") {
        Rondell.activeRondell = this.id;
        this.hovering = true;
        if (!paused) {
          this.autoRotation.paused = true;
          this._focusedItem.showCaption();
        }
      } else {
        this.hovering = false;
        if (paused && !this.autoRotation.once) {
          this.autoRotation.paused = false;
          this._autoShiftInit();
        }
        if (!this.alwaysShowCaption) {
          this._focusedItem.hideCaption();
        }
      }
      if (this.controls.enabled) {
        return this._refreshControls();
      }
    };

    Rondell.prototype.shiftTo = function(idx, keepOrder) {
      var distance, item, newItem, newItemIndex, relativeIndex, scrollbarIdx, _i, _j, _len, _len1, _ref, _ref1, _ref2;
      if (keepOrder == null) {
        keepOrder = false;
      }
      if (idx == null) {
        return;
      }
      if (!keepOrder && this.switchIndices && idx !== this.currentLayer && this.getIndexInRange(idx) === this._focusedItem.currentSlot) {
        _ref = this.getRelativeItemPosition(idx, true), distance = _ref[0], relativeIndex = _ref[1];
        if (relativeIndex > this.currentLayer) {
          idx++;
        } else {
          idx--;
        }
      }
      idx = this.getIndexInRange(idx);
      newItemIndex = this._itemIndices[idx];
      newItem = this._getItem(newItemIndex);
      if (this.switchIndices) {
        this._itemIndices[idx] = this._focusedItem.id;
        this._itemIndices[this._focusedItem.currentSlot] = newItemIndex;
        newItem.currentSlot = this._focusedItem.currentSlot;
        this._focusedItem.currentSlot = idx;
      }
      this._focusedItem = newItem;
      this.currentLayer = idx;
      this._focusedItem.prepareFadeIn();
      _ref1 = this.items;
      for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
        item = _ref1[_i];
        if (item !== this._focusedItem) {
          item.prepareFadeOut();
        }
      }
      _ref2 = this.items;
      for (_j = 0, _len1 = _ref2.length; _j < _len1; _j++) {
        item = _ref2[_j];
        item.runAnimation();
      }
      this._autoShiftInit();
      this._refreshControls();
      if (this.lightbox.enabled && lightboxIsVisible()) {
        this.showLightbox();
      }
      if (this.scrollbar.enabled) {
        scrollbarIdx = idx;
        if (idx === this._focusedItem.currentSlot) {
          scrollbarIdx = this._focusedItem.currentSlot + 1;
        }
        this.scrollbar._instance.setPosition(scrollbarIdx, false);
      }
      return typeof this.onAfterShift === "function" ? this.onAfterShift(idx) : void 0;
    };

    Rondell.prototype.getRelativeItemPosition = function(idx, wrapIndices) {
      var distance, relativeIndex;
      if (wrapIndices == null) {
        wrapIndices = this.wrapIndices;
      }
      distance = Math.abs(idx - this.currentLayer);
      relativeIndex = idx;
      if (distance > this.visibleItems && distance > this.maxItems / 2 && this.repeating && wrapIndices) {
        if (idx > this.currentLayer) {
          relativeIndex -= this.maxItems;
        } else {
          relativeIndex += this.maxItems;
        }
        distance = Math.abs(relativeIndex - this.currentLayer);
      }
      return [distance, relativeIndex];
    };

    Rondell.prototype.getIndexInRange = function(idx) {
      if (this.repeating) {
        if (idx < 1) {
          idx += this.maxItems;
        } else if (idx > this.maxItems) {
          idx -= this.maxItems;
        }
      } else {
        if (idx < 1) {
          idx = 1;
        } else if (idx > this.maxItems) {
          idx = this.maxItems;
        }
      }
      return idx;
    };

    Rondell.prototype._refreshControls = function() {
      if (!this.controls.enabled) {
        return;
      }
      this.controls._shiftLeft.stop().fadeTo(this.controls.fadeTime, 1);
      return this.controls._shiftRight.stop().fadeTo(this.controls.fadeTime, 1);
      
      /* animate controlls
      this.controls._shiftLeft.stop().fadeTo(this.controls.fadeTime, (this.currentLayer > 1 || this.repeating) && this.hovering ? 1 : 0);
      return this.controls._shiftRight.stop().fadeTo(this.controls.fadeTime, (this.currentLayer < this.maxItems || this.repeating) && this.hovering ? 1 : 0);
       */
    };

    Rondell.prototype.shiftLeft = function(e) {
      if (e != null) {
        e.preventDefault();
      }
      return this.shiftTo(this.currentLayer - 1);
    };

    Rondell.prototype.shiftRight = function(e) {
      if (e != null) {
        e.preventDefault();
      }
      return this.shiftTo(this.currentLayer + 1);
    };

    Rondell.prototype._autoShiftInit = function() {
      var autoRotation;
      autoRotation = this.autoRotation;
      if (this.isActive() && autoRotation.enabled && autoRotation._timer < 0) {
        return autoRotation._timer = window.setTimeout(this._autoShift, autoRotation.delay);
      }
    };

    Rondell.prototype._autoShift = function() {
      this.autoRotation._timer = -1;
      if (this.isActive() && this.isFocused() && !lightboxIsVisible() && !this.autoRotation.paused) {
        if (this.autoRotation.direction) {
          return this.shiftRight();
        } else {
          return this.shiftLeft();
        }
      } else {
        return this._autoShiftInit();
      }
    };

    Rondell.prototype.onWindowFocus = function() {
      return this._windowFocused = true;
    };

    Rondell.prototype.onWindowBlur = function() {
      return this._windowFocused = false;
    };

    Rondell.prototype.isActive = function() {
      return true;
    };

    Rondell.prototype.isFocused = function() {
      return this._windowFocused && Rondell.activeRondell === this.id;
    };

    Rondell.prototype.keyDown = function(e) {
      var keyCode, now;
      if (!(this.isActive() && this.isFocused())) {
        return;
      }
      now = (new Date()).getTime();
      if (this._lastKeyEvent > now - this.keyDelay) {
        return;
      }
      if (this.autoRotation._timer >= 0) {
        window.clearTimeout(this.autoRotation._timer);
        this.autoRotation._timer = -1;
      }
      this._lastKeyEvent = now;
      keyCode = e.which || e.keyCode;
      switch (keyCode) {
        case 37:
          return this.shiftLeft(e);
        case 39:
          return this.shiftRight(e);
        case 27:
          return closeLightbox();
      }
    };

    Rondell.prototype.showLightbox = function() {
      var lightbox, lightboxContent,
        _this = this;
      lightbox = getLightbox();
      lightboxContent = $('.rondell-lightbox-content', lightbox);
      if (!lightboxIsVisible()) {
        lightbox.add(lightboxContent).css('visibility', 'hidden');
      }
      return lightboxContent.stop().fadeTo(100, 0, function() {
        var attr, content, icon, iconCopy, linkTarget, linkUrl, _i, _len, _ref;
        content = $('.rondell-lightbox-inner', lightboxContent).html(_this._focusedItem.object.html());
        $('.rondell-lightbox-position').text("" + _this.currentLayer + " | " + _this.maxItems);
        $("." + _this.classes.overlay, content).style = '';
        if (_this._focusedItem.isLink) {
          linkUrl = _this._focusedItem.object.attr('href');
          linkTarget = _this._focusedItem.object.attr('target');
          $("." + _this.classes.caption, content).append("<a href='" + linkUrl + "' target='" + linkTarget + "'>" + _this.strings.more + "</a>").attr('style', '');
        }
        icon = $("." + _this.classes.image, content);
        if (icon && _this._focusedItem.referencedImage) {
          _ref = ['style', 'width', 'height'];
          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            attr = _ref[_i];
            icon.removeAttr(attr);
          }
          icon[0].src = _this._focusedItem.referencedImage;
        }

	//$(".rondell-lightbox-content").css('left', '50%');	

        if (icon && !icon[0].complete) {
          iconCopy = $("<img style=\"display:none\"/>");
          lightboxContent.append(_this.iconCopy);
          return iconCopy.one('load', updateLightbox)[0].src = _this._focusedItem.referencedImage;
        } else {
          return setTimeout(updateLightbox, 0);
        }
      });
    };

    return Rondell;

  })();
  getActiveRondell = function() {
    return $(".rondell-instance-" + Rondell.activeRondell).data('api');
  };
  resizeTimer = 0;
  resizeLightbox = function() {
    clearTimeout(resizeTimer);
    if (lightboxIsVisible()) {
      return resizeTimer = setTimeout(updateLightbox, 200);
    }
  };
  lightboxIsVisible = function() {
    var _ref;
    return (_ref = $.rondell.lightbox.instance) != null ? _ref.is(':visible') : void 0;
  };
  closeLightbox = function() {
    if (lightboxIsVisible()) {
      return getLightbox().stop().fadeOut(150);
    }
  };
  getLightbox = function() {
    var lightbox;
    if (!$.rondell.lightbox.instance) {
      lightbox = $.rondell.lightbox.instance = $($.rondell.lightbox.template).appendTo($('body'));
      $('.rondell-lightbox-overlay, .rondell-lightbox-close', lightbox).bind('click.rondell', closeLightbox);
      $('.rondell-lightbox-prev', lightbox).bind('click.rondell', function() {
        return getActiveRondell().shiftLeft();
      });
      $('.rondell-lightbox-next', lightbox).bind('click.rondell', function() {
        return getActiveRondell().shiftRight();
      });
      $window.bind('resize.rondell', resizeLightbox);
      lightbox.bind("mousewheel.rondell", function(e, d, dx, dy) {
        return getActiveRondell()._onMousewheel(e, d, dx, dy);
      });
    }
    return $.rondell.lightbox.instance;
  };

  updateLightbox = function() {
    var $lightbox, $lightboxContent, activeRondell, focusedItem, image, imageDimension, imageHeight, imageWidth, maxHeight, maxWidth, newHeight, newProps, newWidth, updateCallback, winHeight, winWidth, windowPadding;
    $lightbox = getLightbox();
    $lightboxContent = $('.rondell-lightbox-content', $lightbox);
    winWidth = $window.innerWidth();
    winHeight = $window.innerHeight();
if(window.location.href.indexOf("societygent") > 0) {
    winHeight = document.body.clientHeight;
}
    windowPadding = 20;
    activeRondell = getActiveRondell();
    focusedItem = activeRondell._focusedItem;
    $lightbox.css('display', 'block');
    image = $('img:first', $lightboxContent);
    if (image.length) {
if(window.location.href.indexOf("dee-trade") >= 0 || true) {
      if (!focusedItem.lightboxImageWidth || (true)) {
        focusedItem.lightboxImageWidth = image[0].width;
        focusedItem.lightboxImageHeight = image[0].height;
        pixelRatio = window.devicePixelRatio || 1;
         
        if(!(pixelRatio > 1)) {
                pixelRatio = 1;
        }

if(window.location.href.indexOf("dee-trade") >= 0) {
if(pixelRatio == 1) {
pixelRatio = 2;
}
}

var isV2 = false;

if(pixelRatio > 1) {
if(((image[0].naturalWidth / pixelRatio) > ($window.width() - 0)) || ((image[0].naturalHeight / pixelRatio) > ($window.height() - 0))) {
    focusedItem.lightboxImageWidth = $window.width() - 0;
    focusedItem.lightboxImageHeight = $window.height() - 0;
}
else if (((image[0].naturalWidth / 1) < ($window.width() - 10)) && ((image[0].naturalHeight) < ($window.height() - 10))){
    isV2 = true;
    }
else {
    focusedItem.lightboxImageWidth = image[0].naturalWidth / pixelRatio;
focusedItem.lightboxImageHeight = image[0].naturalHeight / pixelRatio;
}
}

        image.attr('width', focusedItem.lightboxImageWidth);
      }
}
else {
      if (!focusedItem.lightboxImageWidth) {
        focusedItem.lightboxImageWidth = image[0].width;
        focusedItem.lightboxImageHeight = image[0].height;
        image.attr('width', focusedItem.lightboxImageWidth).attr('height', focusedItem.lightboxImageHeight);
      }
}
      imageWidth = focusedItem.lightboxImageWidth;
      imageHeight = focusedItem.lightboxImageHeight;

      imageDimension = imageWidth / imageHeight;
      maxWidth = winWidth - windowPadding * 2;
      maxHeight = winHeight - windowPadding * 2;

      if (imageWidth > maxWidth) {
        imageWidth = maxWidth;
        imageHeight = imageWidth / imageDimension;
      }
      if (imageHeight > maxHeight) {
        imageHeight = maxHeight;
        imageWidth = imageHeight * imageDimension;
      }

    }
    $lightbox.add($lightboxContent).css('visibility', 'visible');
    newWidth = $lightboxContent.outerWidth();
    if(!isV2) {
        newWidth = focusedItem.lightboxImageWidth;
    }
    newHeight = $lightboxContent.outerHeight();

$(".rondell-lightbox-content").css('left', '50%');

    newProps = {
      marginLeft: -newWidth / 2,
      top: Math.max((winHeight - newHeight) / 2, 20)
    };
    updateCallback = function() {
      return typeof activeRondell.onUpdateLightbox === "function" ? activeRondell.onUpdateLightbox(focusedItem) : void 0;
    };
    if ($lightboxContent.css('opacity') < 1) {
      $lightboxContent.css(newProps).fadeTo(200, 1, updateCallback);
    } else {
      newProps.opacity = 1;
      $lightboxContent.animate(newProps, 200, updateCallback);
    }
    return $lightbox.stop().fadeTo(150, 1);
  };

  updateLightboxOrginal = function() {
    var $lightbox, $lightboxContent, activeRondell, focusedItem, image, imageDimension, imageHeight, imageWidth, maxHeight, maxWidth, newHeight, newProps, newWidth, updateCallback, winHeight, winWidth, windowPadding;
    $lightbox = getLightbox();
    $lightboxContent = $('.rondell-lightbox-content', $lightbox);
    winWidth = $window.innerWidth();
    winHeight = $window.innerHeight();
if(window.location.href.indexOf("societygent") > 0) {
    winHeight = document.body.clientHeight;
}
    windowPadding = 20;
    activeRondell = getActiveRondell();
    focusedItem = activeRondell._focusedItem;
    $lightbox.css('display', 'block');
    image = $('img:first', $lightboxContent);
    if (image.length) {
if(window.location.href.indexOf("dee-trade") >= 0) {
      if (!focusedItem.lightboxImageWidth || (true)) {
        focusedItem.lightboxImageWidth = image[0].width;
        focusedItem.lightboxImageHeight = image[0].height;
        pixelRatio = window.devicePixelRatio || 1;
        if(pixelRatio != 2 && pixelRatio != 3) {
                pixelRatio = 1;
        }

if(window.location.href.indexOf("dee-trade") >= 0) {
if(pixelRatio == 1) {
pixelRatio = 2;
}
}

if(pixelRatio > 1) {
if((image[0].naturalWidth < ($window.width() - 100)) && (image[0].naturalHeight < ($window.height() - 100))) {
}
else {
focusedItem.lightboxImageWidth = image[0].naturalWidth / pixelRatio;
focusedItem.lightboxImageHeight = image[0].naturalHeight / pixelRatio;
}
}

        image.attr('width', focusedItem.lightboxImageWidth).attr('height', focusedItem.lightboxImageHeight);
      }
}
else {
      if (!focusedItem.lightboxImageWidth) {
        focusedItem.lightboxImageWidth = image[0].width;
        focusedItem.lightboxImageHeight = image[0].height;
        image.attr('width', focusedItem.lightboxImageWidth).attr('height', focusedItem.lightboxImageHeight);
      }
}
      imageWidth = focusedItem.lightboxImageWidth;
      imageHeight = focusedItem.lightboxImageHeight;

      imageDimension = imageWidth / imageHeight;
      maxWidth = winWidth - windowPadding * 2;
      maxHeight = winHeight - windowPadding * 2;

      if (imageWidth > maxWidth) {
        imageWidth = maxWidth;
        imageHeight = imageWidth / imageDimension;
      }
      if (imageHeight > maxHeight) {
        imageHeight = maxHeight;
        imageWidth = imageHeight * imageDimension;
      }

    }
    $lightbox.add($lightboxContent).css('visibility', 'visible');
    newWidth = $lightboxContent.outerWidth();
    newHeight = $lightboxContent.outerHeight();

$(".rondell-lightbox-content").css('left', '50%');

    newProps = {
      marginLeft: -newWidth / 2,
      top: Math.max((winHeight - newHeight) / 2, 20)
    };
    updateCallback = function() {
      return typeof activeRondell.onUpdateLightbox === "function" ? activeRondell.onUpdateLightbox(focusedItem) : void 0;
    };
    if ($lightboxContent.css('opacity') < 1) {
      $lightboxContent.css(newProps).fadeTo(200, 1, updateCallback);
    } else {
      newProps.opacity = 1;
      $lightboxContent.animate(newProps, 200, updateCallback);
    }
    return $lightbox.stop().fadeTo(150, 1);
  };
  return $.fn.rondell = function(options, callback) {
    var rondell;
    if (options == null) {
      options = {};
    }
    if (callback == null) {
      callback = void 0;
    }
    rondell = new Rondell(this, options, this.length, callback);

    this.each(function(idx) {
		if(rondell.currentLayer == (idx + 1)) {
      return rondell._loadItem(idx + 1, $(this));
	  	}
    });

    this.each(function(idx) {
		if(rondell.currentLayer != (idx + 1)) {
      return rondell._loadItem(idx + 1, $(this));
	  	}
    });

    return rondell;
  };
})(jQPac);

/*!
  Presets for jQuery rondell plugin

  @author Sebastian Helzle (sebastian@helzle.net or @sebobo)
  @category jQuery plugin
  @copyright (c) 2009-2013 Sebastian Helzle (www.sebastianhelzle.net)
  @license Licensed under the MIT (http://www.opensource.org/licenses/mit-license.php) license.
*/

(function($) {
  $.rondell || ($.rondell = {});
  return $.rondell.presets = {
    carousel: {
      autoRotation: {
        enabled: true,
        direction: 1,
        once: false,
        delay: 5000
      },
      radius: {
        x: 240,
        y: 50
      },
      center: {
        left: 340,
        top: 160
      },
      controls: {
        margin: {
          x: 130,
          y: 260
        }
      },
      randomStart: true,
      currentLayer: 1,
      funcSize: function(l, r, i) {
        return 1 / Math.abs(l);
      }
    },
    scroller: {
      repeating: false,
      alwaysShowCaption: true,
      visibleItems: 4,
      theme: "dark",
      lightbox: {
        enabled: false
      },
      itemProperties: {
        delay: 0,
        size: {
          width: 100,
          height: 200
        },
        sizeFocused: {
          width: 300,
          height: 200
        }
      },
      center: {
        left: 400,
        top: 100
      },
      size: {
        width: 800,
        height: 200
      },
      controls: {
        margin: {
          x: 210,
          y: 158
        }
      },
      funcTop: function(l, r, i) {
        return 0;
      },
      funcDiff: function(d, r, i) {
        return Math.abs(d) + 1;
      },
      funcLeft: function(l, r, i) {
        return r.center.left + (l - 0.5) * r.itemProperties.size.width;
      },
      funcOpacity: function(l, r, i) {
        return 0.8;
      }
    },
    pages: {
      radius: {
        x: 0,
        y: 0
      },
      lightbox: {
        enabled: false
      },
      scaling: 1,
      theme: "page",
      visibleItems: 1,
      controls: {
        margin: {
          x: 0,
          y: 0
        }
      },
      strings: {
        prev: ' ',
        next: ' '
      },
      center: {
        left: 200,
        top: 200
      },
      itemProperties: {
        size: {
          width: 400,
          height: 400
        }
      },
      funcTop: function(l, r, i) {
        return r.center.top - r.itemProperties.size.height / 2;
      },
      funcLeft: function(l, r, i) {
        return r.center.left + l * r.itemProperties.size.width;
      },
      funcDiff: function(l, r, i) {
        return Math.abs(l) + 0.5;
      }
    },
    cubic: {
      center: {
        left: 300,
        top: 200
      },
      visibleItems: 5,
      itemProperties: {
        size: {
          width: 350,
          height: 350
        },
        sizeFocused: {
          width: 350,
          height: 350
        }
      },
      controls: {
        margin: {
          x: 70,
          y: 330
        }
      },
      funcTop: function(l, r, i) {
        return r.center.top - r.itemProperties.size.height / 2 + Math.pow(l / 2, 3) * r.radius.x;
      },
      funcLeft: function(l, r, i) {
        return r.center.left - r.itemProperties.size.width / 2 + Math.sin(l) * r.radius.x;
      },
      funcSize: function(l, r, i) {
        return Math.pow((Math.PI - Math.abs(l)) / Math.PI, 3);
      }
    },
    gallery: {
      special: {
        itemPadding: 2
      },
      visibleItems: 5,
      theme: "dark",
      cropThumbnails: true,
      center: {
        top: 145,
        left: 250
      },
      size: {
        height: 400,
        width: 500
      },
      controls: {
        margin: {
          x: 10,
          y: 255
        }
      },
      itemProperties: {
        delay: 0,
        sizeFocused: {
          width: 480,
          height: 280
        },
        size: {
          width: 80,
          height: 100
        }
      },
      funcTop: function(l, r, i) {
        return r.size.height - r.itemProperties.size.height - r.special.itemPadding;
      },
      funcDiff: function(d, r, i) {
        return Math.abs(d) - 0.5;
      },
      funcLeft: function(l, r, i) {
        return r.center.left + (l - 0.5) * (r.itemProperties.size.width + r.special.itemPadding);
      },
      funcOpacity: function(l, r, i) {
        return 0.8;
      }
    },
    thumbGallery: {
      special: {
        columns: 3,
        rows: 3,
        groupSize: 9,
        itemPadding: 5,
        thumbsOffset: {
          x: 500,
          y: 0
        }
      },
      visibleItems: 9,
      wrapIndices: false,
      currentLayer: 1,
      switchIndices: true,
      cropThumbnails: true,
      center: {
        top: 215,
        left: 250
      },
      size: {
        height: 430,
        width: 800
      },
      controls: {
        enabled: false,
        margin: {
          x: 10,
          y: 255
        }
      },
      itemProperties: {
        delay: 40,
        sizeFocused: {
          width: 480,
          height: 420
        },
        size: {
          width: 94,
          height: 126
        }
      },
      scrollbar: {
        enabled: true,
        stepSize: 9,
        start: 2,
        style: {
          width: 292,
          right: 3,
          bottom: 5
        }
      },
      funcDiff: function(d, r, i) {
        return Math.abs(d);
      },
      funcOpacity: function(l, r, i) {
        var currentLayerIndex;
        currentLayerIndex = r.currentLayer > r._focusedItem.currentSlot ? r.currentLayer - 1 : r.currentLayer;
        if (i > r._focusedItem.currentSlot) {
          i--;
        }
        if (Math.floor((i - 1) / r.special.groupSize) === Math.floor((currentLayerIndex - 1) / r.special.groupSize)) {
          return 0.8;
        } else {
          return 0;
        }
      },
      funcTop: function(l, r, i) {
        if (i > r._focusedItem.currentSlot) {
          i--;
        }
        return r.special.thumbsOffset.y + r.special.itemPadding + Math.floor(((i - 1) % r.special.groupSize) / r.special.rows) * (r.itemProperties.size.height + r.special.itemPadding);
      },
      funcLeft: function(l, r, i) {
        var column, currentLayerIndex, groupOffset;
        currentLayerIndex = r.currentLayer > r._focusedItem.currentSlot ? r.currentLayer - 1 : r.currentLayer;
        if (i > r._focusedItem.currentSlot) {
          i--;
        }
        column = ((i - 1) % r.special.groupSize) % r.special.columns;
        groupOffset = Math.floor((i - 1) / r.special.groupSize) - Math.floor((currentLayerIndex - 1) / r.special.groupSize);
        return r.special.thumbsOffset.x + r.special.itemPadding + (column + r.special.columns * groupOffset) * (r.itemProperties.size.width + r.special.itemPadding);
      }
    },
    slider: {
      theme: 'slider',
      visibleItems: 1,
      fadeTime: 1000,
      opacityMin: 0.0,
      autoRotation: {
        enabled: true
      },
      center: {
        top: 150,
        left: 300
      },
      size: {
        height: 300,
        width: 600
      },
      controls: {
        margin: {
          x: -1,
          y: 135
        }
      },
      strings: {
        prev: '<button class="lg-prev lg-icon"></button>',
        next: '<button class="lg-next lg-icon"></button>'
      },
      itemProperties: {
        sizeFocused: {
          width: 600,
          height: 300
        },
        size: {
          width: 600,
          height: 300
        }
      },
      funcTop: function(l, r, i) {
        return 0;
      },
      funcLeft: function(l, r, i) {
        return 0;
      },
      funcOpacity: function(l, r, i) {
        return 0.02;
      }
    }
  };
})(jQPac);

/*!
  Scrollbar for jQuery rondell plugin
  
  @author Sebastian Helzle (sebastian@helzle.net or @sebobo)
  @category jQuery plugin
  @copyright (c) 2009-2012 Sebastian Helzle (www.sebastianhelzle.net)
  @license Licensed under the MIT (http://www.opensource.org/licenses/mit-license.php) license.
*/

var __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

(function($) {
  $.rondell || ($.rondell = {});
  return $.rondell.RondellScrollbar = (function() {
    function RondellScrollbar(container, options) {
      this.scrollRight = __bind(this.scrollRight, this);
      this.scrollLeft = __bind(this.scrollLeft, this);
      this.onScrollbarClick = __bind(this.onScrollbarClick, this);
      this.onDragStart = __bind(this.onDragStart, this);
      this.onDrag = __bind(this.onDrag, this);
      this.setPosition = __bind(this.setPosition, this);
      this.scrollTo = __bind(this.scrollTo, this);
      this.updatePosition = __bind(this.updatePosition, this);
      this._initControls = __bind(this._initControls, this);
      $.extend(true, this, $.rondell.defaults.scrollbar, options);
      this.container = container.addClass(this.classes.container);
      this._drag = {
        _dragging: false,
        _lastDragEvent: 0
      };
      this.container.addClass("" + this.classes.container + "-" + this.orientation).css(this.style);
      this._initControls();
      this._minX = this.padding + this.scrollLeftControl.outerWidth() + this.scrollControl.outerWidth() / 2;
      this._maxX = this.container.innerWidth() - this.padding - this.scrollRightControl.outerWidth() - this.scrollControl.outerWidth() / 2;
      this.setPosition(this.position, false, true);
    }

    RondellScrollbar.prototype._initControls = function() {
      var scrollControlTemplate;
      scrollControlTemplate = "<div><span class=\"" + this.classes.scrollInner + "\">&nbsp;</span></div>";
      this.scrollLeftControl = $(scrollControlTemplate).addClass(this.classes.scrollLeft).click(this.scrollLeft);
      this.scrollRightControl = $(scrollControlTemplate).addClass(this.classes.scrollRight).click(this.scrollRight);
      this.scrollControl = $("<div class=\"" + this.classes.control + "\">&nbsp;</div>").css("left", this.container.innerWidth() / 2).mousedown(this.onDragStart);
      this.scrollBackground = $("<div class=\"" + this.classes.background + "\"/>");
      this.container.append(this.scrollBackground, this.scrollLeftControl, this.scrollRightControl, this.scrollControl);
      return this.container.add(this.scrollBackground).click(this.onScrollbarClick);
    };

    RondellScrollbar.prototype.updatePosition = function(position, fireCallback) {
      if (fireCallback == null) {
        fireCallback = true;
      }
      if (!position || position === this.position || position < this.start || position > this.end) {
        return;
      }
      this.position = position;
      if (fireCallback) {
        return typeof this.onScroll === "function" ? this.onScroll(position, true) : void 0;
      }
    };

    RondellScrollbar.prototype.scrollTo = function(x, animate, fireCallback) {
      var newPosition, scroller, target;
      if (animate == null) {
        animate = true;
      }
      if (fireCallback == null) {
        fireCallback = true;
      }
      if (x < this._minX || x > this._maxX) {
        return;
      }
      scroller = this.scrollControl.stop(true);
      target = {
        left: x
      };
      if (animate) {
        scroller.animate(target, this.animationDuration, this.easing);
      } else {
        scroller.css(target);
      }
      newPosition = Math.round((x - this._minX) / (this._maxX - this._minX) * (this.end - this.start)) + this.start;
      if (newPosition !== this.position) {
        return this.updatePosition(newPosition, fireCallback);
      }
    };

    RondellScrollbar.prototype.setPosition = function(position, fireCallback, force) {
      var newX;
      if (fireCallback == null) {
        fireCallback = true;
      }
      if (force == null) {
        force = false;
      }
      if (this.repeating) {
        if (position < this.start) {
          position = this.end;
        }
        if (position > this.end) {
          position = this.start;
        }
      }
      if (!force && (position < this.start || position > this.end || position === this.position)) {
        return;
      }
      newX = Math.round((position - this.start) / (this.end - this.start) * (this._maxX - this._minX)) + this._minX;
      return this.scrollTo(newX, true, fireCallback);
    };

    RondellScrollbar.prototype.onDrag = function(e) {
      var newX, _ref;
      e.preventDefault();
      if (!this._drag._dragging) {
        return;
      }
      if (e.type === "mouseup") {
        this._drag._dragging = false;
        this.scrollControl.removeClass(this.classes.dragging);
        return $(window).unbind("mousemove mouseup", this.onDrag);
      } else {
        newX = 0;
        if ((_ref = this.orientation) === "top" || _ref === "bottom") {
          newX = e.pageX - this.container.offset().left;
        } else {
          newX = e.pageY - this.container.offset().top;
        }
        newX = Math.max(this._minX, Math.min(this._maxX, newX));
        return this.scrollTo(newX, false);
      }
    };

    RondellScrollbar.prototype.onDragStart = function(e) {
      e.preventDefault();
      this._drag._dragging = true;
      this.scrollControl.addClass(this.classes.dragging);
      return $(window).bind("mousemove mouseup", this.onDrag);
    };

    RondellScrollbar.prototype.onScrollbarClick = function(e) {
      return this.scrollTo(e.pageX - this.container.offset().left);
    };

    RondellScrollbar.prototype.scrollLeft = function(e) {
      var newPosition;
      e.preventDefault();
      newPosition = this.position - this.stepSize;
      if (this.keepStepOrder && this.stepSize > 1) {
        if (newPosition >= this.start) {
          newPosition -= (newPosition - this.start) % this.stepSize;
        } else if (this.repeating) {
          newPosition = this.start + Math.floor((this.end - this.start) / this.stepSize) * this.stepSize;
        }
      }
      return this.setPosition(newPosition);
    };

    RondellScrollbar.prototype.scrollRight = function(e) {
      var newPosition;
      e.preventDefault();
      newPosition = this.position + this.stepSize;
      if (this.keepStepOrder && this.stepSize > 1) {
        newPosition -= (newPosition - this.start) % this.stepSize;
        if (this.repeating && newPosition > this.end) {
          newPosition = this.start;
        }
      }
      return this.setPosition(newPosition);
    };

    return RondellScrollbar;

  })();
})(jQPac);

/*!
  RondellItem for jQuery rondell plugin

  @author Sebastian Helzle (sebastian@helzle.net or @sebobo)
  @category jQuery plugin
  @copyright (c) 2009-2012 Sebastian Helzle (www.sebastianhelzle.net)
  @license Licensed under the MIT (http://www.opensource.org/licenses/mit-license.php) license.
*/

var __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

(function($) {
  $.rondell || ($.rondell = {});
  return $.rondell.RondellItem = (function() {
    function RondellItem(id, object, rondell) {
      this.id = id;
      this.object = object;
      this.rondell = rondell;
      this.runAnimation = __bind(this.runAnimation, this);
      this.onAnimationFinished = __bind(this.onAnimationFinished, this);
      this.prepareFadeOut = __bind(this.prepareFadeOut, this);
      this.prepareFadeIn = __bind(this.prepareFadeIn, this);
      this.hideCaption = __bind(this.hideCaption, this);
      this.showCaption = __bind(this.showCaption, this);
      this.onMouseLeave = __bind(this.onMouseLeave, this);
      this.onMouseEnter = __bind(this.onMouseEnter, this);
      this.finalize = __bind(this.finalize, this);
      this.onError = __bind(this.onError, this);
      this.onIconLoad = __bind(this.onIconLoad, this);
      this.refreshDimensions = __bind(this.refreshDimensions, this);
      this.init = __bind(this.init, this);
      this.currentSlot = this.id;
      this.focused = false;
      this.hidden = false;
      this.animating = false;
      this.isNew = true;
      this.icon = null;
      this.resizeable = true;
      this.iconCopy = null;
      this.croppedSize = this.rondell.itemProperties.size;
      this.sizeSmall = this.rondell.itemProperties.size;
      this.sizeFocused = this.rondell.itemProperties.sizeFocused;
      this.objectCSSTarget = {};
      this.objectAnimationTarget = {};
      this.lastObjectAnimationTarget = {};
      this.iconAnimationTarget = {};
      this.lastIconAnimationTarget = {};
      this.animationSpeed = this.rondell.fadeTime;
      this.isLink = this.object.is('a');
      this.referencedImage = null;
    }

    RondellItem.prototype.init = function() {
      var filetype, icon, linkType, linkUrl, _i, _len, _ref;
      if (this.object.is('img')) {
        this.object = this.object.wrap("<div/>").parent();
      }
      this.object.addClass("" + this.rondell.classes.item).data('item', this).css({
        opacity: 0,
        width: this.sizeSmall.width,
        height: this.sizeSmall.height,
        left: this.rondell.center.left - this.sizeFocused.width / 2,
        top: this.rondell.center.top - this.sizeFocused.height / 2
      });
      if (this.isLink && this.rondell.lightbox.displayReferencedImages) {
        linkUrl = this.object.attr('href');
        linkType = this._getFiletype(linkUrl);
        _ref = this.rondell.imageFiletypes;
	this.referencedImage = linkUrl;
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          filetype = _ref[_i];
          if (!(linkType === filetype)) {
            continue;
          }
          this.referencedImage = linkUrl;
          break;
        }
      }
      icon = this.object.find('img:first');
      if (icon.length) {
        this.icon = icon;
        this.resizeable = !icon.hasClass(this.rondell.classes.noScale);
        this.icon.addClass(this.rondell.classes.image);
        //this.object.addClass(this.rondell.classes.loading);
	//var idFromArray = icon.attr("id").replce("gs", "");	
	//console.debug(icon.attr("src"));	
//icon.width(30); 
       if (icon.width() > 0 || (icon[0].width > 0)) {
          return window.setTimeout(this.onIconLoad, 10);
        } else {
          this.iconCopy = $("<img style=\"display:none\"/>");
          $('body').append(this.iconCopy);
          return this.iconCopy.one('load', this.onIconLoad).one('error', this.onError).attr('src', icon.attr('src'));
        }
      } else {
        return this.finalize();
      }
    };

    RondellItem.prototype._getFiletype = function(filename) {
      return filename.substr(filename.lastIndexOf('.') + 1).toLowerCase();
    };

    RondellItem.prototype.refreshDimensions = function() {
      var croppedSize, foHeight, foWidth, focusedSize, iconHeight, iconWidth, itemSize, smHeight, smWidth, _ref, _ref1, _ref2, _ref3, _ref4;
      iconWidth = ((_ref = this.iconCopy) != null ? _ref.width() : void 0) || ((_ref1 = this.iconCopy) != null ? _ref1[0].width : void 0) || this.icon[0].width || this.icon.width();
      iconHeight = ((_ref2 = this.iconCopy) != null ? _ref2.height() : void 0) || ((_ref3 = this.iconCopy) != null ? _ref3[0].height : void 0) || this.icon[0].height || this.icon.height();
      foWidth = smWidth = iconWidth;
      foHeight = smHeight = iconHeight;
      itemSize = this.rondell.itemProperties.size;
      focusedSize = this.rondell.itemProperties.sizeFocused;
      croppedSize = itemSize;
      if ((_ref4 = this.iconCopy) != null) {
        _ref4.remove();
      }
      if (!(iconWidth && iconHeight)) {
        return;
      }
      if (this.resizeable) {
        this.icon.addClass(this.rondell.classes.resizeable);
        smHeight *= itemSize.width / smWidth;
        smWidth = itemSize.width;
        if (smHeight > itemSize.height) {
          smWidth *= itemSize.height / smHeight;
          smHeight = itemSize.height;
        }
        if (this.rondell.cropThumbnails) {
          if (!this.icon.parent().hasClass(this.rondell.classes.crop)) {
            this.icon.wrap($("<div>").addClass(this.rondell.classes.crop));
          }
          croppedSize = {
            width: itemSize.width,
            height: itemSize.width / smWidth * smHeight
          };
	if ((croppedSize.height < itemSize.height) && (!forceThumbnailFull)) {
            croppedSize = {
              width: itemSize.height / croppedSize.height * croppedSize.width,
              height: itemSize.height
            };
          }

          // ALWAYS FIT CONTAINER
		  try {
		  if(window.dontcropimages) {
          if(croppedSize.width > window.thumbSizeX) {
                croppedSize.height = croppedSize.height * (window.thumbSizeX / croppedSize.width);
                croppedSize.width = window.thumbSizeX;
          }

          if(croppedSize.height > window.thumbSizeX) {
                croppedSize.width = croppedSize.width * (window.thumbSizeX / croppedSize.height);
                croppedSize.height = window.thumbSizeX;
          }
		  }
		  }
		  catch(err) {
		  }
          // ALWAYS FIT CONTAINER END	

          smWidth = itemSize.width;
          smHeight = itemSize.height;
        }
        foHeight *= focusedSize.width / foWidth;
        foWidth = focusedSize.width;
        if (foHeight > focusedSize.height) {
          foWidth *= focusedSize.height / foHeight;
          foHeight = focusedSize.height;
        }
      } else {
        smWidth = itemSize.width;
        smHeight = itemSize.height;
        foWidth = focusedSize.width;
        foHeight = focusedSize.height;
      }
      this.croppedSize = croppedSize;
      this.iconWidth = iconWidth;
      this.iconHeight = iconHeight;
      this.sizeSmall = {
        width: Math.round(smWidth),
        height: Math.round(smHeight)
      };

        var widthGS = Math.round(foWidth);
        var heightGS = Math.round(foHeight);

if(widthGS > iconWidth && (iconWidth > 120)) {
                foWidth = iconWidth;
                foHeight = iconHeight;
        }


		try {
		if((jQPac(this.icon.get(0)).attr('alt').indexOf('vimeo') != -1) || (jQPac(this.icon.get(0)).attr('alt').indexOf('youtu.be') != -1) || (jQPac(this.icon.get(0)).attr('alt').indexOf('youtube.com') != -1) || (jQPac(this.icon.get(0)).attr('alt').indexOf('youtube-nocookie.com') != -1)) {

		 if((jQPac('#rondellCarousel').width() > 0) && (jQPac('#rondellCarousel').height() > 0)) {


			 if(presentationType == 1 && navinleft == true) {
			     return this.sizeFocused = {
			       width: jQPac('#rondellCarousel').width() - thumbSizeX,
			       height: jQPac('#rondellCarousel').height()
			     }; 				 
			 }
			 else {			 
				 if(presentationType == 1 && navinleft == false) {
				     return this.sizeFocused = {
				       width: jQPac('#rondellCarousel').width(),
				       height: jQPac('#rondellCarousel').height() - thumbSizeX
				     }; 				 
				 }				 
			 }
		 }
		}
		}
		catch(err) {
		}


      return this.sizeFocused = {
        width: Math.round(foWidth),
        height: Math.round(foHeight)
      };
    };

    RondellItem.prototype.onIconLoad = function() {
      this.refreshDimensions();
      return this.finalize();
    };

    RondellItem.prototype.onError = function() {
      var errorString, _ref;
      errorString = this.rondell.strings.loadingError.replace("%s", this.icon.attr("src"));
      this.icon.remove();
      if ((_ref = this.iconCopy) != null) {
        _ref.remove();
      }
      return this.object.removeClass(this.rondell.classes.loading).addClass(this.rondell.classes.error).html("<p>" + errorString + "</p>");
    };

    RondellItem.prototype.finalize = function() {
      var caption, captionContent, captionWrap, _ref, _ref1, _ref2, _ref3;
      this.object.removeClass(this.rondell.classes.loading);
      if (this.rondell.captionsEnabled) {
        captionContent = null;
        if (this.rondell.cropThumbnails) {
          captionContent = (_ref = this.icon) != null ? _ref.closest("." + this.rondell.classes.crop).siblings() : void 0;
        } else {
          captionContent = (_ref1 = this.icon) != null ? _ref1.siblings() : void 0;
        }
        if (!((captionContent != null ? captionContent.length : void 0) || this.icon) && this.object.children().length) {
          captionContent = this.object.children();
        }
        if (!(captionContent != null ? captionContent.length : void 0)) {
          caption = this.object.attr("title") || ((_ref2 = this.icon) != null ? _ref2.attr("title") : void 0) || ((_ref3 = this.icon) != null ? _ref3.attr("alt") : void 0);
          if (caption) {
            //captionContent = $("<p>" + caption + "</p>");
            //this.object.append(captionContent);
          }
        }
        if (captionContent != null ? captionContent.length : void 0) {
          captionWrap = (captionContent.wrapAll("<div/>")).parent().addClass(this.rondell.classes.caption);
          if (this.icon) {
            this.overlay = captionWrap.addClass(this.rondell.classes.overlay);
          }
        }
      }

            jQPac.each( allImagesAddedToSlider, function( index, imageForSlider ) {
            var elID = findImageId(fullallImagesAddedToSlider[index]);
            	//jQPac("#gs" + elID).removeAttr("width").removeAttr("height").css({ width: "", height: "" });
		//jQPac("#gs" + elID).attr("style", "max-width: 10000px !important;");
		//jQPac("#gs" + elID).removeAttr("width").removeAttr("height").css({ width: "auto", height: "auto" });
            });

      return this.rondell.onItemInit(this.id);
    };

    RondellItem.prototype.onMouseEnter = function() {
      if (!this.animating && !this.hidden && this.object.is(":visible")) {
        return this.object.addClass(this.rondell.itemHoveredClass).stop(true).animate({
          opacity: 1
        }, this.rondell.fadeTime, this.rondell.funcEase);
      }
    };

    RondellItem.prototype.onMouseLeave = function() {
      this.object.removeClass(this.rondell.classes.hovered);
      if (!(this.animating || this.hidden)) {
        return this.object.stop(true).animate({
          opacity: this.objectAnimationTarget.opacity
        }, this.rondell.fadeTime, this.rondell.funcEase);
      }
    };

    RondellItem.prototype.showCaption = function() {
      if (this.rondell.captionsEnabled && (this.overlay != null)) {
        return this.overlay.stop(true).css({
          height: "auto",
          overflow: "auto"
        }).fadeTo(300, 1);
      }
    };

    RondellItem.prototype.hideCaption = function() {
      var _ref;
      if (this.rondell.captionsEnabled && ((_ref = this.overlay) != null ? _ref.is(":visible") : void 0)) {
        return this.overlay.stop(true).css({
          height: this.overlay.height(),
          overflow: "hidden"
        }).fadeTo(200, 0);
      }
    };

    RondellItem.prototype.prepareFadeIn = function() {
      var iconMarginLeft, iconMarginTop, itemFocusedHeight, itemFocusedWidth;
      this.focused = true;
      this.hidden = false;
      itemFocusedWidth = this.sizeFocused.width;
      itemFocusedHeight = this.sizeFocused.height;
      this.lastObjectAnimationTarget = this.objectAnimationTarget;
      // top has been changed to 0 by GS
      var topPosCalc = 0;
      if(presentationType == 3) {
          //topPosCalc = 0;
      }
	  if(navinleft) {
	  //topPosCalc = 0;
  	  }
	  
      this.objectAnimationTarget = {
        width: itemFocusedWidth,
        height: itemFocusedHeight,
        left: this.rondell.center.left - itemFocusedWidth / 2,
        top: topPosCalc,
        opacity: 1
      };
      this.objectCSSTarget = {
        zIndex: this.rondell.zIndex + this.rondell.maxItems,
        display: "block"
      };
      this.animationSpeed = this.rondell.fadeTime;
      if (this.icon) {
        this.lastIconAnimationTarget = this.iconAnimationTarget;
        iconMarginLeft = 0;
        iconMarginTop = 0;
        if (!this.resizeable) {
          iconMarginTop = (this.rondell.itemProperties.sizeFocused.height - this.iconHeight) / 2;
          iconMarginLeft = (this.rondell.itemProperties.sizeFocused.width - this.iconWidth) / 2;
          this.iconAnimationTarget.marginTop = iconMarginTop;
          this.iconAnimationTarget.marginLeft = iconMarginLeft;
        }
        if (this.rondell.cropThumbnails) {
          return this.iconAnimationTarget = {
            marginTop: iconMarginTop,
            marginLeft: iconMarginLeft,
            width: itemFocusedWidth,
            height: itemFocusedHeight
          };
        }
      }
    };

    RondellItem.prototype.prepareFadeOut = function() {
      var idx, itemHeight, itemWidth, layerDiff, layerDist, layerPos, newTarget, newZ, _ref;
      this.focused = false;
      idx = this.currentSlot;
      _ref = this.rondell.getRelativeItemPosition(idx), layerDist = _ref[0], layerPos = _ref[1];
      layerDiff = this.rondell.funcDiff(layerPos - this.rondell.currentLayer, this.rondell, idx);
      if (layerPos < this.rondell.currentLayer) {
        layerDiff *= -1;
      }
      itemWidth = this.sizeSmall.width * this.rondell.funcSize(layerDiff, this.rondell);
      itemHeight = this.sizeSmall.height * this.rondell.funcSize(layerDiff, this.rondell);
      newZ = this.rondell.zIndex - layerDist;
      this.animationSpeed = this.rondell.fadeTime + this.rondell.itemProperties.delay * layerDist;

      var opacityPerPresentation = 0;
      if(presentationType == 1) {
        opacityPerPresentation = 1;
      }

      newTarget = {
        width: itemWidth,
        height: itemHeight,
        left: this.rondell.funcLeft(layerDiff, this.rondell, idx) + (this.rondell.itemProperties.size.width - itemWidth) / 2,
        top: this.rondell.funcTop(layerDiff, this.rondell, idx) + (this.rondell.itemProperties.size.height - itemHeight) / 2,
        opacity: opacityPerPresentation
      };
      this.objectCSSTarget = {
        zIndex: newZ,
        display: "block"
      };
//      if (layerDist <= this.rondell.visibleItems) {
	if (true) {
	if(presentationType == 2) {	
        	newTarget.opacity = 1;
	}
	else {
		newTarget.opacity = this.rondell.funcOpacity(layerDiff, this.rondell, idx);
	}
        this.hidden = false;
        if (this.icon) {
          this.lastIconAnimationTarget = this.iconAnimationTarget;
          if (this.rondell.cropThumbnails) {
            this.iconAnimationTarget = {
              marginTop: (this.rondell.itemProperties.size.height - this.croppedSize.height) / 2,
              marginLeft: (this.rondell.itemProperties.size.width - this.croppedSize.width) / 2,
              width: this.croppedSize.width,
              height: this.croppedSize.height
            };
          }
          if (!this.resizeable) {
            this.iconAnimationTarget = {
              marginTop: (this.rondell.itemProperties.size.height - this.iconHeight) / 2,
              marginLeft: (this.rondell.itemProperties.size.width - this.iconWidth) / 2
            };
          }
        }
      } else if (this.hidden) {
        $.extend(this.objectCSSTarget, newTarget);
      }
      this.lastObjectAnimationTarget = this.objectAnimationTarget;
      return this.objectAnimationTarget = newTarget;
    };

    RondellItem.prototype.onAnimationFinished = function() {
      this.animating = false;


	  /* VIDEO SUPPORT */
	  	  
	  if(this.icon.attr("alt").indexOf("youtube.com") > 0)  {
	  if(this.icon.parent().find(".videocontainergs").length == 0) {
		  var youtubeLink = this.icon.attr("alt");
		  if(youtubeLink.indexOf("iframe") > 0) {

		  	var splitelement1 = youtubeLink.split('src="');
			var splitelement2 = splitelement1[1].split('"');
			youtubeLink = splitelement2[0];
		  }

		  if(youtubeLink.indexOf("watch?v=") > 0) {
  		  	var splitelements = youtubeLink.split("watch?v=");
  			youtubeLink = "https://www.youtube.com/embed/" + splitelements[1];			  
		  }
		  else {		  
		  if(youtubeLink.indexOf("?") > 0) {
		  	var splitelements = youtubeLink.split("?");
			youtubeLink = splitelements[0];
		  }
		  }

		  var autoplaynow = '';
		  if(this.icon.attr("alt").indexOf("autoplay") > 0) {
			  autoplaynow = '&autoplay=1';
		  }		
	
		  if(navinleft == false) {
		  	this.icon.parent().prepend('<iframe style="background: #111111;" class="videocontainergs" width="100%" height="100%" src="' + youtubeLink + '?rel=0&amp;showinfo=0' + autoplaynow + '" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>');
		  }
	  	  else {
			  var gsImgH = this.iconHeight - thumbSizeX;
		  	  var gsImgW = this.iconWidth - thumbSizeX;
		  
	  		  this.icon.parent().prepend('<iframe style="background: #111111;" class="videocontainergs" width="100%" height="100%" src="' + youtubeLink + '?rel=0&amp;showinfo=0' + autoplaynow + '" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>');		  
	  	  }
	  
	  }	
	  }
	  else {
          if(this.icon.attr("alt").indexOf("youtu.be") > 0)  {
          if(this.icon.parent().find(".videocontainergs").length == 0) {
                  var youtubeLink = this.icon.attr("alt");
		  youtubeLink = '<iframe width="560" height="315" src="https://www.youtube.com/embed/' + this.icon.attr("alt").replace("https://youtu.be/", '') + '" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
                  if(youtubeLink.indexOf("iframe") > 0) {

                        var splitelement1 = youtubeLink.split('src="');
                        var splitelement2 = splitelement1[1].split('"');
                        youtubeLink = splitelement2[0];
                  }
                  if(youtubeLink.indexOf("?") > 0) {
                        var splitelements = youtubeLink.split("?");
                        youtubeLink = splitelements[0];
                  }

		  var autoplaynow = '';
		  if(this.icon.attr("alt").indexOf("autoplay") > 0) {
			  autoplaynow = '&autoplay=1';
		  }

                  if(navinleft == false) {
                        this.icon.parent().prepend('<iframe style="background: #111111;" class="videocontainergs" width="100%" height="100%" src="' + youtubeLink + '?rel=0&amp;showinfo=0' + autoplaynow + '" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>');
                  }
                  else {
                          var gsImgH = this.iconHeight - thumbSizeX;
                          var gsImgW = this.iconWidth - thumbSizeX;

                          this.icon.parent().prepend('<iframe style="background: #111111;" class="videocontainergs" width="100%" height="100%"  src="' + youtubeLink + '?rel=0&amp;showinfo=0' + autoplaynow + '" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>');
                  }

          }
          }
	  else {
          if(this.icon.attr("alt").indexOf("youtube-nocookie.com") > 0)  {
          if(this.icon.parent().find(".videocontainergs").length == 0) {
                  var youtubeLink = this.icon.attr("alt");
                  if(youtubeLink.indexOf("iframe") > 0) {

                        var splitelement1 = youtubeLink.split('src="');
                        var splitelement2 = splitelement1[1].split('"');
                        youtubeLink = splitelement2[0];
                  }
                  if(youtubeLink.indexOf("?") > 0) {
                        var splitelements = youtubeLink.split("?");
                        youtubeLink = splitelements[0];
                  }

                  var autoplaynow = '';
                  if(this.icon.attr("alt").indexOf("autoplay") > 0) {
                          autoplaynow = '&autoplay=1';
                  }

                  if(navinleft == false) {
                        this.icon.parent().prepend('<iframe style="background: #111111;" class="videocontainergs" width="100%" height="100%" src="' + youtubeLink + '?rel=0&amp;showinfo=0' + autoplaynow + '" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>');
                  }
                  else {
                          var gsImgH = this.iconHeight - thumbSizeX;
                          var gsImgW = this.iconWidth - thumbSizeX;

                          this.icon.parent().prepend('<iframe style="background: #111111;" class="videocontainergs" width="100%" height="100%"  src="' + youtubeLink + '?rel=0&amp;showinfo=0' + autoplaynow + '" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>');
                  }

          }
          }
	  }

	  }
	  
	  
	  if(this.icon.attr("alt").indexOf("player.vimeo.com") > 0)  {
	  if(this.icon.parent().find(".videocontainergs").length == 0) {
		  var youtubeLink = this.icon.attr("alt");
		  if(youtubeLink.indexOf("iframe") > 0) {

		  	var splitelement1 = youtubeLink.split('src="');
			var splitelement2 = splitelement1[1].split('"');
			youtubeLink = splitelement2[0];
		  }
		  if(youtubeLink.indexOf("?") > 0) {
		  	var splitelements = youtubeLink.split("?");
			youtubeLink = splitelements[0];
		  }

		  var autoplayPar = '';
		  
		  if(this.icon.attr("alt").indexOf("autoplay=1") > 0) {
			  autoplayPar = "&autoplay=1";
		  }

				  if(navinleft == false) {
		  	this.icon.parent().prepend('<iframe class="videocontainergs" src="' + youtubeLink + '?title=0&byline=0&portrait=0' + autoplayPar + '" width="100%" height="100%" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>');
		  }
		  else {
			  var gsImgH = this.iconHeight - thumbSizeX;
			  var gsImgW = this.iconWidth - thumbSizeX;
  		  	this.icon.parent().prepend('<iframe class="videocontainergs" src="' + youtubeLink + '?title=0&byline=0&portrait=0' + autoplayPar + '" width="100%" height="100%" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>');		  
		  }	  
	  }	
	  }
          else {  


          if(this.icon.attr("alt").indexOf("vimeo.com") > 0)  {
          if(this.icon.parent().find(".videocontainergs").length == 0) {
                  var youtubeLink = this.icon.attr("alt");
		youtubeLink = youtubeLink.replace('vimeo.com', 'player.vimeo.com/video');
                  if(youtubeLink.indexOf("iframe") > 0) {

                        var splitelement1 = youtubeLink.split('src="');
                        var splitelement2 = splitelement1[1].split('"');
                        youtubeLink = splitelement2[0];
                  }
                  if(youtubeLink.indexOf("?") > 0) {
                        var splitelements = youtubeLink.split("?");
                        youtubeLink = splitelements[0];
                  }

		  var autoplayPar = '';
		  
		  if(this.icon.attr("alt").indexOf("autoplay=1") > 0) {
			  autoplayPar = "&autoplay=1";
		  }

                                  if(navinleft == false) {
                        this.icon.parent().prepend('<iframe class="videocontainergs" src="' + youtubeLink + '?title=0&byline=0&portrait=0' + autoplayPar + '" width="100%" height="100%"  frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>');
                  }
                  else {
                          var gsImgH = this.iconHeight - thumbSizeX;
                          var gsImgW = this.iconWidth - thumbSizeX;
                        this.icon.parent().prepend('<iframe class="videocontainergs" src="' + youtubeLink + '?title=0&byline=0&portrait=0' + autoplayPar + '" width="100%" height="100%" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>');
                  }
          }
          }
	}

      if (this.focused) {
        this.object.addClass(this.rondell.classes.focused);
        if (this.rondell.hovering || this.rondell.alwaysShowCaption || this.rondell._onMobile()) {
          return this.showCaption();
        }
      } else {
        if (this.objectAnimationTarget.opacity < this.rondell.opacityMin || (this.objectAnimationTarget.opacity <= 0.02)) {
          this.hidden = true;
          return this.object.css("display", "none");
        } else {
          this.hidden = false;
          return this.object.css("display", "block");
        }
      }
    };

    RondellItem.prototype.runAnimation = function(force) {
      if (force == null) {
        force = false;
      }
      this.object.css(this.objectCSSTarget);
      if (!this.hidden) {
        if ((force || this.iconAnimationTarget) && this.icon && (this.focused || !this.rondell.equals(this.iconAnimationTarget, this.lastIconAnimationTarget))) {
          this.icon.stop(true).animate(this.iconAnimationTarget, this.animationSpeed, this.rondell.funcEase);
        }
        if ((force || (this.objectAnimationTarget != null)) && (this.focused || !this.rondell.equals(this.objectAnimationTarget, this.lastObjectAnimationTarget))) {
          this.animating = true;
          this.object.stop(true).animate(this.objectAnimationTarget, this.animationSpeed, this.rondell.funcEase, this.onAnimationFinished);
          if (!this.focused) {
            this.object.removeClass(this.rondell.classes.focused);
            return this.hideCaption();
          }
        } else {
          return this.onAnimationFinished();
        }
      }
    };

    return RondellItem;

  })();
})(jQPac);
/* Modernizr 2.0.6 (Custom Build) | MIT & BSD
 * Build: http://www.modernizr.com/download/#-fontface-backgroundsize-borderradius-boxshadow-rgba-textshadow-cssanimations-cssgradients-csstransitions-touch-iepp-cssclasses-teststyles-testprop-testallprops-prefixes-domprefixes-load
 */
if (typeof window.Modernizr === "undefined") {
(function($) {
;window.Modernizr=function(a,b,c){function C(a,b){var c=a.charAt(0).toUpperCase()+a.substr(1),d=(a+" "+o.join(c+" ")+c).split(" ");return B(d,b)}function B(a,b){for(var d in a)if(k[a[d]]!==c)return b=="pfx"?a[d]:!0;return!1}function A(a,b){return!!~(""+a).indexOf(b)}function z(a,b){return typeof a===b}function y(a,b){return x(n.join(a+";")+(b||""))}function x(a){k.cssText=a}var d="2.0.6",e={},f=!0,g=b.documentElement,h=b.head||b.getElementsByTagName("head")[0],i="modernizr",j=b.createElement(i),k=j.style,l,m=Object.prototype.toString,n=" -webkit- -moz- -o- -ms- -khtml- ".split(" "),o="Webkit Moz O ms Khtml".split(" "),p={},q={},r={},s=[],t=function(a,c,d,e){var f,h,j,k=b.createElement("div");if(parseInt(d,10))while(d--)j=b.createElement("div"),j.id=e?e[d]:i+(d+1),k.appendChild(j);f=["&shy;","<style>",a,"</style>"].join(""),k.id=i,k.innerHTML+=f,g.appendChild(k),h=c(k,a),k.parentNode.removeChild(k);return!!h},u,v={}.hasOwnProperty,w;!z(v,c)&&!z(v.call,c)?w=function(a,b){return v.call(a,b)}:w=function(a,b){return b in a&&z(a.constructor.prototype[b],c)};var D=function(c,d){var f=c.join(""),g=d.length;t(f,function(c,d){var f=b.styleSheets[b.styleSheets.length-1],h=f.cssRules&&f.cssRules[0]?f.cssRules[0].cssText:f.cssText||"",i=c.childNodes,j={};while(g--)j[i[g].id]=i[g];e.touch="ontouchstart"in a||j.touch.offsetTop===9,e.fontface=/src/i.test(h)&&h.indexOf(d.split(" ")[0])===0},g,d)}(['@font-face {font-family:"font";src:url("https://")}',["@media (",n.join("touch-enabled),("),i,")","{#touch{top:9px;position:absolute}}"].join("")],["fontface","touch"]);p.touch=function(){return e.touch},p.rgba=function(){x("background-color:rgba(150,255,150,.5)");return A(k.backgroundColor,"rgba")},p.backgroundsize=function(){return C("backgroundSize")},p.borderradius=function(){return C("borderRadius")},p.boxshadow=function(){return C("boxShadow")},p.textshadow=function(){return b.createElement("div").style.textShadow===""},p.cssanimations=function(){return C("animationName")},p.cssgradients=function(){var a="background-image:",b="gradient(linear,left top,right bottom,from(#9f9),to(white));",c="linear-gradient(left top,#9f9, white);";x((a+n.join(b+a)+n.join(c+a)).slice(0,-a.length));return A(k.backgroundImage,"gradient")},p.csstransitions=function(){return C("transitionProperty")},p.fontface=function(){return e.fontface};for(var E in p)w(p,E)&&(u=E.toLowerCase(),e[u]=p[E](),s.push((e[u]?"":"no-")+u));x(""),j=l=null,a.attachEvent&&function(){var a=b.createElement("div");a.innerHTML="<elem></elem>";return a.childNodes.length!==1}()&&function(a,b){function s(a){var b=-1;while(++b<g)a.createElement(f[b])}a.iepp=a.iepp||{};var d=a.iepp,e=d.html5elements||"abbr|article|aside|audio|canvas|datalist|details|figcaption|figure|footer|header|hgroup|mark|meter|nav|output|progress|section|summary|time|video",f=e.split("|"),g=f.length,h=new RegExp("(^|\\s)("+e+")","gi"),i=new RegExp("<(/*)("+e+")","gi"),j=/^\s*[\{\}]\s*$/,k=new RegExp("(^|[^\\n]*?\\s)("+e+")([^\\n]*)({[\\n\\w\\W]*?})","gi"),l=b.createDocumentFragment(),m=b.documentElement,n=m.firstChild,o=b.createElement("body"),p=b.createElement("style"),q=/print|all/,r;d.getCSS=function(a,b){if(a+""===c)return"";var e=-1,f=a.length,g,h=[];while(++e<f){g=a[e];if(g.disabled)continue;b=g.media||b,q.test(b)&&h.push(d.getCSS(g.imports,b),g.cssText),b="all"}return h.join("")},d.parseCSS=function(a){var b=[],c;while((c=k.exec(a))!=null)b.push(((j.exec(c[1])?"\n":c[1])+c[2]+c[3]).replace(h,"$1.iepp_$2")+c[4]);return b.join("\n")},d.writeHTML=function(){var a=-1;r=r||b.body;while(++a<g){var c=b.getElementsByTagName(f[a]),d=c.length,e=-1;while(++e<d)c[e].className.indexOf("iepp_")<0&&(c[e].className+=" iepp_"+f[a])}l.appendChild(r),m.appendChild(o),o.className=r.className,o.id=r.id,o.innerHTML=r.innerHTML.replace(i,"<$1font")},d._beforePrint=function(){p.styleSheet.cssText=d.parseCSS(d.getCSS(b.styleSheets,"all")),d.writeHTML()},d.restoreHTML=function(){o.innerHTML="",m.removeChild(o),m.appendChild(r)},d._afterPrint=function(){d.restoreHTML(),p.styleSheet.cssText=""},s(b),s(l);d.disablePP||(n.insertBefore(p,n.firstChild),p.media="print",p.className="iepp-printshim",a.attachEvent("onbeforeprint",d._beforePrint),a.attachEvent("onafterprint",d._afterPrint))}(a,b),e._version=d,e._prefixes=n,e._domPrefixes=o,e.testProp=function(a){return B([a])},e.testAllProps=C,e.testStyles=t,g.className=g.className.replace(/\bno-js\b/,"")+(f?" js "+s.join(" "):"");return e}(this,this.document),function(a,b,c){function k(a){return!a||a=="loaded"||a=="complete"}function j(){var a=1,b=-1;while(p.length- ++b)if(p[b].s&&!(a=p[b].r))break;a&&g()}function i(a){var c=b.createElement("script"),d;c.src=a.s,c.onreadystatechange=c.onload=function(){!d&&k(c.readyState)&&(d=1,j(),c.onload=c.onreadystatechange=null)},m(function(){d||(d=1,j())},H.errorTimeout),a.e?c.onload():n.parentNode.insertBefore(c,n)}function h(a){var c=b.createElement("link"),d;c.href=a.s,c.rel="stylesheet",c.type="text/css";if(!a.e&&(w||r)){var e=function(a){m(function(){if(!d)try{a.sheet.cssRules.length?(d=1,j()):e(a)}catch(b){b.code==1e3||b.message=="security"||b.message=="denied"?(d=1,m(function(){j()},0)):e(a)}},0)};e(c)}else c.onload=function(){d||(d=1,m(function(){j()},0))},a.e&&c.onload();m(function(){d||(d=1,j())},H.errorTimeout),!a.e&&n.parentNode.insertBefore(c,n)}function g(){var a=p.shift();q=1,a?a.t?m(function(){a.t=="c"?h(a):i(a)},0):(a(),j()):q=0}function f(a,c,d,e,f,h){function i(){!o&&k(l.readyState)&&(r.r=o=1,!q&&j(),l.onload=l.onreadystatechange=null,m(function(){u.removeChild(l)},0))}var l=b.createElement(a),o=0,r={t:d,s:c,e:h};l.src=l.data=c,!s&&(l.style.display="none"),l.width=l.height="0",a!="object"&&(l.type=d),l.onload=l.onreadystatechange=i,a=="img"?l.onerror=i:a=="script"&&(l.onerror=function(){r.e=r.r=1,g()}),p.splice(e,0,r),u.insertBefore(l,s?null:n),m(function(){o||(u.removeChild(l),r.r=r.e=o=1,j())},H.errorTimeout)}function e(a,b,c){var d=b=="c"?z:y;q=0,b=b||"j",C(a)?f(d,a,b,this.i++,l,c):(p.splice(this.i++,0,a),p.length==1&&g());return this}function d(){var a=H;a.loader={load:e,i:0};return a}var l=b.documentElement,m=a.setTimeout,n=b.getElementsByTagName("script")[0],o={}.toString,p=[],q=0,r="MozAppearance"in l.style,s=r&&!!b.createRange().compareNode,t=r&&!s,u=s?l:n.parentNode,v=a.opera&&o.call(a.opera)=="[object Opera]",w="webkitAppearance"in l.style,x=w&&"async"in b.createElement("script"),y=r?"object":v||x?"img":"script",z=w?"img":y,A=Array.isArray||function(a){return o.call(a)=="[object Array]"},B=function(a){return Object(a)===a},C=function(a){return typeof a=="string"},D=function(a){return o.call(a)=="[object Function]"},E=[],F={},G,H;H=function(a){function f(a){var b=a.split("!"),c=E.length,d=b.pop(),e=b.length,f={url:d,origUrl:d,prefixes:b},g,h;for(h=0;h<e;h++)g=F[b[h]],g&&(f=g(f));for(h=0;h<c;h++)f=E[h](f);return f}function e(a,b,e,g,h){var i=f(a),j=i.autoCallback;if(!i.bypass){b&&(b=D(b)?b:b[a]||b[g]||b[a.split("/").pop().split("?")[0]]);if(i.instead)return i.instead(a,b,e,g,h);e.load(i.url,i.forceCSS||!i.forceJS&&/css$/.test(i.url)?"c":c,i.noexec),(D(b)||D(j))&&e.load(function(){d(),b&&b(i.origUrl,h,g),j&&j(i.origUrl,h,g)})}}function b(a,b){function c(a){if(C(a))e(a,h,b,0,d);else if(B(a))for(i in a)a.hasOwnProperty(i)&&e(a[i],h,b,i,d)}var d=!!a.test,f=d?a.yep:a.nope,g=a.load||a.both,h=a.callback,i;c(f),c(g),a.complete&&b.load(a.complete)}var g,h,i=this.yepnope.loader;if(C(a))e(a,0,i,0);else if(A(a))for(g=0;g<a.length;g++)h=a[g],C(h)?e(h,0,i,0):A(h)?H(h):B(h)&&b(h,i);else B(a)&&b(a,i)},H.addPrefix=function(a,b){F[a]=b},H.addFilter=function(a){E.push(a)},H.errorTimeout=1e4,b.readyState==null&&b.addEventListener&&(b.readyState="loading",b.addEventListener("DOMContentLoaded",G=function(){b.removeEventListener("DOMContentLoaded",G,0),b.readyState="complete"},0)),a.yepnope=d()}(this,this.document),Modernizr.load=function(){yepnope.apply(window,[].slice.call(arguments,0))};
})(jQPac);
}
presentationType = 1;
percentageResize = 100;
forcemaxHeightOfAllMedia = 600;
isLightboxEnabled = true;
mobileOnlyMode = false;
gsFrontColor = "rgba(255, 255, 255)";
gsBackColor = "rgba(0, 0, 0, 0.7)";
gsShopIdPro = 37215;
thumbSizeX = 100;
gallerynav = false; 
fadeTimeGS = 1;   
navinleft = false;   
zoomOnHover = true; 
window.dontcropimages = false;
zoomOnHoverMode = 1;   
zoomOnHoverMobile = false;   
navpos = 3;   
autorotate = false;   
autorotatetime = 3000;   

/*
LICENSE

All rights to this code belong to Gravity Software Ltd. Do not copy, do not redistribute.

*/

try {
(function(o){var t={url:!1,callback:!1,target:!1,duration:120,on:"mouseover",touch:!0,onZoomIn:!1,onZoomOut:!1,magnify:1};o.gravizoom=function(t,n,e,i){var u,c,a,r,m,l,s,f=o(t),h=f.css("position"),d=o(n);return t.style.position=/(absolute|fixed)/.test(h)?h:"relative",t.style.overflow="hidden",e.style.width=e.style.height="",o(e).addClass("gravizoomImg").css({position:"absolute",top:0,left:0,opacity:0,width:e.width*i,height:e.height*i,border:"none",maxWidth:"none",maxHeight:"none"}).appendTo(t),{init:function(){c=f.outerWidth(),u=f.outerHeight(),n===t?(r=c,a=u):(r=d.outerWidth(),a=d.outerHeight()),m=(e.width-c)/r,l=(e.height-u)/a,s=d.offset()},move:function(o){var t=o.pageX-s.left,n=o.pageY-s.top;n=Math.max(Math.min(n,a),0),t=Math.max(Math.min(t,r),0),e.style.left=t*-m+"px",e.style.top=n*-l+"px"}}},o.fn.gravizoom=function(n){return this.each(function(){var e=o.extend({},t,n||{}),i=e.target&&o(e.target)[0]||this,u=this,c=o(u),a=document.createElement("img"),r=o(a),m="mousemove.gravizoom",l=!1,s=!1;if(!e.url){var f=u.querySelector("img");if(f&&(e.url=f.getAttribute("data-src")||f.currentSrc||f.src),!e.url)return}c.one("gravizoom.destroy",function(o,t){c.off(".gravizoom"),i.style.position=o,i.style.overflow=t,a.onload=null,r.remove()}.bind(this,i.style.position,i.style.overflow)),a.onload=function(){function t(t){ if(jQPac(this).parents('.rondell-item-focused').length == 0 && (!jQPac(this).hasClass('rondell-item-focused'))) { return } ; f.init(),f.move(t),r.stop().fadeTo(o.support.opacity?e.duration:0,1,o.isFunction(e.onZoomIn)?e.onZoomIn.call(a):!1)}function n(){r.stop().fadeTo(e.duration,0,o.isFunction(e.onZoomOut)?e.onZoomOut.call(a):!1)}var f=o.gravizoom(i,u,a,e.magnify);"grab"===e.on?c.on("mousedown.gravizoom",function(e){1===e.which&&(o(document).one("mouseup.gravizoom",function(){n(),o(document).off(m,f.move)}),t(e),o(document).on(m,f.move),e.preventDefault())}):"click"===e.on?c.on("click.gravizoom",function(e){return l?void 0:(l=!0,t(e),o(document).on(m,f.move),o(document).one("click.gravizoom",function(){n(),l=!1,o(document).off(m,f.move)}),!1)}):"toggle"===e.on?c.on("click.gravizoom",function(o){l?n():t(o),l=!l}):"mouseover"===e.on&&(f.init(),c.on("mouseenter.gravizoom",t).on("mouseleave.gravizoom",n).on(m,f.move)),e.touch&&c.on("touchstart.gravizoom",function(o){o.preventDefault(),s?(s=!1,n()):(s=!0,t(o.originalEvent.touches[0]||o.originalEvent.changedTouches[0]))}).on("touchmove.gravizoom",function(o){o.preventDefault(),f.move(o.originalEvent.touches[0]||o.originalEvent.changedTouches[0])}).on("touchend.gravizoom",function(o){o.preventDefault(),s&&(s=!1,n())}),o.isFunction(e.callback)&&e.callback.call(a)},a.setAttribute("role","presentation"),a.alt="",a.src=e.url})},o.fn.gravizoom.defaults=t})(jQPac);
}
catch(err) {}

lgGallery = null;
oncego = false;
backgroundColor = '';
maxHeightOfAllMedia = 0;
lastImgSrc = '';
fullallImagesAddedToSlider = [];
variantImagesAddedToSlider = [];
allImagesAddedToSlider = [];
allImagesAddedToSliderOrg = [];
buttonsGS = '';
fullScreenWidth = 0;
fullScreenHeight = '';
initialWidth = 0;
initialHeight = 0;
lastWidth = 0;
photoThumbTheme = 0;
specialTheme = 0;
imgWidth = '';
imageDimensionsHeight2 = {};
imageDimensionsWidth2 = {};
foundIndex = 0;
ignoreImgArr = false;
navinleftspace = 6;
forceThumbnailFull = false;


jQPac.fn.reverse = [].reverse;

var loadScript = function(url, callback){

    var script = document.createElement("script")
    script.type = "text/javascript";

    if (script.readyState){  //IE
        script.onreadystatechange = function(){
            if (script.readyState == "loaded" ||
                    script.readyState == "complete"){
                script.onreadystatechange = null;
                callback();
            }
        };
    } else {  //Others
        script.onload = function(){
            callback();
        };
    }

    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);

};

var loadCSS = function(url, callback){

    var script = document.createElement("link")
    script.type = "text/css";
    script.rel = "stylesheet";

    if (script.readyState){  //IE
        script.onreadystatechange = function(){
            if (script.readyState == "loaded" ||
                    script.readyState == "complete"){
                script.onreadystatechange = null;
                callback();
            }
        };
    } else {  //Others
        script.onload = function(){
            callback();
        };
    }

    script.href = url;
    document.getElementsByTagName("head")[0].appendChild(script);

};

function replaceLast(x, y, z){
  var a = x.split("");
  a[x.lastIndexOf(y)] = z;
  return a.join("");
}

var getLargeImgUrl  = function(jQPac, url, width, height) {
var isZoom = false;
if(height > 0) {
isZoom = true;
}
else {
if(forcemaxHeightOfAllMedia > 0 && forcemaxHeightOfAllMedia < 2000) {
height = forcemaxHeightOfAllMedia;
}
}

if(height != 123123) {
if((height > (fullScreenHeight - parseInt(fullScreenHeight * 0.13)))) {
height = fullScreenHeight - parseInt(fullScreenHeight * 0.13);
}
}

        url = getLargeImgUrl2(jQPac, url, width, height, isZoom);
        if(url.indexOf("/cdn/") == -1 && url.indexOf("shopify.com") == -1) {
        return url;
        }
        var dotPos = url.lastIndexOf(".");

        var ext1 = url.substr(dotPos);
        var ext2 = url.substr(0, dotPos);

        var progressiveUrl = '';
        pixelRatio = window.devicePixelRatio || 1;

if(pixelRatio > 1 && pixelRatio < 2) {
pixelRatio = 2;
}

if(pixelRatio > 2 && pixelRatio < 3) {
pixelRatio = 3;
}

if(pixelRatio > 3) {
pixelRatio = 3;
} 

        if(pixelRatio != 2 && pixelRatio != 3) {
                pixelRatio = 1;
        }

if(window.location.href.indexOf("dee-trade") >= 0) {
if(pixelRatio == 1) {
pixelRatio = 2;
}
}

        if((!isZoom) && (pixelRatio > 1)) {
                progressiveUrl = ext2 + '@' + pixelRatio + 'x.progressive' + ext1;
                //var progressiveUrl = ext2 + '.progressive' + ext1;
        }
        else {
		if(window.location.href.indexOf("dee-trade") >= 0) {
		progressiveUrl = ext2 + '@' + pixelRatio + 'x.progressive' + ext1;
		}
		else {
		    if(pixelRatio > 1 ) {
                progressiveUrl = ext2 + '@' + pixelRatio + 'x.progressive' + ext1;
            }
            else {
                progressiveUrl = ext2 + '.progressive' + ext1;
            }

		//progressiveUrl = ext2 + '.progressive' + ext1;
		}
                //progressiveUrl = ext2 + '.progressive' + ext1;
		//progressiveUrl = ext2 + '@' + pixelRatio + 'x.progressive' + ext1;
        }

        if(presentationType == 2) {
        var dddd = new Date();
        var nnnn = dddd.getTime();

                if(progressiveUrl.indexOf("?") == -1) {
                        progressiveUrl = progressiveUrl + "?dategs=" + nnnn;
                }
                else {
                        progressiveUrl = progressiveUrl + "&dategs=" + nnnn;
                }
        }

        return progressiveUrl;
}


var getLargeImgUrl2  = function(jQPac, url, width, height, currentIsZoom) {

	if(!currentIsZoom) {
    if(width == fullScreenWidth) {
        var positionOfVersion = url.lastIndexOf("?v");
        if(positionOfVersion > 0) {
            url = url.substr(0, positionOfVersion);
        }
    }
	}
if(url.indexOf("/cdn/") == -1 && url.indexOf("shopify.com") == -1) {
	return url;
}
/*
if(photoThumbTheme > 0) {
if(url.indexOf("compact.") != -1) {
	url = url.replace("compact", "large");
	return url;
}

if(url.indexOf("grande.") != -1) {
        url = url.replace("grande", "large");
        return url;
}

if(url.indexOf("small.") != -1) {
        url = url.replace("small", "large");
        return url;
}

if(url.indexOf("medium.") != -1) {
        url = url.replace("medium", "large");
        return url;
}

if(url.indexOf("thumb.") != -1) {
        url = url.replace("thumb", "large");
        return url;
}

if(url.indexOf("original.") != -1) {
        url = url.replace("original", "large");
        return url;
}

if(url.indexOf("master.") != -1) {
        url = url.replace("master", "large");
        return url;
}

if(url.indexOf("icon.") != -1) {
        url = url.replace("icon", "large");
        return url;
}

if(url.indexOf("large.") != -1) {
        return url;
}

if(url.indexOf("large.") != -1) {
        return url;
}

}
*/


    var dotPos = url.lastIndexOf(".");
    var underscorePos = url.lastIndexOf("_") + 1;
    var ext = url.substr(dotPos);
    if(ext.length <= 2) {
        return '';
    }

    if(underscorePos == 0) {
        url = replaceLast(url, ".", "_1024x1024.");
        var dotPos = url.lastIndexOf(".");
        var underscorePos = url.lastIndexOf("_") + 1;
        var ext = url.substr(dotPos);
        if(ext.length <= 2) {
                return '';
        }
    }
    else {
    var dimensionsStr = url.substr(underscorePos);
    // validate the right hand-side substring
    var patternForDims = /[0-9]x|x[0-9]|[^A-z]x[^A-z]|pico|icon|thumb|small|compact|medium|large|grande|original|master/g;
    var testResult = patternForDims.test("_" + dimensionsStr);
    if(!testResult) {
        url = replaceLast(url, ".", "_1024x1024.");
        var dotPos = url.lastIndexOf(".");
        var underscorePos = url.lastIndexOf("_") + 1;
        var ext = url.substr(dotPos);
        if(ext.length <= 2) {
                return '';
        }
    }
    }


    if(width != '') {
        if(currentIsZoom) {
            width = parseInt(width);
            width = width + 1;
            //var maxHeightLight = height - 100;
            maxHeightLight = height;
			 //AKTODO: CHANGED THE ZOOMING PARAMS
			 var threetimeszoom = width * 3;
			 if(threetimeszoom > 4000) {
			 	threetimeszoom = 4000;
			 }
			threetimeszoom = 4000;
			if(height == 123123) {
				threetimeszoom = 123123;
			}
	     var largeImgUrl = url.substr(0, underscorePos) + threetimeszoom + 'x' + url.substr(dotPos);
            return largeImgUrl;
        }
        else {
            width = parseInt(width);
            width = width + 1;
            var largeImgUrl = url.substr(0, underscorePos) + width + 'x' + url.substr(dotPos);
            return largeImgUrl;
        }
    }
    else {
        var largeImgUrl = url.substr(0, underscorePos) + '512x' + url.substr(dotPos);
        return largeImgUrl;
    }
}

var setupResizableSections = function(topMediaElementLeft) {

    if(percentageResize != '' && percentageResize != 0) {
        jQPac("html").hide();
        topMediaElementRight = false;
        leftElementWidth = 0;
        rightElementWidth = 0;
        if(topMediaElementLeft.parent().children().length >= 2) {
            jQPac.each( topMediaElementLeft.parent().children(), function( index, topMediaElementEach ) {
                nextElementTopMedia = this;
                if(jQPac(this).find('button, input[type="submit"], input[type="button"]').length > 0) {
		   topMediaElementRight = jQPac(nextElementTopMedia);
	  	   /*
                    var hash = getHash(this);
                    if(hash.indexOf("Add") >= 0 || hash.indexOf("add") >= 0 || hash.indexOf("Buy") >= 0 || hash.indexOf("buy") >= 0 || hash.indexOf("Purchase") >= 0 || hash.indexOf("Sold") >= 0 || hash.indexOf("sold") >= 0) {
                        topMediaElementRight = jQPac(nextElementTopMedia);
                    }
		   */
                }
            });
        }

	if(specialTheme == 4 && fullScreenWidth > 850) {
		topMediaElementRight = jQPac("#product-right");
        }

        leftElementWidth = topMediaElementLeft.width();
        if(topMediaElementRight != false) {
            rightElementWidth = topMediaElementRight.width();
            var totalWidth = rightElementWidth + leftElementWidth;

		if((totalWidth >= 98 && totalWidth <= 100) || specialTheme == 4) {
                var resizeValInPx = parseInt(leftElementWidth * ((percentageResize / 2) / 100));
                var newLeftWidth = resizeValInPx + leftElementWidth;
                var newRightWidth = rightElementWidth - resizeValInPx;
                //alert(newLeftWidth + " vs " + newRightWidth)
                if(percentageResize == 100) {
                    topMediaElementLeft.css({'width': '100%'});
                    topMediaElementRight.css({'width': '100%'});
                    topMediaElementRight.css({'margin-top': '20px'});
                }
                else {
                    topMediaElementLeft.css({'width': newLeftWidth + '%'});
                    topMediaElementRight.css({'width': newRightWidth + '%'});
                }
            }
        }
        jQPac("html").show();
    }
}

var setupslider = function(jQPac, modeSlider) {
            //jQPac(this).attr("src", "https://media.licdn.com/mpr/mpr/shrink_100_100/AAEAAQAAAAAAAARCAAAAJDcxNWJlODNlLTg3YzItNDlmYi04MmZhLWJhMDlmZTc5NmFjOQ.jpg");
            //jQPac(this).attr("srcset", "https://media.licdn.com/mpr/mpr/shrink_100_100/AAEAAQAAAAAAAARCAAAAJDcxNWJlODNlLTg3YzItNDlmYi04MmZhLWJhMDlmZTc5NmFjOQ.jpg");

    var firstImageWidth = '';

    var counter = 0;
    var i = 1;
    var addMainFromThumb = false;
    var maxImageWidth = 0;
    var maxImageElement = null;
    var firstImageElement = null;
    allImagesAddedToSlider = [];
    topMediaParent = '';
    imgWidth = '';
/*
if(jQPac(window).width() < forcemaxHeightOfAllMedia || jQPac(window).height() < forcemaxHeightOfAllMedia) {
    if((Modernizr.touch && (jQPac(window).width() < 800)) ||  /Android|webOS|iPhone|iPiad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {

if(presentationType != 1) {
thumbSizeX = 0;
}

        fullScreenWidth = jQPac(window).width();
        fullScreenHeight = jQPac(window).height();
        if(fullScreenWidth < fullScreenHeight) {
            forcemaxHeightOfAllMedia = fullScreenWidth - thumbSizeX;
        }
        else {
            forcemaxHeightOfAllMedia = fullScreenHeight - thumbSizeX;
        }
    }
}
*/

if(presentationType != 1) {
thumbSizeX = 0;
}

fullScreenWidth = jQPac(window).width();
fullScreenHeight = jQPac(window).height();

if(forcemaxHeightOfAllMedia > (fullScreenHeight - thumbSizeX)) {
if(navinleft) {
forcemaxHeightOfAllMedia = fullScreenHeight;
}
else {
    forcemaxHeightOfAllMedia = fullScreenHeight - thumbSizeX;
}
}

if((Modernizr.touch && (jQPac(window).width() < 800)) ||  /Android|webOS|iPhone|iPiad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    percentageResize = 100;
}
else {
    forcemaxHeightOfAllMedia = forcemaxHeightOfAllMedia - 100;
}

//jQPac("body").append("<style> .scroll-to-fixed-fixed { position: static !important; } .site-nav__dropdown { z-index: 999; } #slidingbar-wrap { z-index: 99999; } #shopify-section-header .header-container { z-index: 499 !important;} #navbar { z-index: 9999; } .show-nav-mobile .rondell-item { z-index: 1 !important;} .show-nav-mobile .rondell-control { z-index: 1 !important; } #satcb_bar { z-index: 9999 !important; }  </style>");
jQPac("body").append("<style> .gallery-wrap { opacity: 0 !important; } .product_section .product_form { opacity: 1 !important; } .loading-wrapper { display: none !important; } .lg-actions .lg-prev { left: 0px !important; } .lg-actions .lg-next { right: 0px !important; } .scroll-to-fixed-fixed { position: static !important; height: 10px; }  .videocontainergs { display: none; } .rondell-item-focused .videocontainergs { display: block; } .js-zoom-enabled { display: none !important; } .thumbnails-wrapper { display: none !important; } #rondellCarousel { position: relative !important; z-index: 0; } .photolock-tooltip { display: none !important; } </style>");
if(jQPac(".product-form__item").size() > 0) {
//jQPac("body").append("<style>.product-form__item { display: block !important;} </style>");
}

if((jQPac("#ProductPhoto").length > 0) && (jQPac("#ProductThumbs").length > 0))
{
specialTheme = 1;
}

if((jQPac(".product__photo--single").length > 0))
{
jQPac("body").append("<style>.product__photo--single { display: none;}</style>");
if(forcemaxHeightOfAllMedia == 99999) {
// ADAMTESTREMOVE forcemaxHeightOfAllMedia = 300;
}
specialTheme = 2;
//jQPac("body").append("<style>.drawer { z-index: 999 !important;} .drawer-page-content::after { z-index: 700; } </style>");
}

if((jQPac(".product__subimage-list").length > 0) || ((jQPac(".product__image-wrapper").length > 0) && (jQPac(".product__image-container").length > 0)) )
{
if(forcemaxHeightOfAllMedia == 99999) {
if(fullScreenWidth < 750 || percentageResize == 100) {
// ADAMTESTREMOVE forcemaxHeightOfAllMedia = 300;
}
}
jQPac(".product__subimage-list").hide();
specialTheme = 3;


if(percentageResize != 100 && (fullScreenWidth >= 750)) {
	if(jQPac(".page-width--no-gutter").length > 0 && jQPac(".product__content").length > 0) {
	        var leftElementWidth = 50;
	        var rightElementWidth = 50;
                var resizeValInPx = parseInt(leftElementWidth * (percentageResize / 100));
                var newLeftWidth = resizeValInPx + leftElementWidth;
                var newRightWidth = rightElementWidth - resizeValInPx;

	 jQPac(".product__form-container").append(jQPac(".product__description"));
	 jQPac(".product__form-container").prepend(jQPac(".product__content-header"));
	 jQPac(".social-sharing--product").css("margin-bottom", "0px");
	 jQPac(".product__content-header").css("padding-top", "30px");
	 jQPac(".product__content-header").css("padding-bottom", "10px");
	 jQPac(".page-width--no-gutter").css("width", newLeftWidth + "%");
         jQPac(".product__content").css("width", newRightWidth + "%");
	 jQPac(".product__content").css("float", "left");
	 jQPac(".page-width--no-gutter").css("float", "left");
	 jQPac(".product__content").after('<div style="clear: both;"></div>');
	 jQPac(".product__form-container").css("width", "calc(100% - 30px)");
	 jQPac(".product__description").css("width", "calc(100% - 30px)");
	 jQPac(".product__form-wrapper--fixed").css("position", "inherit");
	 //jQPac(".site-header").css("z-index", "9999");
	jQPac("body").append("<style>.product__form-wrapper--fixed { transform: none !important;  position: inherit !important; } .product__form-wrapper--bottom {position: relative; }</style>");
	}
}


}

if((jQPac("#mob-product-images").length > 0))
{
specialTheme = 4;
jQPac("#mob-product-images").remove();
jQPac("#product-photos").css("display", "block");
//jQPac("#nav").css('z-index', 500);
//jQPac(".dropdown").css('z-index', 500);
}


if((jQPac(".majorinfo").length > 0)) {
if(fullScreenWidth >= 750 && (percentageResize != 0)) {
specialTheme = 6;

var galleryWidth = jQPac(jQPac(".product-gallery").get(0)).width();
var infoWidth = jQPac(jQPac(".product-info").get(0)).width();
var resizeValInPx = parseInt(galleryWidth * (percentageResize / 100));
var newLeftWidth = galleryWidth - resizeValInPx;
var newRightWidth = infoWidth + resizeValInPx;

if(percentageResize == 100) {
newLeftWidth = newRightWidth;
}

console.debug(infoWidth);
jQPac(".product-info").css("width", newRightWidth + "px");
jQPac(".product-gallery").css("width", newLeftWidth + "px");
console.debug(newRightWidth);

}
}

var useImgList = false;
var iPhoneUpd = false;

if((typeof productImagesGS != "undefined")  && (productImagesGS.length > 0))
{
useImgList = true;
}

jQPac( ".product-edit-outer img" ).each(function() {
jQPac(this).addClass("ignore-gs");

});

var forceReloadLater = false;

var gsImgSelector = jQPac( "img" );

	try {
	if(jQPac(jQPac("*[role='main']").get(0)).find( "img" ).length > 0) {
		gsImgSelector = jQPac(jQPac("*[role='main']").get(0)).find( "img" );
	}
	} catch(err) {}

    gsImgSelector.each(function() {

		if(jQPac(this).parents(".rte").length > 0) {
			return true;
		}		

if(jQPac(this).parents(".related-carousel").length > 0) {
return true;
}

try {
if((jQPac(this).parents("header").length > 0) && (jQPac(this).parents('*[class*="cart"]').length > 0)) {
return true;
}
} catch(err) {}

if(jQPac(this).hasClass("ignore-gs")) {
return;
}


try {

if(specialTheme == 1) {
if(!(jQPac.contains(jQPac("#ProductPhoto").get(0), this) || jQPac.contains(jQPac("#ProductThumbs").get(0), this))) {
return;
}
}


if(specialTheme == 3) {
if(!(jQPac.contains(jQPac(".product__image-container").get(0), this) || jQPac.contains(jQPac(".product__subimage-list").get(0), this))) {
return;
}
}

if(typeof jQPac( this ).attr('src') != "undefined" && jQPac( this ).attr('src').indexOf("pinterest.com") > -1)
{
return;
}

if(jQPac( this ).parents(".station-tabs-content").length > 0) {
	return;
}

        var canAdd = true;


        if(canAdd) {
            counter++;
            if(jQPac(this).attr("id") === undefined) {
                jQPac(this).attr("id", "gsslider" + i);
                i++;
            }
            var elementId = jQPac(this).attr("id");

            imgSrc = jQPac( this ).attr('src');

            if(imgSrc === undefined || imgSrc == "") {
                imgSrc = jQPac( this ).attr('srcset');
                if(imgSrc === undefined || imgSrc == "") {
                    imgSrc = jQPac( this ).attr('data-srcset');
                }
                if(imgSrc === undefined || imgSrc == "") {
                    imgSrc = jQPac( this ).attr('data-src');
                }

            }
            if(imgSrc === undefined || imgSrc == "") {
                jQPac.each(this.attributes, function() {
                  if(this.specified) {
                      if(imgSrc === undefined || imgSrc == "") {
                          //if(this.value.indexOf("cdn.") >= 0) {
			 if((this.value.indexOf("/cdn/") >= 0) || (this.value.indexOf("cdn.") >= 0) || (this.value.indexOf("cdn.") >= 0) || (this.value.indexOf("cdn2.") >= 0) || (this.value.indexOf("cdn3.") >= 0) || (this.value.indexOf("cdn4.") >= 0)) {
                            imgSrc = this.value;
                        }
                      }
                  }
                });
            }

                if(imgSrc === undefined || imgSrc == "" || getLargeImgUrl(jQPac, imgSrc, '', '') == "") {
                    return true;
                }

                if(imgSrc.indexOf(" ") != -1) {
                    var exploded = imgSrc.split(" ");
					jQPac.each(exploded, function( index ) {
						if(this.length > 1) {
							imgSrc = this;
							return false;
						}
					});					
                }


            /*
            if(!addMainFromThumb) {
                jQPac(this).click(function(e) {
                    var imgSrc = jQPac( this ).attr('src');
                    if(imgSrc === undefined) {
                        imgSrc = jQPac( this ).attr('srcset');
                        if(imgSrc.indexOf(" ") != -1) {
                            var exploded = imgSrc.split(" ");
                            imgSrc = exploded[0];
                        }
                    }
                    var elementId = jQPac(this).attr("id");

                    if(jQPac("#trig_"+ elementId).attr("href") != getLargeImgUrl(jQPac, imgSrc, '')) {
                        // this needs to be changed
                        if(!addMainFromThumb) {
                            jQPac("#trig_"+ elementId).attr("href", getLargeImgUrl(jQPac, imgSrc, ''));
                        }
                    }
                    jQPac('a[href$="' + getLargeImgUrl(jQPac, imgSrc, '') + '"]').trigger('click');
                    e.stopPropagation();
                    return false;
                });
                jQPac(this).addClass("gs-zoom-in");
            }
            */

            if(imgSrc.length < 5) {
                return;
            }

	    if(useImgList) {
		imgInList = false;
	       jQPac.each(productImagesGS, function( index, imageS ) {
		  if(imgSrc.indexOf(imageS) > -1) {
		     imgInList = true;
		  }
	       });
	       if(!imgInList) {
		if(!ignoreImgArr) {
	         return;
		}
   	       }
	    }

        if(firstImageWidth == '') {
            topMediaParent = findMediaTopParent(this);
			
			try {
				if(topMediaParent && (jQPac('.product-images-container .grid__item .product-single__photos .product-single__photo-wrapper').length > 0) && jQPac(topMediaParent).hasClass('product-images-container') && jQPac(topMediaParent).parent().hasClass('product-sticky-wrapper')) {
					topMediaParent = jQPac(jQPac('.product-images-container .grid__item').get(0));
				}
			} catch(err) {}


try {

                if((jQPac(".page-width .product-detail__images").length > 0)) {
                        topMediaParent = jQPac(jQPac(".page-width .product-detail__images").get(0)).parent();
                } 

} catch(err) {}


try {
        if(topMediaParent.hasClass("methods-of-payment") && jQPac(".product-single .grid__item").length > 0) {
                topMediaParent = jQPac(jQPac(".product-single .grid__item").get(0));
        }
} catch(err) {} 

try {
        if(topMediaParent.hasClass("popup-header") && jQPac(".column_6").length > 0) {
                topMediaParent = jQPac(jQPac(".column_6").get(0));
        }
} catch(err) {}

try {

                if((jQPac(".positions .photos .photo").length > 0) && (jQPac(".thumbs .thumb").length > 0)) {           
                        topMediaParent = jQPac(jQPac(".photos").get(0));
                } 

} catch(err) {}

                try {
                if((jQPac(jQPac(".page-width .product__photos--beside")).length > 0)) {
                        topMediaParent = jQPac(jQPac(".page-width .product__photos--beside").get(0));
                        firstImageWidth = 100;
                }
                } catch(err) {}


	    try {
			if(jQPac("#pageContent .product-col-image").length > 0) {
				topMediaParent = jQPac(jQPac("#pageContent .product-col-image").get(0));	
			}
		} catch(err) {}


try {
			if(topMediaParent.attr("class").indexOf("cart") != -1) 
			{
				return;
			}
} catch(err) {}

                try {
                if((jQPac(jQPac(".container .nine.columns")).length > 0)) {
                        topMediaParent = jQPac(jQPac(".container .nine.columns").get(0));
                }
                } catch(err) {}



                try {
                if((topMediaParent == false) && (jQPac(jQPac(".photos .photos__item--main")).length > 0)) {
                        topMediaParent = jQPac(jQPac(".photos").get(0));
                }
                } catch(err) {}

				try {
				if(jQPac(".product-page--images-container .modal--root").length > 0) {

					jQPac(jQPac(".product-page--images-container")).each(function(index) {
						if(jQPac(this).parents(".product-page--description").length == 0) {
								topMediaParent = jQPac(this);
						}					
					});

					jQPac(".product-page--thumbs-container").hide();
					
				}
				} catch(err) {}

	    try {
		if((jQPac("#product-photos").length == 1) && (jQPac("#mobile-product-photos").length == 1)) {
			if(jQPac("#mobile-product-photos").css("display").indexOf("none") != -1) {
				topMediaParent = jQPac("#product-photos");
			}
			else {
				topMediaParent = jQPac("#mobile-product-photos");
			}

		}

		//if((jQPac(".product-single__photos").length > 0)) {
	//	topMediaParent = jQPac(jQPac(".product-single__photos").get(0));
	//	}

	    } catch(err) {}

try {
if(topMediaParent != false) {
if(topMediaParent.hasClass("product-single__description")) {
              if((jQPac(".product-single__photos").length > 0)) {
              topMediaParent = jQPac(jQPac(".product-single__photos").get(0));
              }
}
}

} catch(err) {}


		if(topMediaParent == false) { 
			if(jQPac(".product-single__photos").length > 0) {
				topMediaParent = jQPac(jQPac(".product-single__photos").get(0));
			}
		}

if(topMediaParent == false) {
if(jQPac('.product__photos').length > 0) {
 topMediaParent = jQPac(jQPac('.product__photos').get(0));
}
}


            if(jQPac(".hidden-xs").length > 0) {
                //jQPac("body").append("<style> .hidden-xs { display: block !important; } </style>");
            }

            if((jQPac("#mobile-product").length > 0) && (jQPac("#product-photos").length > 0)) {
                jQPac("body").append("<style> #product-photos { display: block !important; } #mobile-product {display: none !important; }</style>");
                topMediaParent = jQPac("#product-photos");
            }
	    else {
		if(!((Modernizr.touch && (jQPac(window).width() < 800)) ||  /Android|webOS|iPhone|iPiad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))) {
		if((jQPac("#mobile-product").length > 0) && (jQPac(".product-photos").length > 0)) {
                jQPac("body").append("<style> .product-photos { display: block !important; } #mobile-product {display: none !important; }</style>");
                topMediaParent = jQPac(jQPac(".product-photos").get(0));		
		}
		}
	
	    }

if((topMediaParent == false) || (topMediaParent.width() < 101) ) {
forceReloadLater = true;
return;
}
else {
	forceReloadLater = false;
}

            if(topMediaParent == false) {
                return;
            }
//topMediaParent.css("z-index", "1");
topMediaParent.find(".lazyload").removeClass("lazyload");
if(percentageResize == 100 && fullScreenWidth > 750) {
        topMediaParent.css("min-height", "100px");
}

            if(specialTheme == 1) {
                topMediaParent.css("vertical-align", "top");
                topMediaParent.css("padding-top", "2px");
            }

            if(specialTheme == 2) {
                topMediaParent.css("width", "100%");
            }

            if(specialTheme == 3) {
		if(!topMediaParent.hasClass("page-width--no-gutter")) {
                topMediaParent.css("margin-top", "30px");
		}
		else {
		jQPac("body").append("<style> .page-width--no-gutter { margin-bottom: 20px !important; }</style>");	
		}
		topMediaParent.css("margin-bottom", "20px");	
				try { 
				if(!((Modernizr.touch && (jQPac(window).width() < 800)) ||  /Android|webOS|iPhone|iPiad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))) {
				if(jQPac(jQPac(".product__description").get(0)).height() > 440) {
					var marginbottomcalc = jQPac(jQPac(".product__description").get(0)).height() - 440;
					topMediaParent.css("margin-bottom",""  + marginbottomcalc + "px");
				}				
				}
				} catch(err) {}		 
		
           }

            setupResizableSections(topMediaParent);
            firstImageWidth = 1;
            maxImageWidth = firstImageWidth;
            maxImageElement = jQPac(this);
            canAdd = true;
        }
        if(this.width >= firstImageWidth) {
            canAdd = true;
            addMainFromThumb = false;
            maxImageWidth = this.width;
            maxImageElement = jQPac(this);
        }

        if(!canAdd && counter == 1) {
            addMainFromThumb = true;
        }


            if(topMediaParent == '') {
                return false;
            }

            //var imgWidth = '';
            if(imgWidth == '') {
	    if(modeSlider == 1) {
                imgWidth = (topMediaParent.width()/3.5) * 2;
            }
            else if(modeSlider == 2) {
                imgWidth = topMediaParent.width();
				if(navinleft) {
					imgWidth = imgWidth - thumbSizeX - 6;
				}			
            }
	    }
            if(imgWidth <= 99 || imgWidth == "") {
                imgWidth = 1024;
            }


	if((navigator.userAgent.match(/iPhone/i)) || (navigator.userAgent.match(/iPod/i))) {

          if(!iPhoneUpd) {
                iPhoneUpd = true;
                //imgWidth = imgWidth * 2;
          }

        }

	if(specialTheme == 1) {

	if(jQPac.contains(jQPac("#ProductPhoto").get(0), this) || jQPac.contains(jQPac("#ProductThumbs").get(0), this)) {
            if(allImagesAddedToSlider.indexOf(getLargeImgUrl(jQPac, imgSrc, imgWidth, '')) == -1 ) {
                //jQPac(this).hide();
                lastImgSrc = imgSrc;
                allImagesAddedToSlider.push(getLargeImgUrl(jQPac, imgSrc, imgWidth, ''));
                fullallImagesAddedToSlider.push(getLargeImgUrl(jQPac, imgSrc, fullScreenWidth, fullScreenHeight));
				allImagesAddedToSliderOrg.push(getLargeImgUrl(jQPac, imgSrc, 123123, 123123));
                //jQPac("body").prepend( jQPac('<img style="display: none;" id="gs-image-' + allImagesAddedToSlider.length + '" src="' + getLargeImgUrl(jQPac, imgSrc, imgWidth, '') + '" >') );
            }

			if(jQPac(".product-form__item").length > 0) {
	            jQPac(this).attr("src", "");
	            jQPac(this).hide();
				
			}
			else {
	            jQPac(this).attr("src", "");
	            jQPac(this).remove();				
			}


        }
        }
	else if(specialTheme == 3) {
topMediaParent.css("padding-left", "20px");
	if((jQPac.contains(jQPac(".product__image-container").get(0), this) || jQPac.contains(jQPac(".product__subimage-list").get(0), this))) {
            if(allImagesAddedToSlider.indexOf(getLargeImgUrl(jQPac, imgSrc, imgWidth, '')) == -1 ) {
                //jQPac(this).hide();
                lastImgSrc = imgSrc;
                allImagesAddedToSlider.push(getLargeImgUrl(jQPac, imgSrc, imgWidth, ''));
				allImagesAddedToSliderOrg.push(getLargeImgUrl(jQPac, imgSrc, 123123, 123123));
                fullallImagesAddedToSlider.push(getLargeImgUrl(jQPac, imgSrc, fullScreenWidth, fullScreenHeight));
                //jQPac("body").prepend( jQPac('<img style="display: none;" id="gs-image-' + allImagesAddedToSlider.length + '" src="' + getLargeImgUrl(jQPac, imgSrc, imgWidth, '') + '" >') );
            }
            jQPac(this).attr("src", "");
            jQPac(this).remove();

	}
	}
	else {
	    if(jQPac.contains(topMediaParent.get(0), this) || (!ignoreImgArr)) {
            if(allImagesAddedToSlider.indexOf(getLargeImgUrl(jQPac, imgSrc, imgWidth, '')) == -1 ) {
                //jQPac(this).hide();
                lastImgSrc = imgSrc;
                allImagesAddedToSlider.push(getLargeImgUrl(jQPac, imgSrc, imgWidth, ''));
				allImagesAddedToSliderOrg.push(getLargeImgUrl(jQPac, imgSrc, 123123, 123123));
                fullallImagesAddedToSlider.push(getLargeImgUrl(jQPac, imgSrc, fullScreenWidth, fullScreenHeight));
                //jQPac("body").prepend( jQPac('<img style="display: none;" id="gs-image-' + allImagesAddedToSlider.length + '" src="' + getLargeImgUrl(jQPac, imgSrc, imgWidth, '') + '" >') );
            }

            if(jQPac(".product-form__item").size() > 0) {
                jQPac(this).attr("src", "");
                jQPac(this).hide();
            }
            else {
              jQPac(this).attr("src", "");
              jQPac(this).hide();
	      jQPac(this).attr('disabled','disabled');
	      //jQPac(this).remove();
            }

	    }
       }


        }
        if(topMediaParent != '') {
            topMediaParent.children().not('.product-form__item').hide();
        }

}
catch(err) {
}

    });

if(forceReloadLater) {
forcemaxHeightOfAllMedia = 99999;
lgGallery = null;
oncego = false;
backgroundColor = '';
maxHeightOfAllMedia = 0;
lastImgSrc = '';
fullallImagesAddedToSlider = [];
variantImagesAddedToSlider = [];
allImagesAddedToSlider = [];
allImagesAddedToSliderOrg = [];
buttonsGS = '';
fullScreenWidth = 0;
fullScreenHeight = '';
initialWidth = 0;
initialHeight = 0;
lastWidth = 0;
photoThumbTheme = 0;
specialTheme = 0;
imgWidth = '';
imageDimensionsHeight2 = {};
imageDimensionsWidth2 = {};
foundIndex = 0;
ignoreImgArr = false;
navinleftspace = 6;
forceThumbnailFull = false;

setTimeout(function() {
maina();
}, 500);
return false;
}

if(firstImageWidth == '') {
ignoreImgArr = true;
return setupslider(jQPac, modeSlider);
}


            if(imgWidth == '') {
            if(modeSlider == 1) {
                imgWidth = (topMediaParent.width()/3.5) * 2;
            }
            else if(modeSlider == 2) {
                imgWidth = topMediaParent.width();
				if(navinleft) {
					imgWidth = imgWidth - thumbSizeX - 6;
				}	
            }
            }
            if(imgWidth <= 99 || imgWidth == "") {
                imgWidth = 1024;
            }

allImagesAddedToSlider = [];
fullallImagesAddedToSlider = [];
allImagesAddedToSliderOrg = [];
		   
		   var newpopupImgSrc = '';
           jQPac.each( productImagesGSUrls, function( index, productImagesGSI ) {


            if(allImagesAddedToSlider.indexOf(getLargeImgUrl(jQPac, productImagesGSI, imgWidth, '')) == -1 ) {
                //jQPac(this).hide();
                lastImgSrc = imgSrc;
				var smallImageUrl = getLargeImgUrl(jQPac, productImagesGSI, imgWidth, '');
				var largeImageUrl = getLargeImgUrl(jQPac, productImagesGSI, fullScreenWidth, fullScreenHeight);
                allImagesAddedToSlider.push(smallImageUrl);
                fullallImagesAddedToSlider.push(largeImageUrl);
				allImagesAddedToSliderOrg.push(getLargeImgUrl(jQPac, productImagesGSI, 123123, 123123));
                //jQPac("body").prepend( jQPac('<img style="display: none;" id="gs-image-' + allImagesAddedToSlider.length + '" src="' + smallImageUrl + '" >') );
				var imageId = findImageId(largeImageUrl);
//				newpopupImgSrc = newpopupImgSrc + '<li  data-src="' + largeImageUrl + '" class="col-xs-6 col-sm-4 col-md-3" ><a href=""><img id="zoomgs' + imageId + '"  src="' + smallImageUrl + '"></a></li>';
            }

           });
//		   jQPac("body").append( jQPac('<div class="demo-gallery" style="display: none;"><ul id="lightgallery" class="list-unstyled row">' + newpopupImgSrc + '</ul></div>') );


            if(topMediaParent != '') {
		if(jQPac(".product-form__item").size() > 0) {
			topMediaParent.children().not('.product-form__item').hide();
		}
		else {
			topMediaParent.children().hide();
			topMediaParent.children().attr('disabled','disabled');
                	//topMediaParent.children().remove();
		}
            }

                if((specialTheme == 2) && percentageResize != 100) {
                var newElement = jQPac('<div class="gsContThin" style="margin-bottom: 20px;"></div>');

                if(jQPac("#AddToCartForm-product-template, #AddToCartForm-").length > 0) {
                    jQPac("#AddToCartForm-product-template, #AddToCartForm-").parent().prepend(newElement);
		    					jQPac("body").append("<style> @media only screen and (min-width: 990px) { .large-up--two-twelfths { width: 22.66667% !important; } .large-up--push-three-twelfths { left: 19% !important; } }   </style>");						

                }
                else {
                    jQPac("#AddToCartForm").parent().prepend(newElement);
                    percentageResize = percentageResize + 20;
                }
                topMediaParent = newElement;

                if(percentageResize == 0) {
//percentageResize = 50;
                }


                if(percentageResize != 0) {

                     var leftEl = 0;
                     if(jQPac("#AddToCartForm-product-template, #AddToCartForm-").length > 0) {
                        leftEl = jQPac("#AddToCartForm-product-template, #AddToCartForm-").parent();
                     }
                     else {
                         leftEl = jQPac("#AddToCartForm").parent();
                     }
                     var rightEl = jQPac(jQPac(".product-single__description").get(0)).parent();
                     var leftWidth = leftEl.width();
                     var rightWidth = rightEl.width();
                     var sumWidth = leftWidth + rightWidth;
                     var resizeVal = percentageResize * sumWidth / 200;
                     var newLeftWidth = (resizeVal + leftWidth);
                     var newRightWidth = (rightWidth - resizeVal);
                     if(fullScreenWidth >= newLeftWidth && fullScreenWidth >= newRightWidth) {
                      leftEl.css({'width': newLeftWidth + 'px'});
                      rightEl.css({'width': newRightWidth + 'px'});
		      leftEl.attr("style", 'width: ' + newLeftWidth + 'px !important;');
		      rightEl.attr("style", 'width: ' + newRightWidth + 'px !important;');	

                     }
                }

                     if(jQPac("#AddToCartForm-product-template, #AddToCartForm-").length > 0) {
                        leftEl = jQPac("#AddToCartForm-product-template, #AddToCartForm-").parent();
                        var containerLeft = jQPac("#AddToCartForm-product-template, #AddToCartForm-").parent();

                        containerLeft.children().reverse().each(function(index) {
                            if(!jQPac(this).hasClass("gsContThin")) {
                                jQPac(jQPac(".product-single__description").get(0)).parent().prepend(jQPac(this));
                            }
                        });
                     }
                     else {
                         leftEl = jQPac("#AddToCartForm").parent();
                     }
                     var leftWidth = leftEl.width();

                     imgWidth = leftWidth;

                }


  try { jQPac("#rondellCarousel").remove(); } catch(err) {}
            /* THIS IS FOR GALLERY
            var sliderContent = '<div id="rondellCarousel" style="display: block !important;">';
            //allImagesAddedToSlider
            jQPac.each( allImagesAddedToSlider, function( index, imageForSlider ) {
                //alert("XXX" + imageForSlider);
                //console.log(allImagesAddedToSliderOrg[index].width);
                sliderContent = sliderContent + '<a target="_blank" rel="rondell" href="' + imageForSlider + '" title="..."><img style="max-width: 10000px !important;" src="' + imageForSlider + '" alt="Band" title="My favourite band"><h5>Awesome concert</h5><p>My favourite band.</p></a>';
            });
            sliderContent = sliderContent + '</div>';
children().each(function () {
    });

            jQPac(topMediaParent).html(sliderContent);
            var parentHeight = topMediaParent.height();
            if(parentHeight > topMediaParent.width()) {
                //parentHeight = topMediaParent.width();
            }
            jQPac("#rondellCarousel > *").rondell({
              preset: "gallery",
              theme: "light",
            center: {
              top: (parentHeight / 2),
              left: (topMediaParent.width() / 2)
            },
            size: { width: topMediaParent.width(), height: (topMediaParent.width() + 100) },
            controls: {
              enabled: false,
            },
            itemProperties: {
              sizeFocused: {
                width: topMediaParent.width()/1,
                height: parentHeight/1
              }
            }
            });
    */
        return true;

}

function hasValue(valueOfAttr) {
	if(valueOfAttr == "undefined") {
		return false;
	}
	if(valueOfAttr == null) {
		return false;
	}
	if(valueOfAttr === false) {
		return false;
	}
	return true;
}

function getHashMini(elementForHash) {
        var hash = '';
        //elementForHash = jQPac(elementForHash);
        if(hasValue(jQPac(elementForHash).attr('class')) != false) {
                hash = hash + jQPac(elementForHash).attr('class');
        }

        if(hasValue(jQPac(elementForHash).attr('id')) != false) {
                hash = hash + jQPac(elementForHash).attr('id');
        }

        if(hasValue(jQPac(elementForHash).attr('itemprop')) != false) {
                hash = hash + jQPac(elementForHash).attr('itemprop');
        }

        return hash;
}

function getHash(elementForHash) {
	var hash = '';
	//elementForHash = jQPac(elementForHash);
	if(hasValue(jQPac(elementForHash).attr('class')) != false) {
		hash = hash + jQPac(elementForHash).attr('class');
	}

        if(hasValue(jQPac(elementForHash).attr('id')) != false) {
                hash = hash + jQPac(elementForHash).attr('id');
        }

        if(hasValue(jQPac(elementForHash).attr('name')) != false) {
                hash = hash + jQPac(elementForHash).attr('name');
        }

        if(hasValue(jQPac(elementForHash).attr('value')) != false) {
                hash = hash + jQPac(elementForHash).attr('value');
        }

        if(hasValue(jQPac(elementForHash).text()) != false) {
                hash = hash + jQPac(elementForHash).text();
        }
	return hash;
}

var getAddToCartButtons = function(){
    var addButtons = [];

if(addButtons.length == 0) {
        jQPac("body").find(".product_section .notify_form_message").each(function(index) {
            addButtons.push(this);
        });
}

//if(addButtons.length == 0) {
    jQPac("body").find('button, input[type="submit"], input[type="button"]').each(function(index) {
        var hash = getHash(this);
        if(hash.indexOf("Add") >= 0 || hash.indexOf("add") >= 0 || hash.indexOf("Buy") >= 0 || hash.indexOf("buy") >= 0 || hash.indexOf("Purchase") >= 0 || hash.indexOf("Sold") >= 0 || hash.indexOf("sold") >= 0 || hash.indexOf("out") >= 0 || hash.indexOf("Out") >= 0) {
            addButtons.push(this);
        }
    });
   /*
    if(addButtons.length == 0) {
        jQPac("body").find('span, div, p').each(function(index) {
            var hash = jQPac(this).clone().children().remove().end().text();
            if(hash.indexOf("Sold ") >= 0 || hash.indexOf("sold ") >= 0 || hash.indexOf("coming ") >= 0 || hash.indexOf("Coming ") >= 0) {
                addButtons.push(this);
            }
        });
    }
//}
   */

    if(addButtons.length == 0) {

        jQPac("body").find("[class*='price'], [class*='price'], [class*='Price'], [id*='Price']").each(function(index) {
	   if(jQPac(this).parents("header").length == 0) {
            addButtons.push(this);
	   }
        });

        jQPac("body").find('button, input[type="submit"], input[type="button"]').each(function(index) {
          if(jQPac(this).parents("header").length == 0) {
	    addButtons.push(this);
	  }
        });
    }

    if(addButtons.length == 0) {
        jQPac("body").find('input').each(function(index) {
	if(jQPac(this).parents("header").length == 0) {
            addButtons.push(this);
	}
        });
    }

    return addButtons;
};


var findMediaTopParent = function(firstImageElement){
    if(buttonsGS == '') {
        buttonsGS = getAddToCartButtons();
    }
    var topLevelElement = jQPac(firstImageElement);
    var previousTopLevelElement = topLevelElement;

        var hash = getHashMini(topLevelElement);
        hash = hash.toLowerCase();
        if(hash.indexOf("logo") >= 0) {
            return false;
        }

    while(true) {
        previousTopLevelElement = topLevelElement;
        topLevelElement = topLevelElement.parent();

        if(topLevelElement.prop("tagName") == undefined) {
            return false;
        }

        var nodeName = topLevelElement.prop("tagName").toLowerCase();
        if(nodeName == "body") {
            return false;
        }

        if(nodeName == "header") {
            return false;
        }

        var hash = getHashMini(topLevelElement);
        hash = hash.toLowerCase();
        if(hash.indexOf("logo") >= 0) {
            return false;
        }

        var topLevelFound = false;
        jQPac.each( buttonsGS, function( index, button ) {
            //console.log(button);
            if(jQPac.contains(topLevelElement.get(0), button)) {
		if(jQPac(previousTopLevelElement).css("display").indexOf("none") == -1) {
                topLevelFound = true;
		}

            if(jQPac(previousTopLevelElement.get(0)).hasClass("productPrevNext")) {
                topLevelFound = false;

            }   

            }
        });


	if(topLevelFound) {
	   if(jQPac(previousTopLevelElement.get(0)).html().indexOf("/cart") > 0) {
	    // console.debug(previousTopLevelElement.get(0));
		topLevelFound = false;
		return false;
	   }
	}

if(jQPac(previousTopLevelElement.get(0)).parents('[action*="checkout"]').length > 0) {
     topLevelFound = false;
     return false;
} 	

        if(topLevelFound) {
            //jQPac(previousTopLevelElement).css('background-color', 'red');

            /*
            jQPac("#rondellCarousel > *").rondell({
              preset: "carousel",
              size: { width: previousTopLevelElement.width(), height: parentHeight * (3/5) },
              center: { left: (previousTopLevelElement.width() / 2), top: ((parentHeight * (3/5)) / 2) },
              radius: { x: (previousTopLevelElement.width() / 2.5), y: (parentHeight / 6.5) },
              itemProperties: {size: {
                    width: previousTopLevelElement.width()/3.5,
                    height: parentHeight/3.5
              }}
            });
            */

            /*
            jQPac("#rondellCarousel > *").rondell({
              preset: "carousel",
              size: { width: previousTopLevelElement.width(), height: parentHeight },
              center: { left: (previousTopLevelElement.width() / 2), top: (parentHeight / 2) },
              radius: { x: (previousTopLevelElement.width() / 2.5), y: (parentHeight / 2.5) }
            });
            */
            //console.log(previousTopLevelElement);
            return previousTopLevelElement;
        }
    }
    return false;
};


var findImageId = function(imgUrlWeb) {

foundIndex = 0;

var foundStrlenofCur = 0;
jQPac.each( imageSrcAttr, function(index) {
var dotPos2 = this.lastIndexOf(".");
var ext2 = this.substr(0, dotPos2);

if(ext2.indexOf('4000x') > 0) {
var specEGS = ext2.split('4000x');
ext2 = specEGS[0];
}

var strlenofCur = ext2.length;


var gsUrlForReplace = imgUrlWeb;

if(gsUrlForReplace.replace("_4000x", "_GSFIXx").indexOf(ext2) != -1)
{

//if(foundIndex == 0) {
if(foundStrlenofCur < strlenofCur || (foundStrlenofCur == 0)) {
//if(foundStrlenofCur > strlenofCur || (foundStrlenofCur == 0)) {
foundStrlenofCur = strlenofCur;
foundIndex = index;
}
//}
}
});
return foundIndex;
}


/*
var findImageId = function(imgUrlWeb) {

foundIndex = 0;

jQPac.each( imageSrcAttr, function(index) {
var dotPos2 = this.lastIndexOf(".");
var ext2 = this.substr(0, dotPos2);

if(imgUrlWeb.indexOf(ext2) != -1)
{
if(foundIndex == 0) {
foundIndex = index;
}
}
});
return foundIndex;
}
*/


var appendSlider = function() {

            var thumbSize = thumbSizeX;
    try { jQPac("#rondellCarousel").remove(); jQPac('#lightgallery').remove(); } catch(err) {}
            var sliderContent = '<div id="rondellCarousel" style="display: block !important;">';
            //allImagesAddedToSlider
			newpopupImgSrc = '';

			// dry run 
			var tmpvariantImagesAddedToSlider = [];
			
			if(variantImagesAddedToSlider.length > 0) {
                jQPac.each(variantImagesAddedToSlider, function (index, imageForSlider) {

                  if(imageForSlider.indexOf("/products/") != -1) {
                    imageForSlider = '/' + imageForSlider.split('/products/')[1];
                   }

                   splitterX = imageForSlider.split("/files/");
                   if(splitterX.length >= 3) {
                    imageForSlider = splitterX[splitterX.length - 1];
                   }

                    var imgOrgUrl = null;
                    jQPac.each(allImagesAddedToSlider, function (index2, imageForSlider2) {
						//console.debug(allImagesAddedToSliderOrg[index2]);
                        if(allImagesAddedToSliderOrg[index2].indexOf(imageForSlider + "_123123") > 0) {
							tmpvariantImagesAddedToSlider.push(imageForSlider);
                        }
                    });
				});				
			}
			variantImagesAddedToSlider = tmpvariantImagesAddedToSlider;

            if(variantImagesAddedToSlider.length == 0) {
                jQPac.each( allImagesAddedToSlider, function( index, imageForSlider ) {
                    //alert("XXX" + imageForSlider);
                    if((variantImagesAddedToSlider.length == 0) || variantOptionValid(imageForSlider)) {
                        var elID = findImageId(fullallImagesAddedToSlider[index]);
                        sliderContent = sliderContent + '<a target="_blank" rel="rondell" href="' + fullallImagesAddedToSlider[index] + '" ><img id="gs' + elID + '" style="max-width: ' + imageDimensionsWidth2[elID] + 'px; max-height: ' + imageDimensionsHeight2[elID] + 'px;  width: ' + imageDimensionsWidth2[elID]  + 'px; height: ' + imageDimensionsHeight2[elID] + 'px" src="' + imageForSlider + '" alt=\'' + altTag[elID] + '\' ></a>';
						var imageId = findImageId(fullallImagesAddedToSlider[index]);
if(altTag[elID].indexOf("iframe") <= 0) {
						newpopupImgSrc = newpopupImgSrc + '<li  data-src="' + fullallImagesAddedToSlider[index] + '" class="col-xs-6 col-sm-4 col-md-3" ><a href=""><img id="zoomgs' + imageId + '"  src="' + imageForSlider + '"></a></li>';
}						
                    }
                });
            }
            else {
                jQPac.each(variantImagesAddedToSlider, function (index, imageForSlider) {
                    var imgOrgUrl = null;
                    jQPac.each(allImagesAddedToSlider, function (index2, imageForSlider2) {
						//console.debug(allImagesAddedToSliderOrg[index2]);
                        if(allImagesAddedToSliderOrg[index2].indexOf(imageForSlider + "_123123") > 0) {
                            imageForSlider = imageForSlider2;
                            index = index2;
                        }
                    });

                    if ((variantImagesAddedToSlider.length == 0) || variantOptionValid(imageForSlider)) {
                        var elID = findImageId(fullallImagesAddedToSlider[index]);
                        sliderContent = sliderContent + '<a target="_blank" rel="rondell" href="' + fullallImagesAddedToSlider[index] + '" ><img id="gs' + elID + '" style="max-width: ' + imageDimensionsWidth2[elID] + 'px; max-height: ' + imageDimensionsHeight2[elID] + 'px;  width: ' + imageDimensionsWidth2[elID] + 'px; height: ' + imageDimensionsHeight2[elID] + 'px" src="' + imageForSlider + '" alt=\'' + altTag[elID] + '\' ></a>';
						var imageId = findImageId(fullallImagesAddedToSlider[index]);
if(altTag[elID].indexOf("iframe") <= 0) {
						newpopupImgSrc = newpopupImgSrc + '<li  data-src="' + fullallImagesAddedToSlider[index] + '" class="col-xs-6 col-sm-4 col-md-3" ><a href=""><img id="zoomgs' + imageId + '"  src="' + imageForSlider + '"></a></li>';						
}
                    }
                });
            }
            sliderContent = sliderContent + '</div>';
  		   jQPac("body").append( jQPac('<div class="demo-gallery" style="display: none;"><ul id="lightgallery" class="list-unstyled row">' + newpopupImgSrc + '</ul></div>') );

		lgGallery =jQPac('#lightgallery').lightGallery();
		
		lgGallery.on('onBeforeOpen.lg',function(event){
		    jQPac("body").append('<style class="hidedivsgs"> div, a { z-index: 1 !important; }</style>');
		    if (window.history && window.history.pushState) {
		      window.history.pushState('forward', null, '#');
		      jQPac(window).on('popstate', function() {
				  jQPac(".lg-close").trigger("click");
				  return true;
		      });

		    }
		});

			lgGallery.on('onBeforeClose.lg',function(event){
				jQPac(".hidedivsgs").each(function () {
					jQPac(this).remove();
				});
			});					
		

jQPac(topMediaParent).children().not('.product-form__item').each(function () {
              jQPac(this).hide();
              jQPac(this).attr('disabled','disabled');
});
jQPac(topMediaParent).prepend(sliderContent);

//            jQPac(topMediaParent).html(sliderContent);
/*
	    jQPac.each( allImagesAddedToSlider, function( index, imageForSlider ) {
	    var elID = findImageId(fullallImagesAddedToSlider[index]);
	    jQPac("#gs" + elID).width(imageDimensionsWidth2[elID]);
	    jQPac("#gs" + elID).height(imageDimensionsHeight2[elID]);
	    });
*/
if((Modernizr.touch && (jQPac(window).width() < 800)) ||  /Android|webOS|iPhone|iPiad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
if(topMediaParent.width() == 0 || (specialTheme == 4)) {
 topMediaParent.width(topMediaParent.parent().width());
 if(topMediaParent.width() == 0) {
 topMediaParent.width(fullScreenWidth);
 }
}
}
            var parentHeight = topMediaParent.height();
            if(parentHeight > topMediaParent.width()) {
                //parentHeight = topMediaParent.width();
            }

            if(maxHeightOfAllMedia > forcemaxHeightOfAllMedia) {
                maxHeightOfAllMedia = forcemaxHeightOfAllMedia;
            }

            parentHeight = maxHeightOfAllMedia;

if(window.location.href.indexOf("jobin") > 0) {
parentHeight = maxHeightOfAllMedia + 120;
}

            if(initialWidth == 0) {
                initialWidth = topMediaParent.width();
                initialHeight = parentHeight;
            }
            else {
                parentHeight = parentHeight * (topMediaParent.width() / initialWidth);
            }

            var parentWidth = topMediaParent.width();
            var controlsEnabled = true;
            if(allImagesAddedToSlider.length == 1) {
                controlsEnabled = false;
            }

            if(variantImagesAddedToSlider.length == 1) {
                controlsEnabled = false;
            }


if(window.location.href.indexOf("enchanted") >= 0 || window.location.href.indexOf("gleener") >= 0) {
    fadeTimeGS = 1;
}

        var layerToAppear = 1;

        if(window.location.href.indexOf("variant=") > 0) {
        currentPage = window.location.href;
        var urlSplit = window.location.href.split("variant=");
        var variantId = urlSplit[1];
		if(variantId.indexOf("#") > 0) {
			var urlSplitSec = variantId.split("#");
			variantId = urlSplitSec[0];
		}	

        if(currentPage.indexOf(variantId) != -1) {
        if((typeof variantImagesGS != "undefined") && variantId in variantImagesGS) {
        var dotPos2 = variantImagesGS[variantId].lastIndexOf(".");
        var ext2 = variantImagesGS[variantId].substr(0, dotPos2);
        var longest = 0;
        jQPac.each( allImagesAddedToSlider, function( index, imageForSlider ) {
        if(imageForSlider.indexOf(ext2) != -1)
        {
        if(imageForSlider.length <= longest || (longest == 0)) {
            longest = imageForSlider.length;
            layerToAppear = index + 1;
        }
        }
        });

        }
        }
        }


    if(variantImagesAddedToSlider.length > 0)
    {
        layerToAppear = 1;
    }


try {
if(jQPac('.product__description').length > 0) {
var rightq = jQPac(jQPac('.product__description').get(0));
var rightv = parseInt(rightq.css("margin-left").replace("px", ""));
if(rightv < -200) {
parentHeight = parentHeight * 11 / 16
}
}
} catch(err) {}


var gscalcHeight = (parseInt(parentHeight) + parseInt(thumbSize) + parseInt(10));

var navposCal = parentHeight / 2 - 15;
if(navpos == 1) {
	navposCal = 10;
}
if(navpos == 3) {
	navposCal = parentHeight  - 30;
}

            jQPac("#rondellCarousel > *").rondell({
              preset: "slider",
	      fadeTime: fadeTimeGS,
          autoRotation:
          {
            enabled: autorotate,
            direction: 1,
            once: false,
            delay: autorotatetime
          },
            center: {
              top: (parentHeight / 2),
              left: (topMediaParent.width() / 2)
            },
            lightbox: {
                enabled: isLightboxEnabled
            },
            theme: "light",
            size: { width: topMediaParent.width(), height: parentHeight },
            controls: {
                enabled: controlsEnabled,
        margin: {
          x: 0,
          y: navposCal
        }
      },
            currentLayer: layerToAppear,
      funcTop: function(l, r, i) {
        return 0;
      },
            itemProperties: {
              sizeFocused: {
                width: topMediaParent.width()/1,
                height: parentHeight
              },
                size: {
                  width: thumbSize,
                  height: thumbSize
                }
            },
            });


			setTimeout(function()
			{
			window.isClicked = true;
			}, 400);

			setTimeout(function()
			{

     			 try {
     			if(zoomOnHover) {
     				if(zoomOnHoverMode == 1) {
  					jQPac('.rondell-item').each(function() {
  						if(jQPac(this).find("iframe").length == 0) {
     			    			jQPac(this).gravizoom({ touch: zoomOnHoverMobile });		
  						}
  					});				
     				}
     				else {
     				jQPac('.rondell-item').each(function() {
  					if(jQPac(this).find("iframe").length == 0) {
     					jQPac(this).gravizoom({url: jQPac(this).attr("href").replace('_4000x', '_2000x'), touch: zoomOnHoverMobile });
  					}
     				});
     				}
     			}
     			} catch(err) {}	
				
				jQPac("#rondellCarousel .mediaWrapper iframe").each(function() {
					jQPac(this).unwrap();
				});
			}, 1000);	

}

var appendGallery = function() {
	
	
		var preventSameImage = '';

            var thumbSize = thumbSizeX;
//alert(fullScreenWidth);
 try { jQPac("#rondellCarousel").remove(); jQPac('#lightgallery').remove(); } catch(err) {}
            var sliderContent = '<div id="rondellCarousel" style="display: block !important;" >';
            //allImagesAddedToSlider
			newpopupImgSrc = '';


			// dry run 
			var tmpvariantImagesAddedToSlider = [];
			
			if(variantImagesAddedToSlider.length > 0) {
                jQPac.each(variantImagesAddedToSlider, function (index, imageForSlider) {

                  if(imageForSlider.indexOf("/products/") != -1) {
                    imageForSlider = '/' + imageForSlider.split('/products/')[1];
                   }

                   splitterX = imageForSlider.split("/files/");
                   if(splitterX.length >= 3) {
                    imageForSlider = splitterX[splitterX.length - 1];
                   }

                    var imgOrgUrl = null;
                    jQPac.each(allImagesAddedToSlider, function (index2, imageForSlider2) {
						//console.debug(allImagesAddedToSliderOrg[index2]);
                        if(allImagesAddedToSliderOrg[index2].indexOf(imageForSlider + "_123123") > 0) {
							tmpvariantImagesAddedToSlider.push(imageForSlider);
                        }
                    });
				});				
			}
			variantImagesAddedToSlider = tmpvariantImagesAddedToSlider;

            if(variantImagesAddedToSlider.length == 0) {
                jQPac.each(allImagesAddedToSlider, function (index, imageForSlider) {
                    //alert("XXX" + imageForSlider);
                    //console.log(allImagesAddedToSliderOrg[index].width);
                    if ((variantImagesAddedToSlider.length == 0) || variantOptionValid(imageForSlider)) {
                        var elID = findImageId(fullallImagesAddedToSlider[index]);
                        sliderContent = sliderContent + '<a target="_blank" rel="rondell" href="' + fullallImagesAddedToSlider[index] + '" ><img id="gs' + elID + '" style="max-width: ' + imageDimensionsWidth2[elID] + 'px; max-height: ' + imageDimensionsHeight2[elID] + 'px;  width: ' + imageDimensionsWidth2[elID] + 'px; height: ' + imageDimensionsHeight2[elID] + 'px" src="' + imageForSlider + '" alt=\'' + altTag[elID] + '\' ></a>';
						var imageId = findImageId(fullallImagesAddedToSlider[index]);
if(altTag[elID].indexOf("iframe") <= 0) {
						newpopupImgSrc = newpopupImgSrc + '<li  data-src="' + fullallImagesAddedToSlider[index] + '" class="col-xs-6 col-sm-4 col-md-3" ><a href=""><img id="zoomgs' + imageId + '"  src="' + imageForSlider + '"></a></li>';
}
                    }
                });
            }
            else {
                jQPac.each(variantImagesAddedToSlider, function (index, imageForSlider) {
                    var imgOrgUrl = null;
					var index2Tmp = '';
                    jQPac.each(allImagesAddedToSlider, function (index2, imageForSlider2) {
						//console.debug(allImagesAddedToSliderOrg[index2]);
                        if(allImagesAddedToSliderOrg[index2].indexOf(imageForSlider + "_123123") > 0 && preventSameImage.indexOf(index2 + ';') == -1 ) {
                            imageForSlider = imageForSlider2;
                            index = index2;		
							index2Tmp = index2;					
                        }
                    });
					
					if(index2Tmp != '') {
						//preventSameImage = preventSameImage + index2Tmp + '; ';
					}

                    if ((variantImagesAddedToSlider.length == 0) || variantOptionValid(imageForSlider)) {
                        var elID = findImageId(fullallImagesAddedToSlider[index]);
                        sliderContent = sliderContent + '<a target="_blank" rel="rondell" href="' + fullallImagesAddedToSlider[index] + '" ><img id="gs' + elID + '" style="max-width: ' + imageDimensionsWidth2[elID] + 'px; max-height: ' + imageDimensionsHeight2[elID] + 'px;  width: ' + imageDimensionsWidth2[elID] + 'px; height: ' + imageDimensionsHeight2[elID] + 'px" src="' + imageForSlider + '" alt=\'' + altTag[elID] + '\' ></a>';
						var imageId = findImageId(fullallImagesAddedToSlider[index]);
if(altTag[elID].indexOf("iframe") <= 0) {
						newpopupImgSrc = newpopupImgSrc + '<li  data-src="' + fullallImagesAddedToSlider[index] + '" class="col-xs-6 col-sm-4 col-md-3" ><a href=""><img id="zoomgs' + imageId + '"  src="' + imageForSlider + '"></a></li>';
}
                    }
                });
            }
            sliderContent = sliderContent + '</div>';
						
 		   jQPac("body").append( jQPac('<div class="demo-gallery" style="display: none;"><ul id="lightgallery" class="list-unstyled row">' + newpopupImgSrc + '</ul></div>') );
			lgGallery =jQPac('#lightgallery').lightGallery();
			
			lgGallery.on('onBeforeOpen.lg',function(event){
			    jQPac("body").append('<style class="hidedivsgs"> div, a { z-index: 1 !important; }</style>');
			    if (window.history && window.history.pushState) {
			      window.history.pushState('forward', null, '#');
			      jQPac(window).on('popstate', function() {
					  jQPac(".lg-close").trigger("click");
					  return true;
			      });

			    }
			});	

			lgGallery.on('onBeforeClose.lg',function(event){
				jQPac(".hidedivsgs").each(function () {
					jQPac(this).remove();
				});
			});		

jQPac(topMediaParent).children().not('.product-form__item').each(function () {
              jQPac(this).hide();
              jQPac(this).attr('disabled','disabled');
});
jQPac(topMediaParent).prepend(sliderContent);
            //jQPac(topMediaParent).html(sliderContent);

if((Modernizr.touch && (jQPac(window).width() < 800)) ||  /Android|webOS|iPhone|iPiad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
 if(topMediaParent.width() == 0 || (specialTheme == 4)) {
 topMediaParent.width(topMediaParent.parent().width());
 if(topMediaParent.width() == 0) {
 topMediaParent.width(fullScreenWidth);
 }
}
}

            var parentHeight = 0;


            if(parentHeight == 0) {
		parentHeight = maxHeightOfAllMedia;
                if(maxHeightOfAllMedia > forcemaxHeightOfAllMedia) {
             		parentHeight = forcemaxHeightOfAllMedia;
	        }

		parentHeight = maxHeightOfAllMedia;
	    }
            if(parentHeight > topMediaParent.width()) {
                //parentHeight = topMediaParent.width();
            }
/*
            parentHeight = parentHeight / 1.1;
            if(parentHeight > forcemaxHeightOfAllMedia) {
                parentHeight = forcemaxHeightOfAllMedia;
            }
*/
           if(maxHeightOfAllMedia > forcemaxHeightOfAllMedia) {
                maxHeightOfAllMedia = forcemaxHeightOfAllMedia;
            }

           // parentHeight = parentHeight / 1.1;
            if(parentHeight > maxHeightOfAllMedia) {
                parentHeight = maxHeightOfAllMedia;
            }



            var parentWidth = topMediaParent.width();

if(fullScreenWidth < parentWidth) {
parentWidth = fullScreenWidth;
}


            if(initialWidth == 0) {
                initialWidth = parentWidth;
                initialHeight = parentHeight;
            }
            else {
                parentHeight = parentHeight * (parentWidth / initialWidth);
            }

if(window.location.href.indexOf("enchanted") >= 0 || window.location.href.indexOf("gleener") >= 0) {
    fadeTimeGS = 1;
}

        var layerToAppear = 1;

        if(window.location.href.indexOf("variant=") > 0) {
        currentPage = window.location.href;
        var urlSplit = window.location.href.split("variant=");
        var variantId = urlSplit[1];
		if(variantId.indexOf("#") > 0) {
			var urlSplitSec = variantId.split("#");
			variantId = urlSplitSec[0];
		}
        if(currentPage.indexOf(variantId) != -1) {
        if((typeof variantImagesGS != "undefined") && variantId in variantImagesGS) {
        var dotPos2 = variantImagesGS[variantId].lastIndexOf(".");
        var ext2 = variantImagesGS[variantId].substr(0, dotPos2);
        var longest = 0;
        jQPac.each( allImagesAddedToSlider, function( index, imageForSlider ) {
        if(imageForSlider.indexOf(ext2) != -1)
        {
        if(imageForSlider.length <= longest || (longest == 0)) {
            longest = imageForSlider.length;
            layerToAppear = index + 1;
        }
        }
        });

        }
        }
        }

        if(variantImagesAddedToSlider.length > 0)
        {
            layerToAppear = 1;
        }

        var controlsEnabled = gallerynav;
        if(variantImagesAddedToSlider.length == 1) {
            controlsEnabled = false;
        }

try {
if(jQPac('.product__description').length > 0) {
var rightq = jQPac(jQPac('.product__description').get(0));
var rightv = parseInt(rightq.css("margin-left").replace("px", ""));
if(rightv < -200) {
parentHeight = parentHeight * 11 / 16
}
}
} catch(err) {}


var gscalcHeight = (parseInt(parentHeight) + parseInt(thumbSize) + parseInt(10));

var navposCal = parentHeight / 2 - 15;
var navposCalLeft = -1;
if(navpos == 1) {
	navposCal = 10;
}


var navdepCentLeft = (parentWidth / 2);
var navdepCentTop = (parentHeight / 2);
if(navinleft) {
	var leftNavAdjust = navinleftspace + thumbSize;
	jQPac("body").append("<style>.lg-gs-left { left: " + parseInt(leftNavAdjust + 2) + "px !important;} </style>");
	navdepCentLeft = ((parentWidth + thumbSize) / 2) + navinleftspace;
	navdepCentTop = ((parentHeight - thumbSize) / 2);
	gscalcHeight = (parseInt(parentHeight)) - (thumbSize);
}

if(navpos == 3) {
	navposCal = gscalcHeight  - 30;
}


var navdepSizeFocWidth = parentWidth;
if(navinleft) {
	navdepSizeFocWidth = parentWidth - thumbSize - navinleftspace;
}



            jQPac("#rondellCarousel > *").rondell({
              preset: "gallery",
              theme: "light",
	      fadeTime: fadeTimeGS,
	  autoRotation: 	
	  {
	    enabled: autorotate,
	    direction: 1,
	    once: false,
	    delay: autorotatetime
	  },
            center: {
              top: navdepCentTop,
              left: navdepCentLeft
            },
            size: { width: parentWidth, height: gscalcHeight },
            controls: {
              enabled: controlsEnabled,
        margin: {
          x: navposCalLeft,
          y: navposCal
        }
            },
      strings: {
        prev: '<button class="lg-prev lg-icon"></button>',
        next: '<button class="lg-next lg-icon"></button>'
      },
            lightbox: {
                enabled: isLightboxEnabled
            },
            currentLayer: layerToAppear,
      funcTop: function(l, r, i) {
		  if(navinleft) {
	          var spaceNeeded = ((allImagesAddedToSlider.length - 1) * (r.itemProperties.size.height + r.special.itemPadding));

	          if(variantImagesAddedToSlider.length != 0) {
	              spaceNeeded = ((variantImagesAddedToSlider.length - 1) * (r.itemProperties.size.height + r.special.itemPadding));
	          }
			  var spaceLeft = gscalcHeight - spaceNeeded;
			  spaceToCenter = 0;
	          if(spaceLeft > 0) {
	              spaceToCenter = spaceLeft / 2;
	          }
			  
	          var offsetHeight = ((r._focusedItem.currentSlot ) * (r.itemProperties.size.height + r.special.itemPadding)) - gscalcHeight;
			  //offsetHeight = 0;
			  //spaceToCenter = 0;
	          //console.log(offsetWidth);
	          if(offsetHeight <= 0) {
	              offsetHeight = 0;
	          }			  		
			  
	          if(i > r._focusedItem.currentSlot) {
	              return  (i - 2) * (r.itemProperties.size.height + r.special.itemPadding) + spaceToCenter - offsetHeight;
	          }
	          return  (i - 1) * (r.itemProperties.size.height + r.special.itemPadding) + spaceToCenter - offsetHeight;			  	  
			  
		  }
		  else {

			jQPac(".rondell-container").first().css("height", r._focusedItem.iconHeight + 14 + thumbSizeX);
		  return (r._focusedItem.iconHeight + 14);
	          return r.size.height - r.itemProperties.size.height - r.special.itemPadding;		  	
		  }
      },
      funcDiff: function(d, r, i) {
        return Math.abs(d) - 0.5;
      },
      funcLeft: function(l, r, i) {
		  if(navinleft) {
			  return 0;
		  }
		  else {
          var spaceNeeded = ((allImagesAddedToSlider.length - 1) * (r.itemProperties.size.width + r.special.itemPadding));

          if(variantImagesAddedToSlider.length != 0) {
              spaceNeeded = ((variantImagesAddedToSlider.length - 1) * (r.itemProperties.size.width + r.special.itemPadding));
          }

          var spaceLeft = parentWidth - spaceNeeded;
          var spaceToCenter = 0;
          if(spaceLeft > 0) {
              spaceToCenter = spaceLeft / 2;
          }
          var offsetWidth = ((r._focusedItem.currentSlot ) * (r.itemProperties.size.width + r.special.itemPadding)) - parentWidth;
          //console.log(offsetWidth);
          if(offsetWidth <= 0) {
              offsetWidth = 0;
          }

          if(i > r._focusedItem.currentSlot) {
              return  (i - 2) * (r.itemProperties.size.width + r.special.itemPadding) + spaceToCenter - offsetWidth;
          }

		  try {
			 var thumbQty = jQPac(".rondell-item-image").length ;
			  
		  if(((thumbQty - 1) * (thumbSizeX + 2)) > parentWidth) {
		  if(thumbQty == r._focusedItem.currentSlot) {
		  	return  (i - 0) * (r.itemProperties.size.width + r.special.itemPadding) + spaceToCenter - offsetWidth;
		  }
	  	  }
		  } catch(err) {}

          return  (i - 1) * (r.itemProperties.size.width + r.special.itemPadding) + spaceToCenter - offsetWidth;

        return r.center.left + (l - 0.5) * (r.itemProperties.size.width + r.special.itemPadding);
		}
      },
            itemProperties: {
              sizeFocused: {
                width: navdepSizeFocWidth,
                height: gscalcHeight
              },
                size: {
                  width: thumbSize,
                  height: thumbSize
                }
            }
            });

			setTimeout(function()
			{
			window.isClicked = true;
			}, 400);

			setTimeout(function()
			{
				
      			 try {
      			if(zoomOnHover) {
      				if(zoomOnHoverMode == 1) {
   					jQPac('.rondell-item-crop').each(function() {
   						if(jQPac(this).find("iframe").length == 0) {
      			    			jQPac(this).gravizoom({ touch: zoomOnHoverMobile });		
   						}
   					});				
      				}
      				else {
      				jQPac('.rondell-item-crop').each(function() {
   					if(jQPac(this).find("iframe").length == 0) {
      					jQPac(this).gravizoom({url: jQPac(this).parent().attr("href").replace('_4000x', '_2000x'), touch: zoomOnHoverMobile });
   					}
      				});
      				}
      			}
      			} catch(err) {}
				
				
				jQPac("#rondellCarousel .mediaWrapper iframe").each(function() {
					jQPac(this).unwrap();
				});
			}, 1000);	

}

var appendCarousel = function(){


    var diffFunc;
    var startImageNr = 1;

			// dry run 
			var tmpvariantImagesAddedToSlider = [];
			
			if(variantImagesAddedToSlider.length > 0) {
                jQPac.each(variantImagesAddedToSlider, function (index, imageForSlider) {
                    var imgOrgUrl = null;
                    jQPac.each(allImagesAddedToSlider, function (index2, imageForSlider2) {
						//console.debug(allImagesAddedToSliderOrg[index2]);
                        if(allImagesAddedToSliderOrg[index2].indexOf(imageForSlider + "_123123") > 0) {
							tmpvariantImagesAddedToSlider.push(imageForSlider);
                        }
                    });
				});				
			}
			variantImagesAddedToSlider = tmpvariantImagesAddedToSlider;


    if(variantImagesAddedToSlider.length == 0) {
        if(allImagesAddedToSlider.length > 2) {
            diffFunc = undefined;
        }
        else if(allImagesAddedToSlider.length == 1) {
            diffFunc = undefined;
        }
        else if(allImagesAddedToSlider.length == 2) {
            diffFunc = function(d, r, i) {
              return Math.abs(d) - 2.5;
            };
        }

        if(allImagesAddedToSlider.length == 3) {
            var firstImg = allImagesAddedToSlider[0];
            allImagesAddedToSlider[0] = allImagesAddedToSlider[1];
            allImagesAddedToSlider[1] = firstImg;
			var firstImgOrg = allImagesAddedToSliderOrg[0];
			allImagesAddedToSliderOrg.push[0] = allImagesAddedToSliderOrg[1];
			allImagesAddedToSliderOrg[1] = firstImgOrg;
            startImageNr = 2;
        }
    }
    else {
        if(variantImagesAddedToSlider.length > 2) {
            diffFunc = undefined;
        }
        else if(variantImagesAddedToSlider.length == 1) {
            diffFunc = undefined;
        }
        else if(variantImagesAddedToSlider.length == 2) {
            diffFunc = function(d, r, i) {
              return Math.abs(d) - 2.5;
            };
        }

        if(variantImagesAddedToSlider.length == 3) {
            var firstImg = variantImagesAddedToSlider[0];
            variantImagesAddedToSlider[0] = variantImagesAddedToSlider[1];
            variantImagesAddedToSlider[1] = firstImg;
            startImageNr = 2;
        }
    }

    try { jQPac("#rondellCarousel").remove(); jQPac('#lightgallery').remove(); } catch(err) {}
    var sliderContent = '<div id="rondellCarousel" style="display: block !important;" >';
    //allImagesAddedToSlider

    var dddd = new Date();
    var nnnn = dddd.getTime();
	newpopupImgSrc = '';
    if(variantImagesAddedToSlider.length == 0) {
        jQPac.each(allImagesAddedToSlider, function (index, imageForSlider) {
            if ((variantImagesAddedToSlider.length == 0) || variantOptionValid(imageForSlider)) {
                var elID = findImageId(fullallImagesAddedToSlider[index]);
                var urlIMGSplit = imageForSlider.split("dategs=");
                sliderContent = sliderContent + '<a target="_blank" rel="rondell" href="' + fullallImagesAddedToSlider[index] + '" ><img id="gs' + elID + '" style="" src="' + urlIMGSplit[0] + 'dategs=' + nnnn + '" alt=\'' + altTag[elID] + '\' ></a>';
				var imageId = findImageId(fullallImagesAddedToSlider[index]);
if(altTag[elID].indexOf("iframe") <= 0) {
				newpopupImgSrc = newpopupImgSrc + '<li  data-src="' + fullallImagesAddedToSlider[index] + '" class="col-xs-6 col-sm-4 col-md-3" ><a href=""><img id="zoomgs' + imageId + '"  src="' + imageForSlider + '"></a></li>';
}				
            }
        });
    }
    else {
        jQPac.each(variantImagesAddedToSlider, function (index, imageForSlider) {

            jQPac.each(allImagesAddedToSlider, function (index2, imageForSlider2) {
                if(allImagesAddedToSliderOrg[index2].indexOf(imageForSlider + "_123123") > 0) {
                    imageForSlider = imageForSlider2;
                    index = index2;
                }
            });

            if ((variantImagesAddedToSlider.length == 0) || variantOptionValid(imageForSlider)) {
                var elID = findImageId(fullallImagesAddedToSlider[index]);
                var urlIMGSplit = imageForSlider.split("dategs=");
                sliderContent = sliderContent + '<a target="_blank" rel="rondell" href="' + fullallImagesAddedToSlider[index] + '" ><img id="gs' + elID + '" style="" src="' + urlIMGSplit[0] + 'dategs=' + nnnn + '" alt=\'' + altTag[elID] + '\' ></a>';
				var imageId = findImageId(fullallImagesAddedToSlider[index]);
if(altTag[elID].indexOf("iframe") <= 0) {
				newpopupImgSrc = newpopupImgSrc + '<li  data-src="' + fullallImagesAddedToSlider[index] + '" class="col-xs-6 col-sm-4 col-md-3" ><a href=""><img id="zoomgs' + imageId + '"  src="' + imageForSlider + '"></a></li>';
}
            }
        });
    }

    sliderContent = sliderContent + '</div>';

   jQPac("body").append( jQPac('<div class="demo-gallery" style="display: none;"><ul id="lightgallery" class="list-unstyled row">' + newpopupImgSrc + '</ul></div>') );
	jQPac('#lightgallery').lightGallery();
	
	
jQPac(topMediaParent).children().not('.product-form__item').each(function () {
              jQPac(this).hide();
              jQPac(this).attr('disabled','disabled');
});
jQPac(topMediaParent).prepend(sliderContent);

//    jQPac(topMediaParent).html(sliderContent);
    /*
            jQPac.each( allImagesAddedToSlider, function( index, imageForSlider ) {
            var elID = findImageId(fullallImagesAddedToSlider[index]);
            jQPac("#gs" + elID).width(imageDimensionsWidth2[elID]);
            jQPac("#gs" + elID).height(imageDimensionsHeight2[elID]);
	});
*/
    var parentHeight = topMediaParent.height();
    parentHeight = maxHeightOfAllMedia + 8;
    var heightDisplay = parentHeight;

            if(initialWidth == 0) {
                initialWidth = topMediaParent.width();
                initialHeight = parentHeight;
            }
            else {
                parentHeight = parentHeight * (topMediaParent.width() / initialWidth);
            }

    if(parentHeight > topMediaParent.width()) {
        parentHeight = topMediaParent.width();
        //heightDisplay = parentHeight / 3.5;
        heightDisplay = parentHeight / 2.2;
    }
    else {
        parentHeight = parentHeight * 5/3;
    }

    var decreaseRatio = 1;
    var decreaseRatio2 = 1;

/*
    if(parentHeight > forcemaxHeightOfAllMedia) {
        decreaseRatio = forcemaxHeightOfAllMedia / parentHeight;
        parentHeight = forcemaxHeightOfAllMedia;
        heightDisplay = parentHeight;
    }
*/
    //alert(decreaseRatio);
    var maxParentHeightCalc = parentHeight * (3/5);
    var radiousYCacl = (parentHeight / 6.5);
    if(maxParentHeightCalc > forcemaxHeightOfAllMedia) {
        decreaseRatio2 = forcemaxHeightOfAllMedia / parentHeight;
        maxParentHeightCalc = forcemaxHeightOfAllMedia;
        radiousYCacl = (forcemaxHeightOfAllMedia / 6.5);
        heightDisplay = heightDisplay * decreaseRatio2;
    }

        var layerToAppear = 1;

        if(window.location.href.indexOf("variant=") > 0) {
        currentPage = window.location.href;
	currentPage = currentPage.replace("#", "");
        var urlSplit = window.location.href.split("variant=");
        var variantId = urlSplit[1];
		if(variantId.indexOf("#") > 0) {
			var urlSplitSec = variantId.split("#");
			variantId = urlSplitSec[0];
		}
        if(currentPage.indexOf(variantId) != -1) {
        if((typeof variantImagesGS != "undefined") && variantId in variantImagesGS) {
        var dotPos2 = variantImagesGS[variantId].lastIndexOf(".");
        var ext2 = variantImagesGS[variantId].substr(0, dotPos2);

        var longest = 0;
        jQPac.each( allImagesAddedToSlider, function( index, imageForSlider ) {
        if(imageForSlider.indexOf(ext2) != -1)
        {
        if(imageForSlider.length <= longest || (longest == 0)) {
            longest = imageForSlider.length;
            layerToAppear = index + 1;
	    startImageNr = layerToAppear;
        }
        }
        });

        }
        }
        }

try {
if(jQPac('.product__description').length > 0) {
var rightq = jQPac(jQPac('.product__description').get(0));
var rightv = parseInt(rightq.css("margin-left").replace("px", ""));
if(rightv < -200) {
maxParentHeightCalc = maxParentHeightCalc * 11 / 16
}
}
} catch(err) {}

var sizeFocusedHeight = maxParentHeightCalc - 10;

    jQPac("#rondellCarousel > *").rondell({
      preset: "carousel",
      fadeTime: fadeTimeGS,		
          autoRotation:
          {
            enabled: autorotate,
            direction: 1,
            once: false,
            delay: autorotatetime
          },
      size: { width: topMediaParent.width() * decreaseRatio, height: maxParentHeightCalc },
      center: { left: (topMediaParent.width() * decreaseRatio / 2), top: (maxParentHeightCalc / 2) },
      radius: { x: (topMediaParent.width() * decreaseRatio / 2.5), y: radiousYCacl },
        controls: {
          enabled: false,
        },
        lightbox: {
            enabled: isLightboxEnabled
        },
      itemProperties: {size: {
            width: topMediaParent.width() * decreaseRatio/3.5,
            height: heightDisplay
      }, sizeFocused: {
height: sizeFocusedHeight
          }},
      currentLayer: startImageNr,
      randomStart: false,
      funcDiff: diffFunc,
    });


			setTimeout(function()
			{
			window.isClicked = true;
			}, 400);

			setTimeout(function()
			{
				
    			 try {
    			if(zoomOnHover) {
    				if(zoomOnHoverMode == 1) {
 					jQPac('.rondell-item').each(function() {
 						if(jQPac(this).find("iframe").length == 0) {
    			    			jQPac(this).gravizoom({ touch: zoomOnHoverMobile });		
 						}
 					});				
    				}
    				else {
    				jQPac('.rondell-item').each(function() {
 					if(jQPac(this).find("iframe").length == 0) {
    					jQPac(this).gravizoom({url: jQPac(this).attr("href").replace('_4000x', '_2000x'), touch: zoomOnHoverMobile });
 					}
    				});
    				}
    			}
    			} catch(err) {}	
				
				jQPac("#rondellCarousel .mediaWrapper iframe").each(function() {
					jQPac(this).unwrap();
				});
			}, 1000);	

}

function variantOptionValid(imageForSlider) {

    var vFound = false;
    jQPac.each(variantImagesAddedToSlider, function( index ) {
        if(imageForSlider.indexOf(this) != -1) {
            vFound = true;
        }
    });
    return vFound;
    //variantImagesAddedToSlider
     //(Object.values(variantImagesAddedToSlider).indexOf(imageForSlider) != -1)
}

function createImages(srcs, fn) {
   var imgs = [], img;
   var remaining = srcs.length;
   for (var i = 0; i < srcs.length; i++) {
       img = new Image();
       imgs.push(img);
       img.onload = function() {
           --remaining;
           if (remaining == 0) {
               fn(srcs);
           }
       };
       img.src = srcs[i];
   }
   return(imgs);
}


function getImageSize(images, callback) {


productimages = images;

    jQPac.each(imageDimensionsWidth, function( index ) {
    	var scaledWidth = this;
	var scaledHeight = imageDimensionsHeight[index];
	if(this > imgWidth) {
	    scaledWidth = imgWidth;
	    scaledHeight = parseInt(imageDimensionsHeight[index] * (scaledWidth / this));
	}

	if(scaledHeight > forcemaxHeightOfAllMedia) {
	//console.debug("FORCE");
	scaledHeight = forcemaxHeightOfAllMedia;
	scaledWidth = parseInt(this * (forcemaxHeightOfAllMedia / imageDimensionsHeight[index]));
	//console.debug(scaledWidth);
	}

	w = scaledWidth;
	h = scaledHeight;


imageDimensionsWidth2[index] = scaledWidth;
imageDimensionsHeight2[index] = scaledHeight;


                    var widthX = topMediaParent.width();
                    if(widthX < 200) {
                        widthX = 350;
                    }
                    if((w - 5) > widthX) {
                        //h = parseInt((widthX / w) * h);
                    }

		    if(parseInt(h) > parseInt(maxHeightOfAllMedia)) {
                        maxHeightOfAllMedia = h;
                    }

    });

                for (var i = 1; i <= productimages.length; i++) {
                    jQPac("#gs-image-" + i).hide();
                }

                jQPac("html").css("opacity", '1');
                jQPac("html").css("background-color", backgroundColor);
                callback.apply(this, [w, h]);


return;


    waitlimit = 100;
    jQPac(topMediaParent).append('<div id="forcesection">&nbsp;</div>');
    productimages = images;
    var wait = setInterval(function() {
        try {
            var isAllValid = true;
            waitlimit = waitlimit - 30;
            if(waitlimit < 0) {
                waitlimit = 9999;
		jQPac("html").css("opacity", '1');
                jQPac("html").css("background-color", backgroundColor);
            }

            if(productimages.length == 0) {
                jQPac("html").css("opacity", '1');
                jQPac("html").css("background-color", backgroundColor);
            }

            for (var i = 1; i <= productimages.length; i++) {
                var imageObject = jQPac("#gs-image-" + i);
                if(imageObject.length <= 0) {
                    return false;
                }
                var w = imageObject[0].width;
                var h = imageObject[0].height;
                if (w && h) {
                    var widthX = topMediaParent.width();
                    if(widthX < 200) {
                        widthX = 350;
                    }
                    if((w - 5) > widthX) {
                        h = (widthX / w) * h;
                    }

		    if(parseInt(h) > parseInt(maxHeightOfAllMedia)) {
                        maxHeightOfAllMedia = h;
		    }
                }
                else {
                    isAllValid = false;
                }
            }

            if(isAllValid) {
                for (var i = 1; i <= productimages.length; i++) {
                    jQPac("#gs-image-" + i).hide();
                }

                clearInterval(wait);
	        jQPac("#forcesection").remove();
                jQPac("html").css("opacity", '1');
                jQPac("html").css("background-color", backgroundColor);
                callback.apply(this, [w, h]);

if(window.location.href.indexOf("atlasbling.com") > 0) {
jQPac("#productSelect-option-0").change(function() {
        var dotPos2 = variantImagesByVarianName[jQPac( this ).val()].lastIndexOf(".");
        var ext2 = variantImagesByVarianName[jQPac( this ).val()].substr(0, dotPos2);
if(!jQPac(jQPac("#rondellCarousel").find("img[src*='" + ext2 + "']").get(0)).parent().parent().hasClass("rondell-item-focused")) {
        jQPac("#rondellCarousel").find("img[src*='" + ext2 + "']").trigger("click");
}
});
}

            }
        }
        catch(err) {
            jQPac("html").css("opacity", '1');
            jQPac("html").css("background-color", backgroundColor);
        }


    }, 30);
}

var waitForFinalEvent = (function () {
  var timers = {};
  return function (callback, ms, uniqueId) {
    if (!uniqueId) {
      uniqueId = "Don't call this twice without a uniqueId";
    }
    if (timers[uniqueId]) {
      clearTimeout (timers[uniqueId]);
    }
    timers[uniqueId] = setTimeout(callback, ms);
  };
})();

var maina = function(){

try {
if (typeof jQuery.cookie !== "function") { 
    jQuery.cookie = function(firstImageElement, buttonsGS){};
}
} catch(err) {
	try {
	jQuery.cookie = function(firstImageElement, buttonsGS){};
	} catch(err) { }
}

	setTimeout(function() {
try {

if(jQPac('.zoomContainer .zoomLens').length > 0) {
jQPac("body").append("<style> .zoomContainer { display: none !important; } ");
}

if (typeof jQuery.cookie !== "function") {
    jQuery.cookie = function(firstImageElement, buttonsGS){};
}
} catch(err) {
        try {
        jQuery.cookie = function(firstImageElement, buttonsGS){};
        } catch(err) { }
}
	}, 1000);


        setTimeout(function() {
try {
if (typeof jQuery.cookie !== "function") {
    jQuery.cookie = function(firstImageElement, buttonsGS){};
}
} catch(err) {
        try {
        jQuery.cookie = function(firstImageElement, buttonsGS){};
        } catch(err) { }
}
        }, 2000);

        setTimeout(function() {
try {
if (typeof jQuery.cookie !== "function") {
    jQuery.cookie = function(firstImageElement, buttonsGS){};
}
} catch(err) {
        try {
        jQuery.cookie = function(firstImageElement, buttonsGS){};
        } catch(err) { }
}
        }, 5000);

if(Modernizr.touch  ||  /Android|webOS|iPhone|iPiad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {

	if(navinleft) {
	if(thumbSizeX > 90) {
		thumbSizeX = 90;
	}
	}

zoomOnHover = false;
}

try {

jQPac("body").append("<style> .zoomContainer .zoomLens { display: none !important; } .product-area .showcase .container.wide { display: none !important; } #rondellCarousel .lazyload, #rondellCarousel .lazyloading, #rondellCarousel img:not(.lazyloaded) { opacity: 1; } .gravizoomImg { background: #fff; }  .gravizoomImg { display: none !important; } .rondell-item-focused .gravizoomImg { display: block !important;  } .product__subimage-list { max-height: 0px; } </style>");

	if((productImagesGSUrls.length == 1) && (presentationType == 1)) {
		presentationType = 3;
	}

if(jQPac("#mobileNavBar").length > 0) {
jQPac("body").append("<style> #mobileNavBar { z-index: 9999998 !important; } .lg-toolbar { z-index: 9999999; } </style>");
}
} catch(err) {}

    try {
if(window.location.href.indexOf("halodreamhair.com") > 0) {
jQPac(".product-edit-outer").remove();
}
    var currentUrl = jQPac(location).attr('href');
    var isProductPage = false;
    photoThumbTheme = jQPac( ".product-photo-thumb" ).length;

if(jQPac( ".thumb_item" ).length > 0) {
photoThumbTheme = 3;
}

   if(currentUrl.indexOf("/products") > 0) {
        isProductPage = true;
    }

    if(!isProductPage) {
        jQPac("html").css("opacity", '1');
        jQPac("html").css("background-color", backgroundColor);
    }
    else {

        if(typeof imagesByVariants != "undefined") {
            variantImagesAddedToSlider = [];
            //defaultVariant
            var variantIdX = '9999XX';
            if(window.location.href.indexOf("variant=") > 0) {
                var urlSplitX = window.location.href.split("variant=");
                variantIdX = urlSplitX[1];
			if(variantIdX.indexOf("#") > 0) {
				var urlSplitSec = variantIdX.split("#");
				variantIdX = urlSplitSec[0];
			}			


            }
            else {
               variantIdX = defaultVariant;
			   try {
				   variantIdX = gsSliderDefaultV;
			   } catch(err) {}	
            }
            if(imagesByVariants.hasOwnProperty(variantIdX)) {
                variantImagesAddedToSlider = imagesByVariants[variantIdX];
            }
        }

	if((window.location.href.indexOf("dee-trade") >= 0) || (window.location.href.indexOf("kss-accessories") >= 0) || (window.location.href.indexOf("bloombash") >= 0) || (window.location.href.indexOf("kpbrands") >= 0)  || (window.location.href.indexOf("4jexpress") >= 0) || (window.location.href.indexOf("outdoorsrockingchair") >= 0) || (window.location.href.indexOf("reflex-bargain") >= 0) || (window.location.href.indexOf("reflexbargain") >= 0)) {
	//jQPac(".lazyload").removeClass("lazyload");
	}
else {
	if(window.location.href.indexOf("products") >= 0) {
		//jQPac(".lazyload").removeClass("lazyload");
	}
}
        if(presentationType == 1) {
            setupslider(jQPac, 2);
		if(specialTheme == 3) {
		setTimeout(function() {

                if(allImagesAddedToSlider.length == 1 || variantImagesAddedToSlider.length == 1) {
                getImageSize(allImagesAddedToSlider, appendSlider);
                }
                else {
                getImageSize(allImagesAddedToSlider, appendGallery);
                }
                //getImageSize(allImagesAddedToSlider, appendGallery);
                jQPac( window ).resize(function() {
                waitForFinalEvent(function(){
                                        if(jQPac(".rondell-item-focused iframe").length == 0) {
                if(lastWidth != jQPac(window).width()) {
                        jQPac(".rondell-lightbox-close").each(function() {
                        jQPac(this).trigger("click");
                        });

                        jQPac("#rondellCarousel").remove();
                        lastWidth = jQPac(window).width();
                        appendGallery();
                }
                                }
                }, 500, "some unique string");
                });
                lastWidth = jQPac(window).width();
		
		}, 10);		

		}	
		else {
                if(allImagesAddedToSlider.length == 1 || variantImagesAddedToSlider.length == 1) {
                getImageSize(allImagesAddedToSlider, appendSlider);
                }
                else {
                getImageSize(allImagesAddedToSlider, appendGallery);
                }
		//getImageSize(allImagesAddedToSlider, appendGallery);
                jQPac( window ).resize(function() {
                waitForFinalEvent(function(){
					if(jQPac(".rondell-item-focused iframe").length == 0) {
		if(lastWidth != jQPac(window).width()) {
                        jQPac(".rondell-lightbox-close").each(function() {
                        jQPac(this).trigger("click");
                        });

			jQPac("#rondellCarousel").remove();
                        lastWidth = jQPac(window).width();
                        appendGallery();
                }
				}
		}, 500, "some unique string");
		});
		lastWidth = jQPac(window).width();
		}
	}
        else if(presentationType == 2) {
            if(setupslider(jQPac, 1)) {

		if(specialTheme == 3) {

setTimeout(function() {

                jQPac("html").css("background-color", backgroundColor);
                jQPac("html").css("opacity", '1');
                // exception for starting carousel
                if(allImagesAddedToSlider.length == 9999) {
                    //setupslider(jQPac, 2);
                    imgWidthF = topMediaParent.width();
                    allImagesAddedToSlider = [];
                    allImagesAddedToSliderOrg = [];
                    allImagesAddedToSlider.push(getLargeImgUrl(jQPac, lastImgSrc, imgWidthF, ''));
                                        allImagesAddedToSliderOrg.push(getLargeImgUrl(jQPac, lastImgSrc, 123123, 123123));
                    fullallImagesAddedToSlider.push(getLargeImgUrl(jQPac, lastImgSrc, fullScreenWidth, fullScreenHeight));
                    jQPac("#gs-image-" + allImagesAddedToSlider.length).remove();
                    jQPac("body").append( jQPac('<img id="gs-image-' + allImagesAddedToSlider.length + '" src="' + getLargeImgUrl(jQPac, lastImgSrc, imgWidthF, '') + '" >') );
                    getImageSize(allImagesAddedToSlider, appendSlider);
                    jQPac( window ).resize(function() {
                    waitForFinalEvent(function(){
                                if(jQPac(".rondell-item-focused iframe").length == 0) {
                if(lastWidth != jQPac(window).width()) {
                        jQPac(".rondell-lightbox-close").each(function() {
                        jQPac(this).trigger("click");
                        });


                        lastWidth = jQPac(window).width();
                        jQPac("#rondellCarousel").remove();
                        appendSlider();
                }
                }
                    }, 500, "some unique string");
                    });
                lastWidth = jQPac(window).width();
                }
                else {
                    getImageSize(allImagesAddedToSlider, appendCarousel);
                    jQPac( window ).resize(function() {
                    waitForFinalEvent(function(){
                                if(jQPac(".rondell-item-focused iframe").length == 0) {
                if(lastWidth != jQPac(window).width()) {
                        lastWidth = jQPac(window).width();
                        appendCarousel();
                }
                                }
                }, 500, "some unique string");
                    });
                   lastWidth = jQPac(window).width();
                 }


 }, 10);

		}
		else {

                jQPac("html").css("background-color", backgroundColor);
                jQPac("html").css("opacity", '1');
                // exception for starting carousel
                if(allImagesAddedToSlider.length == 9999) {
                    //setupslider(jQPac, 2);
                    imgWidthF = topMediaParent.width();
                    allImagesAddedToSlider = [];
		    allImagesAddedToSliderOrg = [];
                    allImagesAddedToSlider.push(getLargeImgUrl(jQPac, lastImgSrc, imgWidthF, ''));
					allImagesAddedToSliderOrg.push(getLargeImgUrl(jQPac, lastImgSrc, 123123, 123123));
                    fullallImagesAddedToSlider.push(getLargeImgUrl(jQPac, lastImgSrc, fullScreenWidth, fullScreenHeight));
                    jQPac("#gs-image-" + allImagesAddedToSlider.length).remove();
                    jQPac("body").append( jQPac('<img id="gs-image-' + allImagesAddedToSlider.length + '" src="' + getLargeImgUrl(jQPac, lastImgSrc, imgWidthF, '') + '" >') );
                    getImageSize(allImagesAddedToSlider, appendSlider);
                    jQPac( window ).resize(function() {
		    waitForFinalEvent(function(){
				if(jQPac(".rondell-item-focused iframe").length == 0) {
                if(lastWidth != jQPac(window).width()) {
                        jQPac(".rondell-lightbox-close").each(function() {
                        jQPac(this).trigger("click");
                        });


                        lastWidth = jQPac(window).width();
			jQPac("#rondellCarousel").remove();
                	appendSlider();
		}
		}
		    }, 500, "some unique string");
        	    });
		lastWidth = jQPac(window).width();
		}
                else {
                    getImageSize(allImagesAddedToSlider, appendCarousel);
                    jQPac( window ).resize(function() {
		    waitForFinalEvent(function(){
				if(jQPac(".rondell-item-focused iframe").length == 0) {
                if(lastWidth != jQPac(window).width()) {
                        lastWidth = jQPac(window).width();
                        appendCarousel();
                }
				}
		}, 500, "some unique string");
                    });
		   lastWidth = jQPac(window).width();
	   	 }


		}
            }
        }
        else if(presentationType == 3) {
            setupslider(jQPac, 2);

if(specialTheme == 3) {

setTimeout(function() {

            getImageSize(allImagesAddedToSlider, appendSlider);
            jQPac( window ).resize(function() {
                waitForFinalEvent(function(){
                        if(jQPac(".rondell-item-focused iframe").length == 0) {
                if(lastWidth != jQPac(window).width()) {
                        jQPac(".rondell-lightbox-close").each(function() {
                        jQPac(this).trigger("click");
                        });


                        jQPac("#rondellCarousel").remove();
                        lastWidth = jQPac(window).width();
                        appendSlider();
                }
                        }
            }, 500, "some unique string");
            });
           lastWidth = jQPac(window).width();


}, 10);

}
else {

            getImageSize(allImagesAddedToSlider, appendSlider);
            jQPac( window ).resize(function() {
		waitForFinalEvent(function(){
			if(jQPac(".rondell-item-focused iframe").length == 0) {
                if(lastWidth != jQPac(window).width()) {
                        jQPac(".rondell-lightbox-close").each(function() {
                        jQPac(this).trigger("click");
                        });


			jQPac("#rondellCarousel").remove();
                        lastWidth = jQPac(window).width();
                        appendSlider();
                }
			}
	    }, 500, "some unique string");
	    });
	   lastWidth = jQPac(window).width();
}
	}

if(presentationType > 0) {
window.isClicked = false;
jQPac(document).click(function() {
window.isClicked = true;
});

if(window.location.href.indexOf("tutexpress") > 0) {
currentPage = jQPac('#product-select').val();

setInterval(function()
{
    if (currentPage != jQPac('#product-select').val())
    {

        // page has changed, set new page as 'current'
        if(window.isClicked) {

        var variantId = jQPac('#product-select').val();
        if(currentPage.indexOf(variantId) == -1) {
        if((typeof variantImagesGS != "undefined") && variantId in variantImagesGS) {
        var dotPos2 = variantImagesGS[variantId].lastIndexOf(".");
        var ext2 = variantImagesGS[variantId].substr(0, dotPos2);

        var shortV = "";
jQPac("#rondellCarousel").find("img[src*='" + ext2 + "']").each(function(index) {
        if(shortV == "") {
          shortV =  jQPac(this).attr("src");
        }
        else {
        if(jQPac(this).attr("src").length < shortV.length) {
         shortV =  jQPac(this).attr("src");
        }
        }
});
ext2 = shortV;

        //if(!jQPac(jQPac("#rondellCarousel").find("img[src*='" + ext2 + "']").get(0)).parent().parent().hasClass("rondell-item-focused")) {
        if((!jQPac(jQPac("#rondellCarousel").find("img[src*='" + ext2 + "']").get(0)).parent().parent().hasClass("rondell-item-focused")) && (!jQPac(jQPac("#rondellCarousel").find("img[src*='" + ext2 + "']").get(0)).parent().hasClass("rondell-item-focused")))  {
        jQPac("#rondellCarousel").find("img[src*='" + ext2 + "']").trigger("click");
        }
//        jQPac("img[src*='" + ext2 + "']").trigger("click");

        }
   }
       }
        //var variantSubstr =
        currentPage = jQPac('#product-select').val();
        // do your thing...
    }
}, 500);

return;
}


currentPage = window.location.href;
//currentPage = currentPage.replace("#", "");

if(currentPage.indexOf("#") > 0) {
 var splitUrlK = currentPage.split("#");
  currentPage = splitUrlK[0];
}

lastSetVariantInField = jQPac('[name="id"]').val();
// listen for changes
setInterval(function()
{

try {
if(jQPac('[name="id"]').val().length > 0) {
if(lastSetVariantInField != jQPac('[name="id"]').val()) {
if((window.location.href.indexOf('variant=') == -1) || (window.location.href.indexOf(lastSetVariantInField) != -1 )) {
 if(window.location.href.indexOf(jQPac('[name="id"]').val()) === -1) { window.history.replaceState("", "", '?variant=' + jQPac('[name="id"]').val()); } 
 lastSetVariantInField = jQPac('[name="id"]').val();
}
}
}
} catch(err) {}


var nowPageUrl = window.location.href;
//nowPageUrl = nowPageUrl.replace("#", "");
if(nowPageUrl.indexOf("#") > 0) {
 var splitUrlK = nowPageUrl.split("#");
  nowPageUrl = splitUrlK[0];
}

    if (currentPage != nowPageUrl)
    {

		if(autorotate) {
			if(window.location.href.indexOf("variant=") > 0) {
			autorotate = false;
			window.rondelInst.autoRotation.paused = true;
			window.rondelInst.autoRotation.once = true;
			}
		}

        if(typeof imagesByVariants != "undefined") {
            variantImagesAddedToSlider = [];
	    if(window.location.href.indexOf("variant=") > 0) {
            var urlSplitX = window.location.href.split("variant=");
            var variantIdX = urlSplitX[1];
			if(variantIdX.indexOf("#") > 0) {
				var urlSplitSec = variantIdX.split("#");
				variantIdX = urlSplitSec[0];
			}			

            if(imagesByVariants.hasOwnProperty(variantIdX)) {
                variantImagesAddedToSlider = imagesByVariants[variantIdX];
            }
	    }

            // filter images NEW FUNCTION
            if(presentationType == 1) {
                if(variantImagesAddedToSlider.length == 1) {
                appendSlider();
                }
                else {
                appendGallery();
                }
            }
            else if(presentationType == 2) {
                appendCarousel();
            }
            else if(presentationType == 3) {
                appendSlider();
            }
        }

        if(typeof variantImagesGS != "undefined") {
            // page has changed, set new page as 'current'
            if(window.location.href.indexOf("variant=") > 0 && window.isClicked) {
            var urlSplit = window.location.href.split("variant=");
            var variantId = urlSplit[1];
			if(variantId.indexOf("#") > 0) {
				var urlSplitSec = variantId.split("#");
				variantId = urlSplitSec[0];
			}


            if(currentPage.indexOf(variantId) == -1) {
            if(variantId in variantImagesGS) {
            var dotPos2 = variantImagesGS[variantId].lastIndexOf(".");
            var ext2 = variantImagesGS[variantId].substr(0, dotPos2);

            var shortV = "";
    jQPac("#rondellCarousel").find("img[src*='" + ext2 + "']").each(function(index) {
            if(shortV == "") {
              shortV =  jQPac(this).attr("src");
            }
            else {
            if(jQPac(this).attr("src").length < shortV.length) {
             shortV =  jQPac(this).attr("src");
            }
            }
    });
    ext2 = shortV;

            //if(!jQPac(jQPac("#rondellCarousel").find("img[src*='" + ext2 + "']").get(0)).parent().parent().hasClass("rondell-item-focused")) {
            if((!jQPac(jQPac("#rondellCarousel").find("img[src*='" + ext2 + "']").get(0)).parent().parent().hasClass("rondell-item-focused")) && (!jQPac(jQPac("#rondellCarousel").find("img[src*='" + ext2 + "']").get(0)).parent().hasClass("rondell-item-focused")))  {
            jQPac("#rondellCarousel").find("img[src*='" + ext2 + "']").trigger("click");
            }
    //        jQPac("img[src*='" + ext2 + "']").trigger("click");

            }
            }
            }
        }
        //var variantSubstr =

currentPage = window.location.href;
//currentPage = currentPage.replace("#", "");

if(currentPage.indexOf("#") > 0) {
 var splitUrlK = currentPage.split("#");
  currentPage = splitUrlK[0];
}

        // do your thing...
    }
}, 500);

}

    }
if (window.DeviceOrientationEvent) {
    window.addEventListener('orientationchange', function() { jQPac("html").css("opacity", '0');  location.reload(); }, false);
}

    return;
}
catch(err) {
    jQPac("html").css("opacity", '1');
    jQPac("html").css("background-color", backgroundColor);
    console.log(err);
}
};
try {

if(window.location.href.indexOf("removethisurl") == -1) {




//reflex-bargain
//jQPac("html").css("opacity", '0');

try {
jQPac("html").append("<style> .gallery-wrap { opacity: 0 !important; } </style>");
}
catch(err) {
}

backgroundColor = jQPac("html").css("background-color");
jQPac("html").css("background-color", '#ffffff');
jQPac.ready.promise().done(function () {

	if(oncego) {
		return;
	}
	oncego = true;

	if(productImagesGS.length == 0) {

	jQPac("html").css("opacity", '1');
	return;
	}

if(window.location.href.indexOf("/products") > 0) {
if(jQPac("nav ul").size() > 0) {
if(jQPac("nav ul").css('z-index') == "auto" || jQPac("nav ul").css('z-index') < 500) {
//jQPac("nav ul").css('z-index', 500);
}
}

if(jQPac("header").size() > 0) {
if(jQPac("header").css('z-index') == "auto" || jQPac("header").css('z-index') < 500) {
//jQPac("header").css('z-index', 500);
}
}
}

    fullScreenWidth = jQPac(window).width();
    fullScreenHeight = jQPac(window).height();
    if(fullScreenWidth == 'undefined' || fullScreenWidth == null || fullScreenWidth == 0) {
        fullScreenWidth = 1024;
        fullScreenHeight = '';
    }
    else {
        fullScreenWidth = fullScreenWidth - 50;
    }
    lastWidth = fullScreenWidth;
    if(mobileOnlyMode) {
    if((Modernizr.touch && (jQPac(window).width() < 800)) ||  /Android|webOS|iPhone|iPiad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    maina();
    }
    else {
    jQPac("html").css("opacity", '1');
    jQPac("html").css("background-color", backgroundColor);
    }
    }
    else {
    maina();
    }

});
}
}
catch(err) {
    jQPac("html").css("opacity", '1');
    jQPac("html").css("background-color", backgroundColor);
    console.log(err);
}


